import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _int4: any;
  _target_ss_direct_inheritances_replacement: any;
  bigint: any;
  inet: any;
  jsonb: any;
  jsonpath: any;
  sortable_scope_option_tree_node: any;
  timestamptz: any;
  uuid: any;
};

export type AggregateValidatedSsInheritanceModifications = {
  __typename?: 'AggregateValidatedSsInheritanceModifications';
  deleteConflictingSsDirectInheritancesWhere: Array<DeleteConflictingSsDirectInheritanceWhere>;
  deleteSsDirectInheritancesWhere: Array<DeleteSsDirectInheritancesWhere>;
  insertSsDirectInheritances: Array<InsertSsDirectInheritance>;
  updateSsDirectInheritances: Array<UpdateSsDirectInheritance>;
};

/** Used by comparable_scope_definitions which groups these entries by scope_id. See comparable_scope_definitions for more details. */
export type AllComparableScopeDefiners = {
  __typename?: 'AllComparableScopeDefiners';
  isScopeOptionIdExplicitlySelected: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  scope: Maybe<Scopes>;
  scopeId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeOption: Maybe<ScopeOptions>;
  scopeOptionId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeVariable: ScopeVariables;
  scopeVariableId: Maybe<Scalars['Int']>;
  valueForContainableScopeDefinition: Maybe<Scalars['String']>;
  valueForSortableScopeDefinition: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "all_comparable_scope_definers" */
export type AllComparableScopeDefinersAggregate = {
  __typename?: 'AllComparableScopeDefinersAggregate';
  aggregate: Maybe<AllComparableScopeDefinersAggregateFields>;
  nodes: Array<AllComparableScopeDefiners>;
};

export type AllComparableScopeDefinersAggregateBoolExp = {
  bool_and?: InputMaybe<AllComparableScopeDefinersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AllComparableScopeDefinersAggregateBoolExpBoolOr>;
  count?: InputMaybe<AllComparableScopeDefinersAggregateBoolExpCount>;
};

/** aggregate fields of "all_comparable_scope_definers" */
export type AllComparableScopeDefinersAggregateFields = {
  __typename?: 'AllComparableScopeDefinersAggregateFields';
  avg: Maybe<AllComparableScopeDefinersAvgFields>;
  count: Scalars['Int'];
  max: Maybe<AllComparableScopeDefinersMaxFields>;
  min: Maybe<AllComparableScopeDefinersMinFields>;
  stddev: Maybe<AllComparableScopeDefinersStddevFields>;
  stddevPop: Maybe<AllComparableScopeDefinersStddevPopFields>;
  stddevSamp: Maybe<AllComparableScopeDefinersStddevSampFields>;
  sum: Maybe<AllComparableScopeDefinersSumFields>;
  varPop: Maybe<AllComparableScopeDefinersVarPopFields>;
  varSamp: Maybe<AllComparableScopeDefinersVarSampFields>;
  variance: Maybe<AllComparableScopeDefinersVarianceFields>;
};


/** aggregate fields of "all_comparable_scope_definers" */
export type AllComparableScopeDefinersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersAggregateOrderBy = {
  avg?: InputMaybe<AllComparableScopeDefinersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AllComparableScopeDefinersMaxOrderBy>;
  min?: InputMaybe<AllComparableScopeDefinersMinOrderBy>;
  stddev?: InputMaybe<AllComparableScopeDefinersStddevOrderBy>;
  stddevPop?: InputMaybe<AllComparableScopeDefinersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AllComparableScopeDefinersStddevSampOrderBy>;
  sum?: InputMaybe<AllComparableScopeDefinersSumOrderBy>;
  varPop?: InputMaybe<AllComparableScopeDefinersVarPopOrderBy>;
  varSamp?: InputMaybe<AllComparableScopeDefinersVarSampOrderBy>;
  variance?: InputMaybe<AllComparableScopeDefinersVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AllComparableScopeDefinersAvgFields = {
  __typename?: 'AllComparableScopeDefinersAvgFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersAvgOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "all_comparable_scope_definers". All fields are combined with a logical 'AND'. */
export type AllComparableScopeDefinersBoolExp = {
  _and?: InputMaybe<Array<AllComparableScopeDefinersBoolExp>>;
  _not?: InputMaybe<AllComparableScopeDefinersBoolExp>;
  _or?: InputMaybe<Array<AllComparableScopeDefinersBoolExp>>;
  isScopeOptionIdExplicitlySelected?: InputMaybe<BooleanComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionId?: InputMaybe<IntComparisonExp>;
  scopeVariable?: InputMaybe<ScopeVariablesBoolExp>;
  scopeVariableId?: InputMaybe<IntComparisonExp>;
  valueForContainableScopeDefinition?: InputMaybe<StringComparisonExp>;
  valueForSortableScopeDefinition?: InputMaybe<BooleanComparisonExp>;
};

/** aggregate max on columns */
export type AllComparableScopeDefinersMaxFields = {
  __typename?: 'AllComparableScopeDefinersMaxFields';
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
  valueForContainableScopeDefinition: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersMaxOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  valueForContainableScopeDefinition?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AllComparableScopeDefinersMinFields = {
  __typename?: 'AllComparableScopeDefinersMinFields';
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
  valueForContainableScopeDefinition: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersMinOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  valueForContainableScopeDefinition?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "all_comparable_scope_definers". */
export type AllComparableScopeDefinersOrderBy = {
  isScopeOptionIdExplicitlySelected?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariable?: InputMaybe<ScopeVariablesOrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  valueForContainableScopeDefinition?: InputMaybe<OrderBy>;
  valueForSortableScopeDefinition?: InputMaybe<OrderBy>;
};

/** select columns of table "all_comparable_scope_definers" */
export enum AllComparableScopeDefinersSelectColumn {
  /** column name */
  IsScopeOptionIdExplicitlySelected = 'isScopeOptionIdExplicitlySelected',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeOptionId = 'scopeOptionId',
  /** column name */
  ScopeVariableId = 'scopeVariableId',
  /** column name */
  ValueForContainableScopeDefinition = 'valueForContainableScopeDefinition',
  /** column name */
  ValueForSortableScopeDefinition = 'valueForSortableScopeDefinition'
}

/** select "allComparableScopeDefinersAggregateBoolExpBool_andArgumentsColumns" columns of table "all_comparable_scope_definers" */
export enum AllComparableScopeDefinersSelectColumnAllComparableScopeDefinersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsScopeOptionIdExplicitlySelected = 'isScopeOptionIdExplicitlySelected',
  /** column name */
  ValueForSortableScopeDefinition = 'valueForSortableScopeDefinition'
}

/** select "allComparableScopeDefinersAggregateBoolExpBool_orArgumentsColumns" columns of table "all_comparable_scope_definers" */
export enum AllComparableScopeDefinersSelectColumnAllComparableScopeDefinersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsScopeOptionIdExplicitlySelected = 'isScopeOptionIdExplicitlySelected',
  /** column name */
  ValueForSortableScopeDefinition = 'valueForSortableScopeDefinition'
}

/** aggregate stddev on columns */
export type AllComparableScopeDefinersStddevFields = {
  __typename?: 'AllComparableScopeDefinersStddevFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersStddevOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type AllComparableScopeDefinersStddevPopFields = {
  __typename?: 'AllComparableScopeDefinersStddevPopFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersStddevPopOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type AllComparableScopeDefinersStddevSampFields = {
  __typename?: 'AllComparableScopeDefinersStddevSampFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersStddevSampOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllComparableScopeDefinersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllComparableScopeDefinersStreamCursorValueInput = {
  isScopeOptionIdExplicitlySelected?: InputMaybe<Scalars['Boolean']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
  valueForContainableScopeDefinition?: InputMaybe<Scalars['String']>;
  valueForSortableScopeDefinition?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type AllComparableScopeDefinersSumFields = {
  __typename?: 'AllComparableScopeDefinersSumFields';
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersSumOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type AllComparableScopeDefinersVarPopFields = {
  __typename?: 'AllComparableScopeDefinersVarPopFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersVarPopOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type AllComparableScopeDefinersVarSampFields = {
  __typename?: 'AllComparableScopeDefinersVarSampFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersVarSampOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AllComparableScopeDefinersVarianceFields = {
  __typename?: 'AllComparableScopeDefinersVarianceFields';
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "all_comparable_scope_definers" */
export type AllComparableScopeDefinersVarianceOrderBy = {
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** This view has three uses: (1) To sort scopes: Order your scopes by the sortable_scope_definition column. This sort takes into consideration the scope variable ordinals, as well as the scope option ordinals. (2) To determine the inheritable scopes of a provided scope definition: Use the contains operator ('<@') on the containable_scope_options column. This operator helps identify which scopes are inheritable by your provided scope definition. To provide a scope definition, provide an array that includes the desired scope variable ID and scope option ID pairs (including transitive scope options, which are required) along with any desired '#-*' strings (which represent the 'All' option of scope variables where # represents the scope variable id). For example, you can use this query to determine the inheritable scopes of a scope definition that is identified by scope option ids 1, 2, 7, and the 'All' option of scope variable id 8: SELECT * FROM comparable_scope_definitions WHERE array['3-1', '4-2', '8-7','8-*']::text[] <@ containable_scope_definition, assuming that scope option id 1 has a scope var of 3, scope option id 2 has a scope var of 4, scope option id 7 is the only scope option in scope variable id 8, and none of these scope options have any descendant scope options. This is actually how the scope_inheritabilities view is generated. You could just get the strings like '8-7' or '8-*' from the comparable_scope_definers.value_for_containable_scope_definition field itself to make things easier. (3) To find a scope given a set of scope option ids, like so: SELECT * FROM comparable_scope_definitions WHERE to_jsonb(array[7]::integer[]) <@ scope_identifying_definition_jsonb AND to_jsonb(array[7]::integer[]) @> scope_identifying_definition_jsonb. The passed in scope option ids must be integers only and must not include any descendant scope option ids (so explicitly selected scope option ids only). So there's no need to account for the 'All' option, just pass in the scope_option_ids according to the scope_definers table. */
export type AllComparableScopeDefinitions = {
  __typename?: 'AllComparableScopeDefinitions';
  containableScopeDefinition: Maybe<Array<Scalars['String']>>;
  containableScopeDefinitionJsonb: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  scope: Scopes;
  scopeId: Maybe<Scalars['Int']>;
  scopeIdentifyingDefinitionJsonb: Maybe<Scalars['jsonb']>;
  scopeOptionIds: Maybe<Array<Scalars['Int']>>;
  scopeVariableIds: Maybe<Array<Scalars['Int']>>;
  sortableScopeDefinition: Maybe<Array<Scalars['Boolean']>>;
};


/** This view has three uses: (1) To sort scopes: Order your scopes by the sortable_scope_definition column. This sort takes into consideration the scope variable ordinals, as well as the scope option ordinals. (2) To determine the inheritable scopes of a provided scope definition: Use the contains operator ('<@') on the containable_scope_options column. This operator helps identify which scopes are inheritable by your provided scope definition. To provide a scope definition, provide an array that includes the desired scope variable ID and scope option ID pairs (including transitive scope options, which are required) along with any desired '#-*' strings (which represent the 'All' option of scope variables where # represents the scope variable id). For example, you can use this query to determine the inheritable scopes of a scope definition that is identified by scope option ids 1, 2, 7, and the 'All' option of scope variable id 8: SELECT * FROM comparable_scope_definitions WHERE array['3-1', '4-2', '8-7','8-*']::text[] <@ containable_scope_definition, assuming that scope option id 1 has a scope var of 3, scope option id 2 has a scope var of 4, scope option id 7 is the only scope option in scope variable id 8, and none of these scope options have any descendant scope options. This is actually how the scope_inheritabilities view is generated. You could just get the strings like '8-7' or '8-*' from the comparable_scope_definers.value_for_containable_scope_definition field itself to make things easier. (3) To find a scope given a set of scope option ids, like so: SELECT * FROM comparable_scope_definitions WHERE to_jsonb(array[7]::integer[]) <@ scope_identifying_definition_jsonb AND to_jsonb(array[7]::integer[]) @> scope_identifying_definition_jsonb. The passed in scope option ids must be integers only and must not include any descendant scope option ids (so explicitly selected scope option ids only). So there's no need to account for the 'All' option, just pass in the scope_option_ids according to the scope_definers table. */
export type AllComparableScopeDefinitionsContainableScopeDefinitionJsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This view has three uses: (1) To sort scopes: Order your scopes by the sortable_scope_definition column. This sort takes into consideration the scope variable ordinals, as well as the scope option ordinals. (2) To determine the inheritable scopes of a provided scope definition: Use the contains operator ('<@') on the containable_scope_options column. This operator helps identify which scopes are inheritable by your provided scope definition. To provide a scope definition, provide an array that includes the desired scope variable ID and scope option ID pairs (including transitive scope options, which are required) along with any desired '#-*' strings (which represent the 'All' option of scope variables where # represents the scope variable id). For example, you can use this query to determine the inheritable scopes of a scope definition that is identified by scope option ids 1, 2, 7, and the 'All' option of scope variable id 8: SELECT * FROM comparable_scope_definitions WHERE array['3-1', '4-2', '8-7','8-*']::text[] <@ containable_scope_definition, assuming that scope option id 1 has a scope var of 3, scope option id 2 has a scope var of 4, scope option id 7 is the only scope option in scope variable id 8, and none of these scope options have any descendant scope options. This is actually how the scope_inheritabilities view is generated. You could just get the strings like '8-7' or '8-*' from the comparable_scope_definers.value_for_containable_scope_definition field itself to make things easier. (3) To find a scope given a set of scope option ids, like so: SELECT * FROM comparable_scope_definitions WHERE to_jsonb(array[7]::integer[]) <@ scope_identifying_definition_jsonb AND to_jsonb(array[7]::integer[]) @> scope_identifying_definition_jsonb. The passed in scope option ids must be integers only and must not include any descendant scope option ids (so explicitly selected scope option ids only). So there's no need to account for the 'All' option, just pass in the scope_option_ids according to the scope_definers table. */
export type AllComparableScopeDefinitionsScopeIdentifyingDefinitionJsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "all_comparable_scope_definitions". All fields are combined with a logical 'AND'. */
export type AllComparableScopeDefinitionsBoolExp = {
  _and?: InputMaybe<Array<AllComparableScopeDefinitionsBoolExp>>;
  _not?: InputMaybe<AllComparableScopeDefinitionsBoolExp>;
  _or?: InputMaybe<Array<AllComparableScopeDefinitionsBoolExp>>;
  containableScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  containableScopeDefinitionJsonb?: InputMaybe<JsonbComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<JsonbComparisonExp>;
  scopeOptionIds?: InputMaybe<IntArrayComparisonExp>;
  scopeVariableIds?: InputMaybe<IntArrayComparisonExp>;
  sortableScopeDefinition?: InputMaybe<BooleanArrayComparisonExp>;
};

/** Ordering options when selecting data from "all_comparable_scope_definitions". */
export type AllComparableScopeDefinitionsOrderBy = {
  containableScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinitionJsonb?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<OrderBy>;
  scopeOptionIds?: InputMaybe<OrderBy>;
  scopeVariableIds?: InputMaybe<OrderBy>;
  sortableScopeDefinition?: InputMaybe<OrderBy>;
};

/** select columns of table "all_comparable_scope_definitions" */
export enum AllComparableScopeDefinitionsSelectColumn {
  /** column name */
  ContainableScopeDefinition = 'containableScopeDefinition',
  /** column name */
  ContainableScopeDefinitionJsonb = 'containableScopeDefinitionJsonb',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeIdentifyingDefinitionJsonb = 'scopeIdentifyingDefinitionJsonb',
  /** column name */
  ScopeOptionIds = 'scopeOptionIds',
  /** column name */
  ScopeVariableIds = 'scopeVariableIds',
  /** column name */
  SortableScopeDefinition = 'sortableScopeDefinition'
}

/** Streaming cursor of the table "all_comparable_scope_definitions" */
export type AllComparableScopeDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllComparableScopeDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllComparableScopeDefinitionsStreamCursorValueInput = {
  containableScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  containableScopeDefinitionJsonb?: InputMaybe<Scalars['jsonb']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<Scalars['jsonb']>;
  scopeOptionIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeVariableIds?: InputMaybe<Array<Scalars['Int']>>;
  sortableScopeDefinition?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** This view is not designed for performance. It's just a view to see all configurations and so that configuration() RETURNS SETOF configurations. Use configuration(), json_configuration(), and json_configurations() instead for performance. */
export type AllConfigurations = {
  __typename?: 'AllConfigurations';
  jsonConfiguration: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  scopeSnapshot: Maybe<ScopeSnapshots>;
  scopeSnapshotId: Maybe<Scalars['Int']>;
};


/** This view is not designed for performance. It's just a view to see all configurations and so that configuration() RETURNS SETOF configurations. Use configuration(), json_configuration(), and json_configurations() instead for performance. */
export type AllConfigurationsJsonConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "all_configurations". All fields are combined with a logical 'AND'. */
export type AllConfigurationsBoolExp = {
  _and?: InputMaybe<Array<AllConfigurationsBoolExp>>;
  _not?: InputMaybe<AllConfigurationsBoolExp>;
  _or?: InputMaybe<Array<AllConfigurationsBoolExp>>;
  jsonConfiguration?: InputMaybe<JsonbComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "all_configurations". */
export type AllConfigurationsOrderBy = {
  jsonConfiguration?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** select columns of table "all_configurations" */
export enum AllConfigurationsSelectColumn {
  /** column name */
  JsonConfiguration = 'jsonConfiguration',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId'
}

/** Streaming cursor of the table "all_configurations" */
export type AllConfigurationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllConfigurationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllConfigurationsStreamCursorValueInput = {
  jsonConfiguration?: InputMaybe<Scalars['jsonb']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

export type AllInheritedFlagNodes = {
  __typename?: 'AllInheritedFlagNodes';
  flagNode: FlagNodes;
  id: Scalars['Int'];
};

export type AllInheritedValuedFlagNodes = {
  __typename?: 'AllInheritedValuedFlagNodes';
  flagNode: FlagNodes;
  id: Scalars['Int'];
};

/** Returns all reflexive transitive scope option tree edges implied by the direct edges in scope_option_tree_edges. Each row represents a scope option's reachability to itself or a descendant through zero or more direct edges. IMPORTANT: Results are path-based. (scope_option_id, descendant_scope_option_id) pairs are NOT guaranteed to be unique because multiple paths may exist between the same scope options. This is intentional: direct edges are user-authored topology, so a direct path and one or more longer paths between the same ancestor and descendant may coexist. id uniquely identifies the traversal path represented by the row and is derived from descendant_chain. ALWAYS use DISTINCT when unique ancestor-descendant pairs are expected, especially when constructing values where uniqueness is required, such as the validatable scope containments array. is_canonical_root_path indicates whether the path begins at a root scope option. Root-originating paths are the canonical paths used when constructing the non-duplicated scope option tree. Rows whose paths begin at a non-root scope option remain valid transitive relationships but represent subpaths already included by a root-originating path. */
export type AllScopeOptionTreeEdgeTransitives = {
  __typename?: 'AllScopeOptionTreeEdgeTransitives';
  descendantChain: Array<Scalars['Int']>;
  /** An object relationship */
  descendantScopeOption: ScopeOptions;
  descendantScopeOptionId: Scalars['Int'];
  id: Scalars['String'];
  isCanonicalRootPath: Scalars['Boolean'];
  /** An object relationship */
  scopeOption: ScopeOptions;
  scopeOptionId: Scalars['Int'];
  /** An object relationship */
  scopeOptionTreeEdge: Maybe<ScopeOptionTreeEdges>;
  scopeOptionTreeEdgeId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeVariable: Maybe<ScopeVariables>;
  scopeVariableId: Scalars['Int'];
  /** An array relationship */
  sortableScopeOptionTreeNodes: Array<AllSortableScopeOptionTreeNodes>;
  sortableTreeChain: Maybe<Array<Scalars['sortable_scope_option_tree_node']>>;
};


/** Returns all reflexive transitive scope option tree edges implied by the direct edges in scope_option_tree_edges. Each row represents a scope option's reachability to itself or a descendant through zero or more direct edges. IMPORTANT: Results are path-based. (scope_option_id, descendant_scope_option_id) pairs are NOT guaranteed to be unique because multiple paths may exist between the same scope options. This is intentional: direct edges are user-authored topology, so a direct path and one or more longer paths between the same ancestor and descendant may coexist. id uniquely identifies the traversal path represented by the row and is derived from descendant_chain. ALWAYS use DISTINCT when unique ancestor-descendant pairs are expected, especially when constructing values where uniqueness is required, such as the validatable scope containments array. is_canonical_root_path indicates whether the path begins at a root scope option. Root-originating paths are the canonical paths used when constructing the non-duplicated scope option tree. Rows whose paths begin at a non-root scope option remain valid transitive relationships but represent subpaths already included by a root-originating path. */
export type AllScopeOptionTreeEdgeTransitivesSortableScopeOptionTreeNodesArgs = {
  distinctOn?: InputMaybe<Array<AllSortableScopeOptionTreeNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSortableScopeOptionTreeNodesOrderBy>>;
  where?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
};

/** order by aggregate values of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesAggregateOrderBy = {
  avg?: InputMaybe<AllScopeOptionTreeEdgeTransitivesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AllScopeOptionTreeEdgeTransitivesMaxOrderBy>;
  min?: InputMaybe<AllScopeOptionTreeEdgeTransitivesMinOrderBy>;
  stddev?: InputMaybe<AllScopeOptionTreeEdgeTransitivesStddevOrderBy>;
  stddevPop?: InputMaybe<AllScopeOptionTreeEdgeTransitivesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AllScopeOptionTreeEdgeTransitivesStddevSampOrderBy>;
  sum?: InputMaybe<AllScopeOptionTreeEdgeTransitivesSumOrderBy>;
  varPop?: InputMaybe<AllScopeOptionTreeEdgeTransitivesVarPopOrderBy>;
  varSamp?: InputMaybe<AllScopeOptionTreeEdgeTransitivesVarSampOrderBy>;
  variance?: InputMaybe<AllScopeOptionTreeEdgeTransitivesVarianceOrderBy>;
};

/** order by avg() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesAvgOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "all_scope_option_tree_edge_transitives". All fields are combined with a logical 'AND'. */
export type AllScopeOptionTreeEdgeTransitivesBoolExp = {
  _and?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesBoolExp>>;
  _not?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
  _or?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesBoolExp>>;
  descendantChain?: InputMaybe<IntArrayComparisonExp>;
  descendantScopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  descendantScopeOptionId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  isCanonicalRootPath?: InputMaybe<BooleanComparisonExp>;
  scopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionId?: InputMaybe<IntComparisonExp>;
  scopeOptionTreeEdge?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
  scopeOptionTreeEdgeId?: InputMaybe<IntComparisonExp>;
  scopeVariable?: InputMaybe<ScopeVariablesBoolExp>;
  scopeVariableId?: InputMaybe<IntComparisonExp>;
  sortableScopeOptionTreeNodes?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
  sortableTreeChain?: InputMaybe<SortableScopeOptionTreeNodeArrayComparisonExp>;
};

/** order by max() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesMaxOrderBy = {
  descendantChain?: InputMaybe<OrderBy>;
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  sortableTreeChain?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesMinOrderBy = {
  descendantChain?: InputMaybe<OrderBy>;
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  sortableTreeChain?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "all_scope_option_tree_edge_transitives". */
export type AllScopeOptionTreeEdgeTransitivesOrderBy = {
  descendantChain?: InputMaybe<OrderBy>;
  descendantScopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isCanonicalRootPath?: InputMaybe<OrderBy>;
  scopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdge?: InputMaybe<ScopeOptionTreeEdgesOrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariable?: InputMaybe<ScopeVariablesOrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  sortableScopeOptionTreeNodesAggregate?: InputMaybe<AllSortableScopeOptionTreeNodesAggregateOrderBy>;
  sortableTreeChain?: InputMaybe<OrderBy>;
};

/** select columns of table "all_scope_option_tree_edge_transitives" */
export enum AllScopeOptionTreeEdgeTransitivesSelectColumn {
  /** column name */
  DescendantChain = 'descendantChain',
  /** column name */
  DescendantScopeOptionId = 'descendantScopeOptionId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCanonicalRootPath = 'isCanonicalRootPath',
  /** column name */
  ScopeOptionId = 'scopeOptionId',
  /** column name */
  ScopeOptionTreeEdgeId = 'scopeOptionTreeEdgeId',
  /** column name */
  ScopeVariableId = 'scopeVariableId',
  /** column name */
  SortableTreeChain = 'sortableTreeChain'
}

/** order by stddev() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesStddevOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesStddevPopOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesStddevSampOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllScopeOptionTreeEdgeTransitivesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllScopeOptionTreeEdgeTransitivesStreamCursorValueInput = {
  descendantChain?: InputMaybe<Array<Scalars['Int']>>;
  descendantScopeOptionId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  isCanonicalRootPath?: InputMaybe<Scalars['Boolean']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  scopeOptionTreeEdgeId?: InputMaybe<Scalars['Int']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
  sortableTreeChain?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
};

/** order by sum() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesSumOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesVarPopOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesVarSampOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "all_scope_option_tree_edge_transitives" */
export type AllScopeOptionTreeEdgeTransitivesVarianceOrderBy = {
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeId?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Expands each sortable_tree_chain from all_scope_option_tree_edge_transitives into one typed row per sortable scope option tree node. sortable_tree_chain_ordinal identifies the node's position within the chain, while the remaining columns expose the sortable_scope_option_tree_node composite attributes as regular typed columns for consumers such as Hasura and application code. */
export type AllSortableScopeOptionTreeNodes = {
  __typename?: 'AllSortableScopeOptionTreeNodes';
  id: Maybe<Scalars['String']>;
  ordinalWithinParent: Maybe<Scalars['Int']>;
  ordinalWithinParentIsNull: Scalars['Boolean'];
  /** An object relationship */
  scopeOptionTreeEdgeTransitive: AllScopeOptionTreeEdgeTransitives;
  scopeOptionTreeEdgeTransitiveId: Maybe<Scalars['String']>;
  soId: Scalars['Int'];
  soValue: Scalars['String'];
  sortableTreeChainOrdinal: Scalars['Int'];
  svOrdinal: Scalars['Int'];
};

/** order by aggregate values of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesAggregateOrderBy = {
  avg?: InputMaybe<AllSortableScopeOptionTreeNodesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AllSortableScopeOptionTreeNodesMaxOrderBy>;
  min?: InputMaybe<AllSortableScopeOptionTreeNodesMinOrderBy>;
  stddev?: InputMaybe<AllSortableScopeOptionTreeNodesStddevOrderBy>;
  stddevPop?: InputMaybe<AllSortableScopeOptionTreeNodesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AllSortableScopeOptionTreeNodesStddevSampOrderBy>;
  sum?: InputMaybe<AllSortableScopeOptionTreeNodesSumOrderBy>;
  varPop?: InputMaybe<AllSortableScopeOptionTreeNodesVarPopOrderBy>;
  varSamp?: InputMaybe<AllSortableScopeOptionTreeNodesVarSampOrderBy>;
  variance?: InputMaybe<AllSortableScopeOptionTreeNodesVarianceOrderBy>;
};

/** order by avg() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesAvgOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "all_sortable_scope_option_tree_nodes". All fields are combined with a logical 'AND'. */
export type AllSortableScopeOptionTreeNodesBoolExp = {
  _and?: InputMaybe<Array<AllSortableScopeOptionTreeNodesBoolExp>>;
  _not?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
  _or?: InputMaybe<Array<AllSortableScopeOptionTreeNodesBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  ordinalWithinParent?: InputMaybe<IntComparisonExp>;
  ordinalWithinParentIsNull?: InputMaybe<BooleanComparisonExp>;
  scopeOptionTreeEdgeTransitive?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
  scopeOptionTreeEdgeTransitiveId?: InputMaybe<StringComparisonExp>;
  soId?: InputMaybe<IntComparisonExp>;
  soValue?: InputMaybe<StringComparisonExp>;
  sortableTreeChainOrdinal?: InputMaybe<IntComparisonExp>;
  svOrdinal?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  ordinalWithinParent?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeTransitiveId?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  soValue?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  ordinalWithinParent?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeTransitiveId?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  soValue?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "all_sortable_scope_option_tree_nodes". */
export type AllSortableScopeOptionTreeNodesOrderBy = {
  id?: InputMaybe<OrderBy>;
  ordinalWithinParent?: InputMaybe<OrderBy>;
  ordinalWithinParentIsNull?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeTransitive?: InputMaybe<AllScopeOptionTreeEdgeTransitivesOrderBy>;
  scopeOptionTreeEdgeTransitiveId?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  soValue?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** select columns of table "all_sortable_scope_option_tree_nodes" */
export enum AllSortableScopeOptionTreeNodesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  OrdinalWithinParent = 'ordinalWithinParent',
  /** column name */
  OrdinalWithinParentIsNull = 'ordinalWithinParentIsNull',
  /** column name */
  ScopeOptionTreeEdgeTransitiveId = 'scopeOptionTreeEdgeTransitiveId',
  /** column name */
  SoId = 'soId',
  /** column name */
  SoValue = 'soValue',
  /** column name */
  SortableTreeChainOrdinal = 'sortableTreeChainOrdinal',
  /** column name */
  SvOrdinal = 'svOrdinal'
}

/** order by stddev() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesStddevOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesStddevPopOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesStddevSampOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllSortableScopeOptionTreeNodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllSortableScopeOptionTreeNodesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['String']>;
  ordinalWithinParent?: InputMaybe<Scalars['Int']>;
  ordinalWithinParentIsNull?: InputMaybe<Scalars['Boolean']>;
  scopeOptionTreeEdgeTransitiveId?: InputMaybe<Scalars['String']>;
  soId?: InputMaybe<Scalars['Int']>;
  soValue?: InputMaybe<Scalars['String']>;
  sortableTreeChainOrdinal?: InputMaybe<Scalars['Int']>;
  svOrdinal?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesSumOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesVarPopOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesVarSampOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "all_sortable_scope_option_tree_nodes" */
export type AllSortableScopeOptionTreeNodesVarianceOrderBy = {
  ordinalWithinParent?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  sortableTreeChainOrdinal?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** This view is used to validate all of the scope snapshot direct inheritances to ensure that every child scope snapshot is allowed to inherit from their parent scope snapshots, as defined by this predicate always being true: containable_scope_definition <@ containable_directly_inherited_scope_definition. In other words, the scope options of the child's scope should be contained by the scope options of the parent's scope. */
export type AllValidatableScopeContainments = {
  __typename?: 'AllValidatableScopeContainments';
  containableDirectlyInheritedScopeDefinition: Array<Scalars['String']>;
  containableScopeDefinition: Array<Scalars['String']>;
  directlyInheritedScopeId: Scalars['Int'];
  directlyInheritedScopeIdentifyingDefinition: Array<Scalars['Int']>;
  /** An object relationship */
  directlyInheritedScopeSnapshot: ScopeSnapshots;
  directlyInheritedScopeSnapshotId: Scalars['Int'];
  /** An object relationship */
  scope: Maybe<Scopes>;
  scopeId: Scalars['Int'];
  scopeIdentifyingDefinition: Array<Scalars['Int']>;
  /** An object relationship */
  scopeSnapshot: ScopeSnapshots;
  scopeSnapshotId: Scalars['Int'];
  ssDirectInheritanceOrdinal: Maybe<Scalars['Int']>;
};

/** order by aggregate values of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsAggregateOrderBy = {
  avg?: InputMaybe<AllValidatableScopeContainmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AllValidatableScopeContainmentsMaxOrderBy>;
  min?: InputMaybe<AllValidatableScopeContainmentsMinOrderBy>;
  stddev?: InputMaybe<AllValidatableScopeContainmentsStddevOrderBy>;
  stddevPop?: InputMaybe<AllValidatableScopeContainmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AllValidatableScopeContainmentsStddevSampOrderBy>;
  sum?: InputMaybe<AllValidatableScopeContainmentsSumOrderBy>;
  varPop?: InputMaybe<AllValidatableScopeContainmentsVarPopOrderBy>;
  varSamp?: InputMaybe<AllValidatableScopeContainmentsVarSampOrderBy>;
  variance?: InputMaybe<AllValidatableScopeContainmentsVarianceOrderBy>;
};

/** order by avg() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsAvgOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "all_validatable_scope_containments". All fields are combined with a logical 'AND'. */
export type AllValidatableScopeContainmentsBoolExp = {
  _and?: InputMaybe<Array<AllValidatableScopeContainmentsBoolExp>>;
  _not?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
  _or?: InputMaybe<Array<AllValidatableScopeContainmentsBoolExp>>;
  containableDirectlyInheritedScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  containableScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  directlyInheritedScopeId?: InputMaybe<IntComparisonExp>;
  directlyInheritedScopeIdentifyingDefinition?: InputMaybe<IntArrayComparisonExp>;
  directlyInheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  directlyInheritedScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeIdentifyingDefinition?: InputMaybe<IntArrayComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeSnapshotId?: InputMaybe<IntComparisonExp>;
  ssDirectInheritanceOrdinal?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsMaxOrderBy = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsMinOrderBy = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "all_validatable_scope_containments". */
export type AllValidatableScopeContainmentsOrderBy = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeIdentifyingDefinition?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** select columns of table "all_validatable_scope_containments" */
export enum AllValidatableScopeContainmentsSelectColumn {
  /** column name */
  ContainableDirectlyInheritedScopeDefinition = 'containableDirectlyInheritedScopeDefinition',
  /** column name */
  ContainableScopeDefinition = 'containableScopeDefinition',
  /** column name */
  DirectlyInheritedScopeId = 'directlyInheritedScopeId',
  /** column name */
  DirectlyInheritedScopeIdentifyingDefinition = 'directlyInheritedScopeIdentifyingDefinition',
  /** column name */
  DirectlyInheritedScopeSnapshotId = 'directlyInheritedScopeSnapshotId',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeIdentifyingDefinition = 'scopeIdentifyingDefinition',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId',
  /** column name */
  SsDirectInheritanceOrdinal = 'ssDirectInheritanceOrdinal'
}

/** order by stddev() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsStddevOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsStddevPopOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsStddevSampOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AllValidatableScopeContainmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllValidatableScopeContainmentsStreamCursorValueInput = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  containableScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeIdentifyingDefinition?: InputMaybe<Array<Scalars['Int']>>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeIdentifyingDefinition?: InputMaybe<Array<Scalars['Int']>>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
  ssDirectInheritanceOrdinal?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsSumOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsVarPopOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsVarSampOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "all_validatable_scope_containments" */
export type AllValidatableScopeContainmentsVarianceOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
  ssDirectInheritanceOrdinal?: InputMaybe<OrderBy>;
};

export type AncestorScopeDifference = {
  __typename?: 'AncestorScopeDifference';
  ancestorScope: ScopeWithComparableScopeDefiners;
  ancestorScopeSnapshots: Array<PrimitiveScopeSnapshot>;
  savedInheritance: Maybe<SavedSsInheritance>;
  validatedInheritances: Array<ValidatedSsInheritance>;
};

/** Defines the available policies for handling arrays during configuration imports. */
export type ArrayImportOptions = {
  __typename?: 'ArrayImportOptions';
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description: Scalars['String'];
  /** Unique identifier for the array import option. */
  name: Scalars['String'];
  /** Display order of the import option. Lower values are displayed first. */
  ordinal: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "array_import_options". All fields are combined with a logical 'AND'. */
export type ArrayImportOptionsBoolExp = {
  _and?: InputMaybe<Array<ArrayImportOptionsBoolExp>>;
  _not?: InputMaybe<ArrayImportOptionsBoolExp>;
  _or?: InputMaybe<Array<ArrayImportOptionsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "array_import_options". */
export type ArrayImportOptionsOrderBy = {
  description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
};

/** select columns of table "array_import_options" */
export enum ArrayImportOptionsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Ordinal = 'ordinal'
}

/** Streaming cursor of the table "array_import_options" */
export type ArrayImportOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ArrayImportOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArrayImportOptionsStreamCursorValueInput = {
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the array import option. */
  name?: InputMaybe<Scalars['String']>;
  /** Display order of the import option. Lower values are displayed first. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['Boolean']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Boolean']>>;
  _eq?: InputMaybe<Array<Scalars['Boolean']>>;
  _gt?: InputMaybe<Array<Scalars['Boolean']>>;
  _gte?: InputMaybe<Array<Scalars['Boolean']>>;
  _in?: InputMaybe<Array<Array<Scalars['Boolean']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['Boolean']>>;
  _lte?: InputMaybe<Array<Scalars['Boolean']>>;
  _neq?: InputMaybe<Array<Scalars['Boolean']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Boolean']>>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ComparableScopeDefinerWithScopeVariableAndOption = {
  __typename?: 'ComparableScopeDefinerWithScopeVariableAndOption';
  isScopeOptionIdExplicitlySelected: Scalars['Boolean'];
  scopeOption: Maybe<ScopeOptionWithinComparableScopeDefiner>;
  scopeVariable: ScopeVariableWithinComparableScopeDefiner;
};

/** columns and relationships of "comparable_scope_definitions_return_type" */
export type ComparableScopeDefinitionsReturnType = {
  __typename?: 'ComparableScopeDefinitionsReturnType';
  containableScopeDefinition: Maybe<Array<Scalars['String']>>;
  containableScopeDefinitionJsonb: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  scope: Maybe<Scopes>;
  scopeId: Maybe<Scalars['Int']>;
  scopeIdentifyingDefinitionJsonb: Maybe<Scalars['jsonb']>;
  scopeOptionIds: Maybe<Array<Scalars['Int']>>;
  scopeVariableIds: Maybe<Array<Scalars['Int']>>;
  sortableScopeDefinition: Maybe<Array<Scalars['Boolean']>>;
};


/** columns and relationships of "comparable_scope_definitions_return_type" */
export type ComparableScopeDefinitionsReturnTypeContainableScopeDefinitionJsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "comparable_scope_definitions_return_type" */
export type ComparableScopeDefinitionsReturnTypeScopeIdentifyingDefinitionJsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "comparable_scope_definitions_return_type". All fields are combined with a logical 'AND'. */
export type ComparableScopeDefinitionsReturnTypeBoolExp = {
  _and?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeBoolExp>>;
  _not?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
  _or?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeBoolExp>>;
  containableScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  containableScopeDefinitionJsonb?: InputMaybe<JsonbComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<JsonbComparisonExp>;
  scopeOptionIds?: InputMaybe<IntArrayComparisonExp>;
  scopeVariableIds?: InputMaybe<IntArrayComparisonExp>;
  sortableScopeDefinition?: InputMaybe<BooleanArrayComparisonExp>;
};

/** Ordering options when selecting data from "comparable_scope_definitions_return_type". */
export type ComparableScopeDefinitionsReturnTypeOrderBy = {
  containableScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinitionJsonb?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<OrderBy>;
  scopeOptionIds?: InputMaybe<OrderBy>;
  scopeVariableIds?: InputMaybe<OrderBy>;
  sortableScopeDefinition?: InputMaybe<OrderBy>;
};

/** select columns of table "comparable_scope_definitions_return_type" */
export enum ComparableScopeDefinitionsReturnTypeSelectColumn {
  /** column name */
  ContainableScopeDefinition = 'containableScopeDefinition',
  /** column name */
  ContainableScopeDefinitionJsonb = 'containableScopeDefinitionJsonb',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeIdentifyingDefinitionJsonb = 'scopeIdentifyingDefinitionJsonb',
  /** column name */
  ScopeOptionIds = 'scopeOptionIds',
  /** column name */
  ScopeVariableIds = 'scopeVariableIds',
  /** column name */
  SortableScopeDefinition = 'sortableScopeDefinition'
}

/** Streaming cursor of the table "comparable_scope_definitions_return_type" */
export type ComparableScopeDefinitionsReturnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ComparableScopeDefinitionsReturnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ComparableScopeDefinitionsReturnTypeStreamCursorValueInput = {
  containableScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  containableScopeDefinitionJsonb?: InputMaybe<Scalars['jsonb']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeIdentifyingDefinitionJsonb?: InputMaybe<Scalars['jsonb']>;
  scopeOptionIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeVariableIds?: InputMaybe<Array<Scalars['Int']>>;
  sortableScopeDefinition?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Return type used by the ScopeRoot configuration import planner/executor. Each row represents one imported flag node and describes the incoming JSON state, the existing effective ScopeRoot state, the planner's intended destination/storage state, and the operations that would be or were performed. This view intentionally contains no rows and exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type ConfigImportOperationsReturnType = {
  __typename?: 'ConfigImportOperationsReturnType';
  /** Current zero-based effective array position of the existing flag node found at planned_flag_path. NULL when no existing node exists there or when the node is not an array child. */
  existingArrayIndex: Maybe<Scalars['Int']>;
  /** Persisted array_ordinal of the existing flag node found at planned_flag_path. Unlike array_index, array_ordinal is a stored ordering value local to the node's defining snapshot and may contain gaps. NULL when no existing node exists there or when the node is not an array child. */
  existingArrayOrdinal: Maybe<Scalars['Int']>;
  /** Effective scalar value currently resolved for the existing flag node at planned_flag_path in the target scope snapshot inheritance tree. This may originate from the target snapshot or from an inherited snapshot. NULL when no effective value exists. */
  existingEffectiveValue: Maybe<Scalars['jsonb']>;
  /** Scope snapshot in which the existing concrete flag node found at planned_flag_path is defined. This may be the target snapshot or an inherited snapshot. NULL when no existing node occupies the planned destination path. */
  existingFlagNodeDefinedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** ID of the existing concrete flag_nodes row found at planned_flag_path before the import. NULL when the planned destination path does not currently contain a flag node. */
  existingFlagNodeId: Maybe<Scalars['Int']>;
  /** Type of the existing effective flag node currently found at planned_flag_path in the target scope snapshot inheritance tree. NULL when no existing node occupies the planned destination path. */
  existingFlagNodeType: Maybe<Scalars['String']>;
  /** Scope snapshot in which existing_flag_value_id is applied. Used to distinguish a value applied directly in the target scope snapshot from an inherited effective value. NULL when no effective flag value exists. */
  existingFlagValueAppliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** ID of the flag_values row currently supplying the effective value for the existing flag node at planned_flag_path. May refer to a value inherited from another scope snapshot. NULL when no effective flag value exists. */
  existingFlagValueId: Maybe<Scalars['Int']>;
  /** Scope snapshot in which the existing parent flag node at planned_parent_flag_path is concretely defined. Used together with existing_parent_scope_flag_node_id when creating a new child beneath an existing parent. NULL when the parent does not already exist or when this is a top-level node. */
  existingParentFlagNodeScopeSnapshotId: Maybe<Scalars['Int']>;
  /** Abstract scope_flag_node_id of the existing effective node found at planned_parent_flag_path. Primarily used when a new imported node must be created beneath an already-existing parent. NULL when the planned parent does not already exist or when this is a top-level node. */
  existingParentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** Property name of the existing effective flag node found at planned_flag_path. NULL when no existing node exists there or when the node is an array child. */
  existingPropertyName: Maybe<Scalars['String']>;
  /** ID of the abstract scope_flag_nodes identity belonging to the existing flag node found at planned_flag_path. NULL when no existing node occupies the planned destination path. */
  existingScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** Planned structural operation for the flag node. Examples include USE_EXISTING_FLAG_NODE, CREATE_FLAG_NODE, SKIP_FLAG_NODE_CREATION, SKIP_TYPE_MISMATCH, and SKIP_ANCESTOR_TYPE_MISMATCH. */
  flagNodeOperation: Maybe<Scalars['String']>;
  /** Planned value operation for a scalar flag node. Currently UPSERT_FLAG_VALUE or SKIP. NULL for object and array nodes, which do not directly carry flag values. */
  flagValueOperation: Maybe<Scalars['String']>;
  /** Zero-based position of this node within its parent array in the incoming JSON. NULL when the node is not an array child. This always represents the source JSON position, regardless of where the node is planned to be placed. */
  importedArrayIndex: Maybe<Scalars['Int']>;
  /** Depth of this flag node in the incoming JSON tree. Top-level imported properties have depth 1. */
  importedFlagNodeDepth: Maybe<Scalars['Int']>;
  /** Flag node type inferred from the incoming JSON value. Expected values are object, array, or value. */
  importedFlagNodeType: Maybe<Scalars['String']>;
  /** Path of this node exactly as it appears in the incoming JSON configuration. Array path components use the zero-based indexes from the imported JSON and are not adjusted for the selected array import policy. */
  importedFlagPath: Maybe<Array<Scalars['String']>>;
  /** Path of this node's parent exactly as represented in the incoming JSON configuration. */
  importedParentFlagPath: Maybe<Array<Scalars['String']>>;
  /** Property name from the incoming JSON when this node is a child of an object. NULL for array children. */
  importedPropertyName: Maybe<Scalars['String']>;
  /** Scalar value supplied by the incoming JSON when imported_flag_node_type is value. JSON null is represented here as JSON null and is converted to SQL NULL only when persisted to flag_values.value. NULL for object and array nodes. */
  importedValue: Maybe<Scalars['jsonb']>;
  /** Deterministic preorder position of this import operation within the flattened imported JSON tree. Used to preserve parent-before-child execution order. */
  operationOrdinal: Maybe<Scalars['Int']>;
  /** Zero-based effective array position where the planner intends this imported array child to appear after import. For MatchByIndex this normally equals imported_array_index; for Append it is shifted after the existing effective array elements. NULL for non-array children. */
  plannedArrayIndex: Maybe<Scalars['Int']>;
  /** Persisted array_ordinal that will be used if this import creates a new array child. This is a storage ordering value rather than an effective JSON array index and may therefore differ from planned_array_index. Existing array ordinal gaps are preserved rather than filled. */
  plannedArrayOrdinal: Maybe<Scalars['Int']>;
  /** Effective destination path where the planner intends this imported node to exist in the target configuration. Usually equal to imported_flag_path, but may differ for operations such as appending imported elements to an existing array. */
  plannedFlagPath: Maybe<Array<Scalars['String']>>;
  /** Effective destination path of this node's planned parent in the target configuration. Usually equal to imported_parent_flag_path, but may differ when an ancestor is repositioned by an import policy such as array appending. */
  plannedParentFlagPath: Maybe<Array<Scalars['String']>>;
  /** An object relationship */
  targetScopeSnapshot: Maybe<ScopeSnapshots>;
  /** The scope snapshot into which the configuration is being imported. All existing-state comparisons and planned operations in this row are evaluated relative to this target scope snapshot. */
  targetScopeSnapshotId: Maybe<Scalars['Int']>;
};


/** Return type used by the ScopeRoot configuration import planner/executor. Each row represents one imported flag node and describes the incoming JSON state, the existing effective ScopeRoot state, the planner's intended destination/storage state, and the operations that would be or were performed. This view intentionally contains no rows and exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type ConfigImportOperationsReturnTypeExistingEffectiveValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Return type used by the ScopeRoot configuration import planner/executor. Each row represents one imported flag node and describes the incoming JSON state, the existing effective ScopeRoot state, the planner's intended destination/storage state, and the operations that would be or were performed. This view intentionally contains no rows and exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type ConfigImportOperationsReturnTypeImportedValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "config_import_operations_return_type". All fields are combined with a logical 'AND'. */
export type ConfigImportOperationsReturnTypeBoolExp = {
  _and?: InputMaybe<Array<ConfigImportOperationsReturnTypeBoolExp>>;
  _not?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
  _or?: InputMaybe<Array<ConfigImportOperationsReturnTypeBoolExp>>;
  existingArrayIndex?: InputMaybe<IntComparisonExp>;
  existingArrayOrdinal?: InputMaybe<IntComparisonExp>;
  existingEffectiveValue?: InputMaybe<JsonbComparisonExp>;
  existingFlagNodeDefinedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  existingFlagNodeId?: InputMaybe<IntComparisonExp>;
  existingFlagNodeType?: InputMaybe<StringComparisonExp>;
  existingFlagValueAppliedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  existingFlagValueId?: InputMaybe<IntComparisonExp>;
  existingParentFlagNodeScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  existingParentScopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  existingPropertyName?: InputMaybe<StringComparisonExp>;
  existingScopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  flagNodeOperation?: InputMaybe<StringComparisonExp>;
  flagValueOperation?: InputMaybe<StringComparisonExp>;
  importedArrayIndex?: InputMaybe<IntComparisonExp>;
  importedFlagNodeDepth?: InputMaybe<IntComparisonExp>;
  importedFlagNodeType?: InputMaybe<StringComparisonExp>;
  importedFlagPath?: InputMaybe<StringArrayComparisonExp>;
  importedParentFlagPath?: InputMaybe<StringArrayComparisonExp>;
  importedPropertyName?: InputMaybe<StringComparisonExp>;
  importedValue?: InputMaybe<JsonbComparisonExp>;
  operationOrdinal?: InputMaybe<IntComparisonExp>;
  plannedArrayIndex?: InputMaybe<IntComparisonExp>;
  plannedArrayOrdinal?: InputMaybe<IntComparisonExp>;
  plannedFlagPath?: InputMaybe<StringArrayComparisonExp>;
  plannedParentFlagPath?: InputMaybe<StringArrayComparisonExp>;
  targetScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  targetScopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "config_import_operations_return_type". */
export type ConfigImportOperationsReturnTypeOrderBy = {
  existingArrayIndex?: InputMaybe<OrderBy>;
  existingArrayOrdinal?: InputMaybe<OrderBy>;
  existingEffectiveValue?: InputMaybe<OrderBy>;
  existingFlagNodeDefinedInScopeSnapshotId?: InputMaybe<OrderBy>;
  existingFlagNodeId?: InputMaybe<OrderBy>;
  existingFlagNodeType?: InputMaybe<OrderBy>;
  existingFlagValueAppliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  existingFlagValueId?: InputMaybe<OrderBy>;
  existingParentFlagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  existingParentScopeFlagNodeId?: InputMaybe<OrderBy>;
  existingPropertyName?: InputMaybe<OrderBy>;
  existingScopeFlagNodeId?: InputMaybe<OrderBy>;
  flagNodeOperation?: InputMaybe<OrderBy>;
  flagValueOperation?: InputMaybe<OrderBy>;
  importedArrayIndex?: InputMaybe<OrderBy>;
  importedFlagNodeDepth?: InputMaybe<OrderBy>;
  importedFlagNodeType?: InputMaybe<OrderBy>;
  importedFlagPath?: InputMaybe<OrderBy>;
  importedParentFlagPath?: InputMaybe<OrderBy>;
  importedPropertyName?: InputMaybe<OrderBy>;
  importedValue?: InputMaybe<OrderBy>;
  operationOrdinal?: InputMaybe<OrderBy>;
  plannedArrayIndex?: InputMaybe<OrderBy>;
  plannedArrayOrdinal?: InputMaybe<OrderBy>;
  plannedFlagPath?: InputMaybe<OrderBy>;
  plannedParentFlagPath?: InputMaybe<OrderBy>;
  targetScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  targetScopeSnapshotId?: InputMaybe<OrderBy>;
};

/** select columns of table "config_import_operations_return_type" */
export enum ConfigImportOperationsReturnTypeSelectColumn {
  /** column name */
  ExistingArrayIndex = 'existingArrayIndex',
  /** column name */
  ExistingArrayOrdinal = 'existingArrayOrdinal',
  /** column name */
  ExistingEffectiveValue = 'existingEffectiveValue',
  /** column name */
  ExistingFlagNodeDefinedInScopeSnapshotId = 'existingFlagNodeDefinedInScopeSnapshotId',
  /** column name */
  ExistingFlagNodeId = 'existingFlagNodeId',
  /** column name */
  ExistingFlagNodeType = 'existingFlagNodeType',
  /** column name */
  ExistingFlagValueAppliedInScopeSnapshotId = 'existingFlagValueAppliedInScopeSnapshotId',
  /** column name */
  ExistingFlagValueId = 'existingFlagValueId',
  /** column name */
  ExistingParentFlagNodeScopeSnapshotId = 'existingParentFlagNodeScopeSnapshotId',
  /** column name */
  ExistingParentScopeFlagNodeId = 'existingParentScopeFlagNodeId',
  /** column name */
  ExistingPropertyName = 'existingPropertyName',
  /** column name */
  ExistingScopeFlagNodeId = 'existingScopeFlagNodeId',
  /** column name */
  FlagNodeOperation = 'flagNodeOperation',
  /** column name */
  FlagValueOperation = 'flagValueOperation',
  /** column name */
  ImportedArrayIndex = 'importedArrayIndex',
  /** column name */
  ImportedFlagNodeDepth = 'importedFlagNodeDepth',
  /** column name */
  ImportedFlagNodeType = 'importedFlagNodeType',
  /** column name */
  ImportedFlagPath = 'importedFlagPath',
  /** column name */
  ImportedParentFlagPath = 'importedParentFlagPath',
  /** column name */
  ImportedPropertyName = 'importedPropertyName',
  /** column name */
  ImportedValue = 'importedValue',
  /** column name */
  OperationOrdinal = 'operationOrdinal',
  /** column name */
  PlannedArrayIndex = 'plannedArrayIndex',
  /** column name */
  PlannedArrayOrdinal = 'plannedArrayOrdinal',
  /** column name */
  PlannedFlagPath = 'plannedFlagPath',
  /** column name */
  PlannedParentFlagPath = 'plannedParentFlagPath',
  /** column name */
  TargetScopeSnapshotId = 'targetScopeSnapshotId'
}

/** Streaming cursor of the table "config_import_operations_return_type" */
export type ConfigImportOperationsReturnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConfigImportOperationsReturnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigImportOperationsReturnTypeStreamCursorValueInput = {
  /** Current zero-based effective array position of the existing flag node found at planned_flag_path. NULL when no existing node exists there or when the node is not an array child. */
  existingArrayIndex?: InputMaybe<Scalars['Int']>;
  /** Persisted array_ordinal of the existing flag node found at planned_flag_path. Unlike array_index, array_ordinal is a stored ordering value local to the node's defining snapshot and may contain gaps. NULL when no existing node exists there or when the node is not an array child. */
  existingArrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** Effective scalar value currently resolved for the existing flag node at planned_flag_path in the target scope snapshot inheritance tree. This may originate from the target snapshot or from an inherited snapshot. NULL when no effective value exists. */
  existingEffectiveValue?: InputMaybe<Scalars['jsonb']>;
  /** Scope snapshot in which the existing concrete flag node found at planned_flag_path is defined. This may be the target snapshot or an inherited snapshot. NULL when no existing node occupies the planned destination path. */
  existingFlagNodeDefinedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** ID of the existing concrete flag_nodes row found at planned_flag_path before the import. NULL when the planned destination path does not currently contain a flag node. */
  existingFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Type of the existing effective flag node currently found at planned_flag_path in the target scope snapshot inheritance tree. NULL when no existing node occupies the planned destination path. */
  existingFlagNodeType?: InputMaybe<Scalars['String']>;
  /** Scope snapshot in which existing_flag_value_id is applied. Used to distinguish a value applied directly in the target scope snapshot from an inherited effective value. NULL when no effective flag value exists. */
  existingFlagValueAppliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** ID of the flag_values row currently supplying the effective value for the existing flag node at planned_flag_path. May refer to a value inherited from another scope snapshot. NULL when no effective flag value exists. */
  existingFlagValueId?: InputMaybe<Scalars['Int']>;
  /** Scope snapshot in which the existing parent flag node at planned_parent_flag_path is concretely defined. Used together with existing_parent_scope_flag_node_id when creating a new child beneath an existing parent. NULL when the parent does not already exist or when this is a top-level node. */
  existingParentFlagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** Abstract scope_flag_node_id of the existing effective node found at planned_parent_flag_path. Primarily used when a new imported node must be created beneath an already-existing parent. NULL when the planned parent does not already exist or when this is a top-level node. */
  existingParentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Property name of the existing effective flag node found at planned_flag_path. NULL when no existing node exists there or when the node is an array child. */
  existingPropertyName?: InputMaybe<Scalars['String']>;
  /** ID of the abstract scope_flag_nodes identity belonging to the existing flag node found at planned_flag_path. NULL when no existing node occupies the planned destination path. */
  existingScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Planned structural operation for the flag node. Examples include USE_EXISTING_FLAG_NODE, CREATE_FLAG_NODE, SKIP_FLAG_NODE_CREATION, SKIP_TYPE_MISMATCH, and SKIP_ANCESTOR_TYPE_MISMATCH. */
  flagNodeOperation?: InputMaybe<Scalars['String']>;
  /** Planned value operation for a scalar flag node. Currently UPSERT_FLAG_VALUE or SKIP. NULL for object and array nodes, which do not directly carry flag values. */
  flagValueOperation?: InputMaybe<Scalars['String']>;
  /** Zero-based position of this node within its parent array in the incoming JSON. NULL when the node is not an array child. This always represents the source JSON position, regardless of where the node is planned to be placed. */
  importedArrayIndex?: InputMaybe<Scalars['Int']>;
  /** Depth of this flag node in the incoming JSON tree. Top-level imported properties have depth 1. */
  importedFlagNodeDepth?: InputMaybe<Scalars['Int']>;
  /** Flag node type inferred from the incoming JSON value. Expected values are object, array, or value. */
  importedFlagNodeType?: InputMaybe<Scalars['String']>;
  /** Path of this node exactly as it appears in the incoming JSON configuration. Array path components use the zero-based indexes from the imported JSON and are not adjusted for the selected array import policy. */
  importedFlagPath?: InputMaybe<Array<Scalars['String']>>;
  /** Path of this node's parent exactly as represented in the incoming JSON configuration. */
  importedParentFlagPath?: InputMaybe<Array<Scalars['String']>>;
  /** Property name from the incoming JSON when this node is a child of an object. NULL for array children. */
  importedPropertyName?: InputMaybe<Scalars['String']>;
  /** Scalar value supplied by the incoming JSON when imported_flag_node_type is value. JSON null is represented here as JSON null and is converted to SQL NULL only when persisted to flag_values.value. NULL for object and array nodes. */
  importedValue?: InputMaybe<Scalars['jsonb']>;
  /** Deterministic preorder position of this import operation within the flattened imported JSON tree. Used to preserve parent-before-child execution order. */
  operationOrdinal?: InputMaybe<Scalars['Int']>;
  /** Zero-based effective array position where the planner intends this imported array child to appear after import. For MatchByIndex this normally equals imported_array_index; for Append it is shifted after the existing effective array elements. NULL for non-array children. */
  plannedArrayIndex?: InputMaybe<Scalars['Int']>;
  /** Persisted array_ordinal that will be used if this import creates a new array child. This is a storage ordering value rather than an effective JSON array index and may therefore differ from planned_array_index. Existing array ordinal gaps are preserved rather than filled. */
  plannedArrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** Effective destination path where the planner intends this imported node to exist in the target configuration. Usually equal to imported_flag_path, but may differ for operations such as appending imported elements to an existing array. */
  plannedFlagPath?: InputMaybe<Array<Scalars['String']>>;
  /** Effective destination path of this node's planned parent in the target configuration. Usually equal to imported_parent_flag_path, but may differ when an ancestor is repositioned by an import policy such as array appending. */
  plannedParentFlagPath?: InputMaybe<Array<Scalars['String']>>;
  /** The scope snapshot into which the configuration is being imported. All existing-state comparisons and planned operations in this row are evaluated relative to this target scope snapshot. */
  targetScopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

export type ConflictingFlagNodeContext = {
  __typename?: 'ConflictingFlagNodeContext';
  arrayOrdinal: Maybe<Scalars['Int']>;
  definedInScopeId: Scalars['Int'];
  definedInScopeSnapshotId: Scalars['Int'];
  definedInScopeVersion: Scalars['String'];
  effectiveValue: Maybe<Scalars['jsonb']>;
  flagNodeId: Scalars['Int'];
  flagNodeType: Scalars['String'];
  flagPath: Array<Scalars['String']>;
  flagValueAppliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  flagValueId: Maybe<Scalars['Int']>;
  parentFlagNodeScopeSnapshotId: Maybe<Scalars['Int']>;
  propertyName: Maybe<Scalars['String']>;
  scopeFlagNodeId: Scalars['Int'];
  targetScopeSnapshotId: Scalars['Int'];
  valuedFlagAsJsonExtract: Scalars['jsonb'];
};

export type ConflictsForFlagPath = {
  __typename?: 'ConflictsForFlagPath';
  conflictingFlagNodeContexts: Array<ConflictingFlagNodeContext>;
  flagPath: Array<Scalars['String']>;
  redundantBecause: Array<FlagPathConflictRedundancyReason>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type DeleteConflictingSsDirectInheritanceWhere = {
  __typename?: 'DeleteConflictingSsDirectInheritanceWhere';
  directlyInheritedScopeSnapshotId: EqualToIntExpression;
  scopeSnapshotId: EqualToIntExpression;
};

export type DeleteSsDirectInheritancesWhere = {
  __typename?: 'DeleteSsDirectInheritancesWhere';
  directlyInheritedScopeId: EqualToIntExpression;
  scopeSnapshotId: EqualToIntExpression;
};

/** columns and relationships of "deployments" */
export type Deployments = {
  __typename?: 'Deployments';
  id: Scalars['Int'];
  key: Scalars['String'];
  scopeId: Scalars['Int'];
  /** An object relationship */
  scopeSnapshot: ScopeSnapshots;
  scopeVersion: Scalars['String'];
};

/** order by aggregate values of table "deployments" */
export type DeploymentsAggregateOrderBy = {
  avg?: InputMaybe<DeploymentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DeploymentsMaxOrderBy>;
  min?: InputMaybe<DeploymentsMinOrderBy>;
  stddev?: InputMaybe<DeploymentsStddevOrderBy>;
  stddevPop?: InputMaybe<DeploymentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<DeploymentsStddevSampOrderBy>;
  sum?: InputMaybe<DeploymentsSumOrderBy>;
  varPop?: InputMaybe<DeploymentsVarPopOrderBy>;
  varSamp?: InputMaybe<DeploymentsVarSampOrderBy>;
  variance?: InputMaybe<DeploymentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "deployments" */
export type DeploymentsArrRelInsertInput = {
  data: Array<DeploymentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DeploymentsOnConflict>;
};

/** order by avg() on columns of table "deployments" */
export type DeploymentsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "deployments". All fields are combined with a logical 'AND'. */
export type DeploymentsBoolExp = {
  _and?: InputMaybe<Array<DeploymentsBoolExp>>;
  _not?: InputMaybe<DeploymentsBoolExp>;
  _or?: InputMaybe<Array<DeploymentsBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeVersion?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "deployments" */
export enum DeploymentsConstraint {
  /** unique or primary key constraint on columns "id" */
  DeploymentsPkey = 'deployments_pkey',
  /** unique or primary key constraint on columns "key", "tenant_id" */
  DeploymentsTenantIdKeyKey = 'deployments_tenant_id_key_key'
}

/** input type for incrementing numeric columns in table "deployments" */
export type DeploymentsIncInput = {
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "deployments" */
export type DeploymentsInsertInput = {
  key?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsObjRelInsertInput>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "deployments" */
export type DeploymentsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "deployments" */
export type DeploymentsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "deployments" */
export type DeploymentsMutationResponse = {
  __typename?: 'DeploymentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Deployments>;
};

/** on_conflict condition type for table "deployments" */
export type DeploymentsOnConflict = {
  constraint: DeploymentsConstraint;
  updateColumns?: Array<DeploymentsUpdateColumn>;
  where?: InputMaybe<DeploymentsBoolExp>;
};

/** Ordering options when selecting data from "deployments". */
export type DeploymentsOrderBy = {
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: deployments */
export type DeploymentsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "deployments" */
export enum DeploymentsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeVersion = 'scopeVersion'
}

/** input type for updating data in table "deployments" */
export type DeploymentsSetInput = {
  key?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "deployments" */
export type DeploymentsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "deployments" */
export type DeploymentsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "deployments" */
export type DeploymentsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "deployments" */
export type DeploymentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DeploymentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeploymentsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "deployments" */
export type DeploymentsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** update columns of table "deployments" */
export enum DeploymentsUpdateColumn {
  /** column name */
  Key = 'key',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeVersion = 'scopeVersion'
}

export type DeploymentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DeploymentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeploymentsSetInput>;
  /** filter the rows which have to be updated */
  where: DeploymentsBoolExp;
};

/** order by varPop() on columns of table "deployments" */
export type DeploymentsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "deployments" */
export type DeploymentsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "deployments" */
export type DeploymentsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

export type DescendantScopeDifference = {
  __typename?: 'DescendantScopeDifference';
  descendantScope: ScopeWithComparableScopeDefiners;
  descendantScopeSnapshots: Array<PrimitiveScopeSnapshotWithValidationDifference>;
};

export type EqualToIntExpression = {
  __typename?: 'EqualToIntExpression';
  _eq: Scalars['Int'];
};

export type ExpectedJsonConfigurationHashes = {
  after: Scalars['String'];
  before: Scalars['String'];
};

/** Defines the available policies for handling flag nodes during configuration imports. */
export type FlagNodeImportOptions = {
  __typename?: 'FlagNodeImportOptions';
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description: Scalars['String'];
  /** Unique identifier for the flag node import option. */
  name: Scalars['String'];
  /** Display order of the import option. Lower values are displayed first. */
  ordinal: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "flag_node_import_options". All fields are combined with a logical 'AND'. */
export type FlagNodeImportOptionsBoolExp = {
  _and?: InputMaybe<Array<FlagNodeImportOptionsBoolExp>>;
  _not?: InputMaybe<FlagNodeImportOptionsBoolExp>;
  _or?: InputMaybe<Array<FlagNodeImportOptionsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "flag_node_import_options". */
export type FlagNodeImportOptionsOrderBy = {
  description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
};

/** select columns of table "flag_node_import_options" */
export enum FlagNodeImportOptionsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Ordinal = 'ordinal'
}

/** Streaming cursor of the table "flag_node_import_options" */
export type FlagNodeImportOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FlagNodeImportOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FlagNodeImportOptionsStreamCursorValueInput = {
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the flag node import option. */
  name?: InputMaybe<Scalars['String']>;
  /** Display order of the import option. Lower values are displayed first. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

export enum FlagNodeTypesEnum {
  Array = 'ARRAY',
  Object = 'OBJECT',
  Value = 'VALUE'
}

/** Boolean expression to compare columns of type "FlagNodeTypesEnum". All fields are combined with logical 'AND'. */
export type FlagNodeTypesEnumComparisonExp = {
  _eq?: InputMaybe<FlagNodeTypesEnum>;
  _in?: InputMaybe<Array<FlagNodeTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FlagNodeTypesEnum>;
  _nin?: InputMaybe<Array<FlagNodeTypesEnum>>;
};

/**
 * The individual nodes of a flag. Flag nodes at the root of the scope snapshot do not have a parent flag node. A parent flag node can also belong to a different scope snapshot altogether, where (parent_flag_node_scope_id, parent_flag_node_scope_version) would be different than (defined_in_scope_id, defined_in_scope_version).
 * 
 * ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data).
 * 
 * Because inherited_valued_flag_nodes is not refreshed until the end of the transaction, logic that requires the current IVFN state during a transaction should use inherited_valued_flag_node_references() rather than querying the materialized inherited_valued_flag_nodes table directly.
 * 
 * Also make sure that the flag_nodes_canonical_valued_flag_node foreign key remains NOT ENFORCED. This foreign key provides the canonical relationship from a flag node to its IVFN row. This relationship is needed by the frontend to display derived information about a flag node, such as its array index, which is only available through the IVFN table. The foreign key must remain NOT ENFORCED because inherited_valued_flag_nodes can legitimately be stale until its deferred refresh occurs at the end of the transaction.
 * 
 * Finally, make sure that the unique constraint flag_nodes_array_ordinal_within_parent remains DEFERRABLE INITIALLY DEFERRED as well, in order to preserve the ability to reorder array children without temporary conflicts.
 */
export type FlagNodes = {
  __typename?: 'FlagNodes';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Int']>;
  /** An object relationship */
  canonicalValuedFlagNode: InheritedValuedFlagNodes;
  /** An array relationship */
  children: Array<FlagNodes>;
  /** An aggregate relationship */
  childrenAggregate: FlagNodesAggregate;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Scalars['Int'];
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Scalars['Int'];
  /** An array relationship */
  flagValues: Array<FlagValues>;
  /** An aggregate relationship */
  flagValuesAggregate: FlagValuesAggregate;
  id: Scalars['Int'];
  /** An object relationship */
  parent: Maybe<FlagNodes>;
  /** An object relationship */
  parentScopeFlagNode: Maybe<ScopeFlagNodes>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName: Maybe<Scalars['String']>;
  /** An object relationship */
  scope: Maybe<Scopes>;
  /** An object relationship */
  scopeFlagNode: ScopeFlagNodes;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Scalars['Int'];
  /** An object relationship */
  scopeSnapshot: ScopeSnapshots;
  /** Can be one of the flag_node_types: 'array', 'object', 'value'. Note that only flag nodes of type 'array' and 'object' can have child flag nodes. This is enforced using foreign key, specifically from the flag_nodes.parent_flag_node_type column. Only flag nodes of type 'value' can have flag_values assigned to them. This is also enforced using foreign key, specifically from the flag_values.flag_node_type column. */
  type: FlagNodeTypesEnum;
};


/**
 * The individual nodes of a flag. Flag nodes at the root of the scope snapshot do not have a parent flag node. A parent flag node can also belong to a different scope snapshot altogether, where (parent_flag_node_scope_id, parent_flag_node_scope_version) would be different than (defined_in_scope_id, defined_in_scope_version).
 * 
 * ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data).
 * 
 * Because inherited_valued_flag_nodes is not refreshed until the end of the transaction, logic that requires the current IVFN state during a transaction should use inherited_valued_flag_node_references() rather than querying the materialized inherited_valued_flag_nodes table directly.
 * 
 * Also make sure that the flag_nodes_canonical_valued_flag_node foreign key remains NOT ENFORCED. This foreign key provides the canonical relationship from a flag node to its IVFN row. This relationship is needed by the frontend to display derived information about a flag node, such as its array index, which is only available through the IVFN table. The foreign key must remain NOT ENFORCED because inherited_valued_flag_nodes can legitimately be stale until its deferred refresh occurs at the end of the transaction.
 * 
 * Finally, make sure that the unique constraint flag_nodes_array_ordinal_within_parent remains DEFERRABLE INITIALLY DEFERRED as well, in order to preserve the ability to reorder array children without temporary conflicts.
 */
export type FlagNodesChildrenArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/**
 * The individual nodes of a flag. Flag nodes at the root of the scope snapshot do not have a parent flag node. A parent flag node can also belong to a different scope snapshot altogether, where (parent_flag_node_scope_id, parent_flag_node_scope_version) would be different than (defined_in_scope_id, defined_in_scope_version).
 * 
 * ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data).
 * 
 * Because inherited_valued_flag_nodes is not refreshed until the end of the transaction, logic that requires the current IVFN state during a transaction should use inherited_valued_flag_node_references() rather than querying the materialized inherited_valued_flag_nodes table directly.
 * 
 * Also make sure that the flag_nodes_canonical_valued_flag_node foreign key remains NOT ENFORCED. This foreign key provides the canonical relationship from a flag node to its IVFN row. This relationship is needed by the frontend to display derived information about a flag node, such as its array index, which is only available through the IVFN table. The foreign key must remain NOT ENFORCED because inherited_valued_flag_nodes can legitimately be stale until its deferred refresh occurs at the end of the transaction.
 * 
 * Finally, make sure that the unique constraint flag_nodes_array_ordinal_within_parent remains DEFERRABLE INITIALLY DEFERRED as well, in order to preserve the ability to reorder array children without temporary conflicts.
 */
export type FlagNodesChildrenAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/**
 * The individual nodes of a flag. Flag nodes at the root of the scope snapshot do not have a parent flag node. A parent flag node can also belong to a different scope snapshot altogether, where (parent_flag_node_scope_id, parent_flag_node_scope_version) would be different than (defined_in_scope_id, defined_in_scope_version).
 * 
 * ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data).
 * 
 * Because inherited_valued_flag_nodes is not refreshed until the end of the transaction, logic that requires the current IVFN state during a transaction should use inherited_valued_flag_node_references() rather than querying the materialized inherited_valued_flag_nodes table directly.
 * 
 * Also make sure that the flag_nodes_canonical_valued_flag_node foreign key remains NOT ENFORCED. This foreign key provides the canonical relationship from a flag node to its IVFN row. This relationship is needed by the frontend to display derived information about a flag node, such as its array index, which is only available through the IVFN table. The foreign key must remain NOT ENFORCED because inherited_valued_flag_nodes can legitimately be stale until its deferred refresh occurs at the end of the transaction.
 * 
 * Finally, make sure that the unique constraint flag_nodes_array_ordinal_within_parent remains DEFERRABLE INITIALLY DEFERRED as well, in order to preserve the ability to reorder array children without temporary conflicts.
 */
export type FlagNodesFlagValuesArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


/**
 * The individual nodes of a flag. Flag nodes at the root of the scope snapshot do not have a parent flag node. A parent flag node can also belong to a different scope snapshot altogether, where (parent_flag_node_scope_id, parent_flag_node_scope_version) would be different than (defined_in_scope_id, defined_in_scope_version).
 * 
 * ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data).
 * 
 * Because inherited_valued_flag_nodes is not refreshed until the end of the transaction, logic that requires the current IVFN state during a transaction should use inherited_valued_flag_node_references() rather than querying the materialized inherited_valued_flag_nodes table directly.
 * 
 * Also make sure that the flag_nodes_canonical_valued_flag_node foreign key remains NOT ENFORCED. This foreign key provides the canonical relationship from a flag node to its IVFN row. This relationship is needed by the frontend to display derived information about a flag node, such as its array index, which is only available through the IVFN table. The foreign key must remain NOT ENFORCED because inherited_valued_flag_nodes can legitimately be stale until its deferred refresh occurs at the end of the transaction.
 * 
 * Finally, make sure that the unique constraint flag_nodes_array_ordinal_within_parent remains DEFERRABLE INITIALLY DEFERRED as well, in order to preserve the ability to reorder array children without temporary conflicts.
 */
export type FlagNodesFlagValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};

/** aggregated selection of "flag_nodes" */
export type FlagNodesAggregate = {
  __typename?: 'FlagNodesAggregate';
  aggregate: FlagNodesAggregateFields;
  nodes: Array<FlagNodes>;
};

export type FlagNodesAggregateBoolExp = {
  count?: InputMaybe<FlagNodesAggregateBoolExpCount>;
};

/** aggregate fields of "flag_nodes" */
export type FlagNodesAggregateFields = {
  __typename?: 'FlagNodesAggregateFields';
  avg: Maybe<FlagNodesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<FlagNodesMaxFields>;
  min: Maybe<FlagNodesMinFields>;
  stddev: Maybe<FlagNodesStddevFields>;
  stddevPop: Maybe<FlagNodesStddevPopFields>;
  stddevSamp: Maybe<FlagNodesStddevSampFields>;
  sum: Maybe<FlagNodesSumFields>;
  varPop: Maybe<FlagNodesVarPopFields>;
  varSamp: Maybe<FlagNodesVarSampFields>;
  variance: Maybe<FlagNodesVarianceFields>;
};


/** aggregate fields of "flag_nodes" */
export type FlagNodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FlagNodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flag_nodes" */
export type FlagNodesAggregateOrderBy = {
  avg?: InputMaybe<FlagNodesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FlagNodesMaxOrderBy>;
  min?: InputMaybe<FlagNodesMinOrderBy>;
  stddev?: InputMaybe<FlagNodesStddevOrderBy>;
  stddevPop?: InputMaybe<FlagNodesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<FlagNodesStddevSampOrderBy>;
  sum?: InputMaybe<FlagNodesSumOrderBy>;
  varPop?: InputMaybe<FlagNodesVarPopOrderBy>;
  varSamp?: InputMaybe<FlagNodesVarSampOrderBy>;
  variance?: InputMaybe<FlagNodesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "flag_nodes" */
export type FlagNodesArrRelInsertInput = {
  data: Array<FlagNodesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<FlagNodesOnConflict>;
};

/** aggregate avg on columns */
export type FlagNodesAvgFields = {
  __typename?: 'FlagNodesAvgFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flag_nodes" */
export type FlagNodesAvgOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "flag_nodes". All fields are combined with a logical 'AND'. */
export type FlagNodesBoolExp = {
  _and?: InputMaybe<Array<FlagNodesBoolExp>>;
  _not?: InputMaybe<FlagNodesBoolExp>;
  _or?: InputMaybe<Array<FlagNodesBoolExp>>;
  arrayOrdinal?: InputMaybe<IntComparisonExp>;
  canonicalValuedFlagNode?: InputMaybe<InheritedValuedFlagNodesBoolExp>;
  children?: InputMaybe<FlagNodesBoolExp>;
  childrenAggregate?: InputMaybe<FlagNodesAggregateBoolExp>;
  definedInScopeId?: InputMaybe<IntComparisonExp>;
  definedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  flagValues?: InputMaybe<FlagValuesBoolExp>;
  flagValuesAggregate?: InputMaybe<FlagValuesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  parent?: InputMaybe<FlagNodesBoolExp>;
  parentScopeFlagNode?: InputMaybe<ScopeFlagNodesBoolExp>;
  parentScopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  propertyName?: InputMaybe<StringComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesBoolExp>;
  scopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  type?: InputMaybe<FlagNodeTypesEnumComparisonExp>;
};

/** unique or primary key constraints on table "flag_nodes" */
export enum FlagNodesConstraint {
  /** unique or primary key constraint on columns "parent_scope_flag_node_id_non_null", "array_ordinal", "defined_in_scope_snapshot_id" */
  FlagNodesArrayOrdinalWithinParent = 'flag_nodes_array_ordinal_within_parent',
  /** unique or primary key constraint on columns "parent_scope_flag_node_id_non_null", "property_name", "defined_in_scope_snapshot_id" */
  FlagNodesDefinedInScopeSnapshotIdParentScopeFlagNode = 'flag_nodes_defined_in_scope_snapshot_id_parent_scope_flag_node_',
  /** unique or primary key constraint on columns "id", "array_ordinal" */
  FlagNodesIdArrayOrdinalKey = 'flag_nodes_id_array_ordinal_key',
  /** unique or primary key constraint on columns "id", "defined_in_scope_snapshot_id" */
  FlagNodesIdDefinedInScopeSnapshotIdKey = 'flag_nodes_id_defined_in_scope_snapshot_id_key',
  /** unique or primary key constraint on columns "id", "property_name" */
  FlagNodesIdPropertyNameKey = 'flag_nodes_id_property_name_key',
  /** unique or primary key constraint on columns "id", "scope_flag_node_id", "defined_in_scope_snapshot_id" */
  FlagNodesIdScopeFlagNodeIdDefinedInScopeSnapshotIdK = 'flag_nodes_id_scope_flag_node_id_defined_in_scope_snapshot_id_k',
  /** unique or primary key constraint on columns "id", "scope_flag_node_id", "parent_scope_flag_node_id", "parent_flag_node_scope_snapshot_id", "defined_in_scope_snapshot_id", "parent_flag_node_type_enforcer" */
  FlagNodesIdScopeFlagNodeIdDefinedInScopeSnapshotIdP = 'flag_nodes_id_scope_flag_node_id_defined_in_scope_snapshot_id_p',
  /** unique or primary key constraint on columns "property_name", "parent_scope_flag_node_id", "defined_in_scope_snapshot_id" */
  FlagNodesPropertyNameDefinedInScopeSnapshotIdParentSc = 'flag_nodes_property_name_defined_in_scope_snapshot_id_parent_sc',
  /** unique or primary key constraint on columns "scope_flag_node_id", "defined_in_scope_snapshot_id" */
  FlagNodesScopeFlagNodeIdDefinedInScopeSnapshotIdKey = 'flag_nodes_scope_flag_node_id_defined_in_scope_snapshot_id_key',
  /** unique or primary key constraint on columns "type", "scope_flag_node_id", "defined_in_scope_snapshot_id" */
  FlagNodesScopeFlagNodeIdDefinedInScopeSnapshotIdType = 'flag_nodes_scope_flag_node_id_defined_in_scope_snapshot_id_type',
  /** unique or primary key constraint on columns "id" */
  NodesPkey1 = 'nodes_pkey1'
}

/** input type for incrementing numeric columns in table "flag_nodes" */
export type FlagNodesIncInput = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentFlagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "flag_nodes" */
export type FlagNodesInsertInput = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<Scalars['Int']>;
  children?: InputMaybe<FlagNodesArrRelInsertInput>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<Scalars['Int']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  flagValues?: InputMaybe<FlagValuesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<FlagNodesObjRelInsertInput>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentFlagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  parentScopeFlagNode?: InputMaybe<ScopeFlagNodesObjRelInsertInput>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<ScopesObjRelInsertInput>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesObjRelInsertInput>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsObjRelInsertInput>;
  /** Can be one of the flag_node_types: 'array', 'object', 'value'. Note that only flag nodes of type 'array' and 'object' can have child flag nodes. This is enforced using foreign key, specifically from the flag_nodes.parent_flag_node_type column. Only flag nodes of type 'value' can have flag_values assigned to them. This is also enforced using foreign key, specifically from the flag_values.flag_node_type column. */
  type?: InputMaybe<FlagNodeTypesEnum>;
};

/** aggregate max on columns */
export type FlagNodesMaxFields = {
  __typename?: 'FlagNodesMaxFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Int']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName: Maybe<Scalars['String']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flag_nodes" */
export type FlagNodesMaxOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FlagNodesMinFields = {
  __typename?: 'FlagNodesMinFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Int']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName: Maybe<Scalars['String']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flag_nodes" */
export type FlagNodesMinOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "flag_nodes" */
export type FlagNodesMutationResponse = {
  __typename?: 'FlagNodesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FlagNodes>;
};

/** input type for inserting object relation for remote table "flag_nodes" */
export type FlagNodesObjRelInsertInput = {
  data: FlagNodesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<FlagNodesOnConflict>;
};

/** on_conflict condition type for table "flag_nodes" */
export type FlagNodesOnConflict = {
  constraint: FlagNodesConstraint;
  updateColumns?: Array<FlagNodesUpdateColumn>;
  where?: InputMaybe<FlagNodesBoolExp>;
};

/** Ordering options when selecting data from "flag_nodes". */
export type FlagNodesOrderBy = {
  arrayOrdinal?: InputMaybe<OrderBy>;
  canonicalValuedFlagNode?: InputMaybe<InheritedValuedFlagNodesOrderBy>;
  childrenAggregate?: InputMaybe<FlagNodesAggregateOrderBy>;
  definedInScopeId?: InputMaybe<OrderBy>;
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  flagValuesAggregate?: InputMaybe<FlagValuesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  parent?: InputMaybe<FlagNodesOrderBy>;
  parentScopeFlagNode?: InputMaybe<ScopeFlagNodesOrderBy>;
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  propertyName?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesOrderBy>;
  scopeFlagNodeId?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: flag_nodes */
export type FlagNodesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "flag_nodes" */
export enum FlagNodesSelectColumn {
  /** column name */
  ArrayOrdinal = 'arrayOrdinal',
  /** column name */
  DefinedInScopeId = 'definedInScopeId',
  /** column name */
  DefinedInScopeSnapshotId = 'definedInScopeSnapshotId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentScopeFlagNodeId = 'parentScopeFlagNodeId',
  /** column name */
  PropertyName = 'propertyName',
  /** column name */
  ScopeFlagNodeId = 'scopeFlagNodeId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "flag_nodes" */
export type FlagNodesSetInput = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentFlagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName?: InputMaybe<Scalars['String']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Can be one of the flag_node_types: 'array', 'object', 'value'. Note that only flag nodes of type 'array' and 'object' can have child flag nodes. This is enforced using foreign key, specifically from the flag_nodes.parent_flag_node_type column. Only flag nodes of type 'value' can have flag_values assigned to them. This is also enforced using foreign key, specifically from the flag_values.flag_node_type column. */
  type?: InputMaybe<FlagNodeTypesEnum>;
};

/** aggregate stddev on columns */
export type FlagNodesStddevFields = {
  __typename?: 'FlagNodesStddevFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flag_nodes" */
export type FlagNodesStddevOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type FlagNodesStddevPopFields = {
  __typename?: 'FlagNodesStddevPopFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "flag_nodes" */
export type FlagNodesStddevPopOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type FlagNodesStddevSampFields = {
  __typename?: 'FlagNodesStddevSampFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "flag_nodes" */
export type FlagNodesStddevSampOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "flag_nodes" */
export type FlagNodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FlagNodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FlagNodesStreamCursorValueInput = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<Scalars['Int']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** The property name under which this node appears when its parent is an object (if there's no parent node, the "parent" is still considered an object). Null only when the parent is an array. */
  propertyName?: InputMaybe<Scalars['String']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Can be one of the flag_node_types: 'array', 'object', 'value'. Note that only flag nodes of type 'array' and 'object' can have child flag nodes. This is enforced using foreign key, specifically from the flag_nodes.parent_flag_node_type column. Only flag nodes of type 'value' can have flag_values assigned to them. This is also enforced using foreign key, specifically from the flag_values.flag_node_type column. */
  type?: InputMaybe<FlagNodeTypesEnum>;
};

/** aggregate sum on columns */
export type FlagNodesSumFields = {
  __typename?: 'FlagNodesSumFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Int']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Int']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flag_nodes" */
export type FlagNodesSumOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** update columns of table "flag_nodes" */
export enum FlagNodesUpdateColumn {
  /** column name */
  ArrayOrdinal = 'arrayOrdinal',
  /** column name */
  DefinedInScopeId = 'definedInScopeId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentFlagNodeScopeSnapshotId = 'parentFlagNodeScopeSnapshotId',
  /** column name */
  ParentScopeFlagNodeId = 'parentScopeFlagNodeId',
  /** column name */
  PropertyName = 'propertyName',
  /** column name */
  ScopeFlagNodeId = 'scopeFlagNodeId',
  /** column name */
  Type = 'type'
}

export type FlagNodesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlagNodesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlagNodesSetInput>;
  /** filter the rows which have to be updated */
  where: FlagNodesBoolExp;
};

/** aggregate varPop on columns */
export type FlagNodesVarPopFields = {
  __typename?: 'FlagNodesVarPopFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "flag_nodes" */
export type FlagNodesVarPopOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type FlagNodesVarSampFields = {
  __typename?: 'FlagNodesVarSampFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "flag_nodes" */
export type FlagNodesVarSampOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type FlagNodesVarianceFields = {
  __typename?: 'FlagNodesVarianceFields';
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal: Maybe<Scalars['Float']>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId: Maybe<Scalars['Float']>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flag_nodes" */
export type FlagNodesVarianceOrderBy = {
  /** The relative order of this flag_node (which is an array element) within it's parent flag node (which is an array). This is NOT necessarily an index - we only care about relative order. This means, even though ordinal 1 and 2 may not exist, we still know that ordinal 3 must come before ordinal 4. See inherited_flag_nodes to see how flag nodes are sorted currently, especially within it's scope snapshot inheritance tree. */
  arrayOrdinal?: InputMaybe<OrderBy>;
  /** The foreign key (scope_flag_node_id, defined_in_scope_id) -> scope_flag_nodes.(id, scope_id) along with the foreign key (defined_in_scope_snapshot_id, defined_in_scope_id) -> scope_snapshots.(id, scope_id) ensures that the related scope_flag_node as well as the related scope_snapshot belong to the same scope_id. */
  definedInScopeId?: InputMaybe<OrderBy>;
  /** Specifies the scope snapshot that this flag node is defined in. */
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The tuple (parent_scope_flag_node_id, parent_flag_node_scope_snapshot_id) specifies the parent flag node, which must belong to either the same scope snapshot or an ancestor scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** Reference to our abstract level scope flag node which helps us keep track of changes to the flag node from one scope version to the next. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

export enum FlagPathConflictRedundancyReason {
  AncestorFlagPathConflict = 'AncestorFlagPathConflict',
  AncestorScopeSnapshotInheritanceConflict = 'AncestorScopeSnapshotInheritanceConflict'
}

export enum FlagValueImportOptionOld {
  OnlyIfNoExistingValueAtAll = 'OnlyIfNoExistingValueAtAll',
  OnlyIfNoExistingValueInCurrentScopeSnapshot = 'OnlyIfNoExistingValueInCurrentScopeSnapshot',
  OnlyIfResultingInValueChange = 'OnlyIfResultingInValueChange',
  OverrideExistingValue = 'OverrideExistingValue',
  Skip = 'Skip'
}

/** Defines the available policies for handling flag values during configuration imports. */
export type FlagValueImportOptions = {
  __typename?: 'FlagValueImportOptions';
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description: Scalars['String'];
  /** Unique identifier for the flag value import option. */
  name: Scalars['String'];
  /** Display order of the import option. Lower values are displayed first. */
  ordinal: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "flag_value_import_options". All fields are combined with a logical 'AND'. */
export type FlagValueImportOptionsBoolExp = {
  _and?: InputMaybe<Array<FlagValueImportOptionsBoolExp>>;
  _not?: InputMaybe<FlagValueImportOptionsBoolExp>;
  _or?: InputMaybe<Array<FlagValueImportOptionsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "flag_value_import_options". */
export type FlagValueImportOptionsOrderBy = {
  description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
};

/** select columns of table "flag_value_import_options" */
export enum FlagValueImportOptionsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Ordinal = 'ordinal'
}

/** Streaming cursor of the table "flag_value_import_options" */
export type FlagValueImportOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FlagValueImportOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FlagValueImportOptionsStreamCursorValueInput = {
  /** Human-readable description of the import option. Stored as Markdown and intended to be rendered as Markdown by clients. */
  description?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the flag value import option. */
  name?: InputMaybe<Scalars['String']>;
  /** Display order of the import option. Lower values are displayed first. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/**  ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data). */
export type FlagValues = {
  __typename?: 'FlagValues';
  /** An object relationship */
  appliedInScopeSnapshot: ScopeSnapshots;
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Scalars['Int'];
  /** An object relationship */
  flagNode: Maybe<FlagNodes>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Scalars['Int'];
  id: Scalars['Int'];
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeFlagNode: ScopeFlagNodes;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Scalars['Int'];
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value: Maybe<Scalars['jsonb']>;
};


/**  ***IMPORTANT***: Make sure the refresh_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_inherited_valued_flag_nodes_trigger on the ivfn table to validate the final correct ivfn data (as opposed to failing on intermediate data). */
export type FlagValuesValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "flag_values" */
export type FlagValuesAggregate = {
  __typename?: 'FlagValuesAggregate';
  aggregate: FlagValuesAggregateFields;
  nodes: Array<FlagValues>;
};

export type FlagValuesAggregateBoolExp = {
  count?: InputMaybe<FlagValuesAggregateBoolExpCount>;
};

/** aggregate fields of "flag_values" */
export type FlagValuesAggregateFields = {
  __typename?: 'FlagValuesAggregateFields';
  avg: Maybe<FlagValuesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<FlagValuesMaxFields>;
  min: Maybe<FlagValuesMinFields>;
  stddev: Maybe<FlagValuesStddevFields>;
  stddevPop: Maybe<FlagValuesStddevPopFields>;
  stddevSamp: Maybe<FlagValuesStddevSampFields>;
  sum: Maybe<FlagValuesSumFields>;
  varPop: Maybe<FlagValuesVarPopFields>;
  varSamp: Maybe<FlagValuesVarSampFields>;
  variance: Maybe<FlagValuesVarianceFields>;
};


/** aggregate fields of "flag_values" */
export type FlagValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FlagValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flag_values" */
export type FlagValuesAggregateOrderBy = {
  avg?: InputMaybe<FlagValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FlagValuesMaxOrderBy>;
  min?: InputMaybe<FlagValuesMinOrderBy>;
  stddev?: InputMaybe<FlagValuesStddevOrderBy>;
  stddevPop?: InputMaybe<FlagValuesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<FlagValuesStddevSampOrderBy>;
  sum?: InputMaybe<FlagValuesSumOrderBy>;
  varPop?: InputMaybe<FlagValuesVarPopOrderBy>;
  varSamp?: InputMaybe<FlagValuesVarSampOrderBy>;
  variance?: InputMaybe<FlagValuesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FlagValuesAppendInput = {
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "flag_values" */
export type FlagValuesArrRelInsertInput = {
  data: Array<FlagValuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<FlagValuesOnConflict>;
};

/** aggregate avg on columns */
export type FlagValuesAvgFields = {
  __typename?: 'FlagValuesAvgFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flag_values" */
export type FlagValuesAvgOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "flag_values". All fields are combined with a logical 'AND'. */
export type FlagValuesBoolExp = {
  _and?: InputMaybe<Array<FlagValuesBoolExp>>;
  _not?: InputMaybe<FlagValuesBoolExp>;
  _or?: InputMaybe<Array<FlagValuesBoolExp>>;
  appliedInScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  appliedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  flagNode?: InputMaybe<FlagNodesBoolExp>;
  flagNodeScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  reuseValuesFromScopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesBoolExp>;
  scopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "flag_values" */
export enum FlagValuesConstraint {
  /** unique or primary key constraint on columns "id" */
  FlagNodeValuesPkey = 'flag_node_values_pkey',
  /** unique or primary key constraint on columns "id", "flag_node_scope_snapshot_id", "applied_in_scope_snapshot_id", "scope_flag_node_id", "flag_node_type" */
  FlagValuesIdScopeFlagNodeIdAppliedInScopeSnapshotId = 'flag_values_id_scope_flag_node_id_applied_in_scope_snapshot_id_',
  /** unique or primary key constraint on columns "applied_in_scope_snapshot_id", "scope_flag_node_id" */
  FlagValuesScopeFlagNodeIdAppliedInScopeSnapshotIdKey = 'flag_values_scope_flag_node_id_applied_in_scope_snapshot_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FlagValuesDeleteAtPathInput = {
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FlagValuesDeleteElemInput = {
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FlagValuesDeleteKeyInput = {
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "flag_values" */
export type FlagValuesIncInput = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "flag_values" */
export type FlagValuesInsertInput = {
  appliedInScopeSnapshot?: InputMaybe<ScopeSnapshotsObjRelInsertInput>;
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  flagNode?: InputMaybe<FlagNodesObjRelInsertInput>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesObjRelInsertInput>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type FlagValuesMaxFields = {
  __typename?: 'FlagValuesMaxFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flag_values" */
export type FlagValuesMaxOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FlagValuesMinFields = {
  __typename?: 'FlagValuesMinFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flag_values" */
export type FlagValuesMinOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "flag_values" */
export type FlagValuesMutationResponse = {
  __typename?: 'FlagValuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FlagValues>;
};

/** on_conflict condition type for table "flag_values" */
export type FlagValuesOnConflict = {
  constraint: FlagValuesConstraint;
  updateColumns?: Array<FlagValuesUpdateColumn>;
  where?: InputMaybe<FlagValuesBoolExp>;
};

/** Ordering options when selecting data from "flag_values". */
export type FlagValuesOrderBy = {
  appliedInScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  flagNode?: InputMaybe<FlagNodesOrderBy>;
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesOrderBy>;
  scopeFlagNodeId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: flag_values */
export type FlagValuesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FlagValuesPrependInput = {
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "flag_values" */
export enum FlagValuesSelectColumn {
  /** column name */
  AppliedInScopeSnapshotId = 'appliedInScopeSnapshotId',
  /** column name */
  FlagNodeScopeSnapshotId = 'flagNodeScopeSnapshotId',
  /** column name */
  Id = 'id',
  /** column name */
  ReuseValuesFromScopeFlagNodeId = 'reuseValuesFromScopeFlagNodeId',
  /** column name */
  ScopeFlagNodeId = 'scopeFlagNodeId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flag_values" */
export type FlagValuesSetInput = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type FlagValuesStddevFields = {
  __typename?: 'FlagValuesStddevFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flag_values" */
export type FlagValuesStddevOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type FlagValuesStddevPopFields = {
  __typename?: 'FlagValuesStddevPopFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "flag_values" */
export type FlagValuesStddevPopOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type FlagValuesStddevSampFields = {
  __typename?: 'FlagValuesStddevSampFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "flag_values" */
export type FlagValuesStddevSampOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "flag_values" */
export type FlagValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FlagValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FlagValuesStreamCursorValueInput = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Keep in mind there can potentially be two different types of nulls stored in a jsonb column: (1) The typical NULL of a sql column, and (2) The 'null'::jsonb value. In the interest of not mixing the two different types of nulls in this column, there is a check constraint to prevent storing 'null'::jsonb and this column is marked as nullable. So you can only store the sql NULL in it. Another reason to use NULL instead of 'null'::jsonb is that even the Hasura GraphQL API has no way of performing a mutation with 'null'::jsonb. In general, we allow storing NULL in the value field because it is useful in scenarios where you would want to override an inherited value with NULL. */
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type FlagValuesSumFields = {
  __typename?: 'FlagValuesSumFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flag_values" */
export type FlagValuesSumOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** update columns of table "flag_values" */
export enum FlagValuesUpdateColumn {
  /** column name */
  AppliedInScopeSnapshotId = 'appliedInScopeSnapshotId',
  /** column name */
  FlagNodeScopeSnapshotId = 'flagNodeScopeSnapshotId',
  /** column name */
  ScopeFlagNodeId = 'scopeFlagNodeId',
  /** column name */
  Value = 'value'
}

export type FlagValuesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FlagValuesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<FlagValuesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<FlagValuesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<FlagValuesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlagValuesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FlagValuesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlagValuesSetInput>;
  /** filter the rows which have to be updated */
  where: FlagValuesBoolExp;
};

/** aggregate varPop on columns */
export type FlagValuesVarPopFields = {
  __typename?: 'FlagValuesVarPopFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "flag_values" */
export type FlagValuesVarPopOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type FlagValuesVarSampFields = {
  __typename?: 'FlagValuesVarSampFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "flag_values" */
export type FlagValuesVarSampOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type FlagValuesVarianceFields = {
  __typename?: 'FlagValuesVarianceFields';
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId: Maybe<Scalars['Float']>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flag_values" */
export type FlagValuesVarianceOrderBy = {
  /** Specifies which scope snapshot this value is applied in, which must be either the same scope snapshot or a descendant scope snapshot of the flag node's scope snapshot (this is enforced by foreign key). */
  appliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. Note that we can actually change the flag_node_scope_snapshot_id and leave the scope_flag_node_id the same. This allows us to change the ancestor scope snapshot so long as there as equivalent scope_flag_node in the new ancestor scope snapshot. The new flag_node_scope_snapshot_id will be updated via a cascade update trigger. See the foreign key (applied_in_scope_snapshot_id, flag_node_scope_snapshot_id) → ss_inheritances.(scope_snapshot_id, ancestor_scope_snapshot_id) to see how this is done. */
  flagNodeScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Not used at all at the moment. Enforced as always NULL by a check constraint. Can be used in the future to allow a value to be reused across multiple flag nodes. */
  reuseValuesFromScopeFlagNodeId?: InputMaybe<OrderBy>;
  /** The tuple (scope_flag_node_id, flag_node_scope_snapshot_id) specifies which flag_node we are setting a value for. */
  scopeFlagNodeId?: InputMaybe<OrderBy>;
};

export type ImportedFlagNodesAndValues = {
  __typename?: 'ImportedFlagNodesAndValues';
  importedFlagNodesCount: Scalars['Int'];
  importedFlagValuesCount: Scalars['Int'];
};

export type IncompatibleFlagNode = {
  __typename?: 'IncompatibleFlagNode';
  arrayOrdinal: Maybe<Scalars['Int']>;
  definedInScopeSnapshotId: Scalars['Int'];
  flagPath: Array<Scalars['String']>;
  id: Scalars['Int'];
  propertyName: Maybe<Scalars['String']>;
  scopeFlagNodeId: Scalars['Int'];
  type: Scalars['String'];
  valuedFlagAsJsonExtract: Scalars['jsonb'];
};

export type IncompatibleFlagValue = {
  __typename?: 'IncompatibleFlagValue';
  appliedInScopeSnapshotId: Scalars['Int'];
  flagNodeScopeSnapshotId: Scalars['Int'];
  flagPath: Array<Scalars['String']>;
  id: Scalars['Int'];
  scopeFlagNodeId: Scalars['Int'];
  value: Scalars['jsonb'];
  valuedFlagAsJsonExtract: Scalars['jsonb'];
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type InetComparisonExp = {
  _eq?: InputMaybe<Scalars['inet']>;
  _gt?: InputMaybe<Scalars['inet']>;
  _gte?: InputMaybe<Scalars['inet']>;
  _in?: InputMaybe<Array<Scalars['inet']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['inet']>;
  _lte?: InputMaybe<Scalars['inet']>;
  _neq?: InputMaybe<Scalars['inet']>;
  _nin?: InputMaybe<Array<Scalars['inet']>>;
};

/** DO NOT UPDATE THIS TABLE MANUALLY! It is only to be automatically updated by the trigger functions on the flag_nodes, flag_values, and ss_inheritances tables whenever it's rows are inserted/updated/deleted. Also, although this inherited_valued_flag_nodes table may seem like a duplicate of the inherited_valued_flag_nodes function, this table serves a different purpose: It's so that we can enforce a unique constraint on (target_scope_snapshot_id, flag_jsonpath). This unique constraint gives us unique flag paths across a scope snapshot's entire inheritance tree. The rest of the check constraints in here however, do not actually necessitate the creation of this table - they are merely here to ensure that the refresh ivfn trigger continues to give us valid ivfn rows (so think of them as enforced test cases, or invariants). ***IMPORTANT***: Make sure the ensure_integrity_of_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction and validates the final correct ivfn data (as opposed to failing on intermediate data). Also, if you modify this table schema, make sure to update ensure_integrity_of_inherited_valued_flag_nodes_trigger (and its internal function calls, if any) accordingly. The foreign keys are marked as NOT VALID NOT ENFORCED because its necessary to prevent any sort of cascade updates/deletes from other tables like flag nodes, flag values etc. since we strictly want the ivfn pipeline to update this table, not cascades. Specifically, if we did allow for a cascade update, the table could potentially result in violating the (target_scope_snapshot_id, flag_node_id) unique constraint (even though it would be a temporary violation). The NOT ENFORCED part of the foreign keys prevents this. Additionally, the unique constraints are also marked as DEFERRABLE INITIALLY DEFERRED and this is necessary because you don't want them to fail when the refresh ivfn function is updating the rows in this table. The only exception to this is the (target_scope_snapshot_id, flag_node_id) unique constraint - this is a non deferrable constraint only because that's the only way we can create a foreign key on flag_nodes to point back here (using the foreign key name flag_nodes_canonical_valued_flag_node). */
export type InheritedValuedFlagNodes = {
  __typename?: 'InheritedValuedFlagNodes';
  /** This is the array index (starts at 0) of an array element within its parent flag node. Only available in this table as it cannot be available in flag_nodes, since we need to compute an ivfn refresh to calculate the final array index. */
  arrayIndex: Maybe<Scalars['Int']>;
  /** Same as flag_node.array_ordinal. Simply here to re-ensure the validity of this value returned by the refresh ivfn function - see check constraints for more info. */
  arrayOrdinal: Maybe<Scalars['Int']>;
  /** An object relationship */
  definedInScopeSnapshot: ScopeSnapshots;
  /** Same as flag_nodes.defined_in_scope_snapshot_id. */
  definedInScopeSnapshotId: Scalars['Int'];
  /** The final, effective value for this flag node after considering all inherited values. Null if either there is no flag value applied to this flag node within this ss inheritance tree, or the actual effective value is null. To determine which, simply check if flag_value_id is null. Remember, just like flag_nodes.value, only the SQL NULL is allowed, not null::jsonb, and there is a check constraint here to enforce this as well. */
  effectiveValue: Maybe<Scalars['jsonb']>;
  /** Like flag_path, except in postgres' jsonpath type. */
  flagJsonpath: Scalars['jsonpath'];
  /** flag_jsonpath casted to text so that we can enforce (inherited_in_scope_snapshot_id, flag_jsonpath_text) unique constraint, giving us unique flag paths across a scope snapshot's entire inheritance tree. */
  flagJsonpathText: Scalars['String'];
  /** An object relationship */
  flagNode: FlagNodes;
  /** Same as flag_nodes.id. */
  flagNodeId: Scalars['Int'];
  /** Same as flag_nodes.type. */
  flagNodeType: Scalars['String'];
  /** An object relationship */
  flagValue: Maybe<FlagValues>;
  /** An object relationship */
  flagValueAppliedInScopeSnapshot: Maybe<ScopeSnapshots>;
  /** Same as flag_values.applied_in_scope_snapshot_id. Null if there is no flag_value for this flag_node in this ss inheritance tree. */
  flagValueAppliedInScopeSnapshotId: Maybe<Scalars['Int']>;
  /** Same as flag_values.id. Null if there is no flag_value for this flag_node in this ss inheritance tree. */
  flagValueId: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** Use this as the canonical order for the ivfns of a target scope snapshot. */
  ordinalWithinIfns: Scalars['Int'];
  /** An object relationship */
  parentFlagNodeScopeSnapshot: Maybe<ScopeSnapshots>;
  /** An object relationship */
  parentScopeFlagNode: Maybe<ScopeFlagNodes>;
  /** Same as flag_nodes.parent_scope_flag_node_id. */
  parentScopeFlagNodeId: Maybe<Scalars['Int']>;
  /** Same as flag_nodes.property_name. */
  propertyName: Maybe<Scalars['String']>;
  /** Needed here to ensure (via a check constraint) that flag_path's last element = property_name_or_array_index. */
  propertyNameOrArrayIndex: Scalars['String'];
  /** An object relationship */
  scopeFlagNode: ScopeFlagNodes;
  /** Same as flag_nodes.scope_flag_node_id. */
  scopeFlagNodeId: Scalars['Int'];
  /** An object relationship */
  targetScopeSnapshot: ScopeSnapshots;
  /** The scope snapshot for which this row represents the inherited flag node and value. It does not necessarily indicate the snapshot where the flag node or value was originally defined. In many cases, however, defined_in_scope_snapshot_id will indeed be identical to target_scope_snapshot_id, because, remember, every scope snapshot inherits itself (per the ss_inheritances table). */
  targetScopeSnapshotId: Scalars['Int'];
};


/** DO NOT UPDATE THIS TABLE MANUALLY! It is only to be automatically updated by the trigger functions on the flag_nodes, flag_values, and ss_inheritances tables whenever it's rows are inserted/updated/deleted. Also, although this inherited_valued_flag_nodes table may seem like a duplicate of the inherited_valued_flag_nodes function, this table serves a different purpose: It's so that we can enforce a unique constraint on (target_scope_snapshot_id, flag_jsonpath). This unique constraint gives us unique flag paths across a scope snapshot's entire inheritance tree. The rest of the check constraints in here however, do not actually necessitate the creation of this table - they are merely here to ensure that the refresh ivfn trigger continues to give us valid ivfn rows (so think of them as enforced test cases, or invariants). ***IMPORTANT***: Make sure the ensure_integrity_of_inherited_valued_flag_nodes_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction and validates the final correct ivfn data (as opposed to failing on intermediate data). Also, if you modify this table schema, make sure to update ensure_integrity_of_inherited_valued_flag_nodes_trigger (and its internal function calls, if any) accordingly. The foreign keys are marked as NOT VALID NOT ENFORCED because its necessary to prevent any sort of cascade updates/deletes from other tables like flag nodes, flag values etc. since we strictly want the ivfn pipeline to update this table, not cascades. Specifically, if we did allow for a cascade update, the table could potentially result in violating the (target_scope_snapshot_id, flag_node_id) unique constraint (even though it would be a temporary violation). The NOT ENFORCED part of the foreign keys prevents this. Additionally, the unique constraints are also marked as DEFERRABLE INITIALLY DEFERRED and this is necessary because you don't want them to fail when the refresh ivfn function is updating the rows in this table. The only exception to this is the (target_scope_snapshot_id, flag_node_id) unique constraint - this is a non deferrable constraint only because that's the only way we can create a foreign key on flag_nodes to point back here (using the foreign key name flag_nodes_canonical_valued_flag_node). */
export type InheritedValuedFlagNodesEffectiveValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "inherited_valued_flag_nodes". All fields are combined with a logical 'AND'. */
export type InheritedValuedFlagNodesBoolExp = {
  _and?: InputMaybe<Array<InheritedValuedFlagNodesBoolExp>>;
  _not?: InputMaybe<InheritedValuedFlagNodesBoolExp>;
  _or?: InputMaybe<Array<InheritedValuedFlagNodesBoolExp>>;
  arrayIndex?: InputMaybe<IntComparisonExp>;
  arrayOrdinal?: InputMaybe<IntComparisonExp>;
  definedInScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  definedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  effectiveValue?: InputMaybe<JsonbComparisonExp>;
  flagJsonpath?: InputMaybe<JsonpathComparisonExp>;
  flagJsonpathText?: InputMaybe<StringComparisonExp>;
  flagNode?: InputMaybe<FlagNodesBoolExp>;
  flagNodeId?: InputMaybe<IntComparisonExp>;
  flagNodeType?: InputMaybe<StringComparisonExp>;
  flagValue?: InputMaybe<FlagValuesBoolExp>;
  flagValueAppliedInScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  flagValueAppliedInScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  flagValueId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  ordinalWithinIfns?: InputMaybe<IntComparisonExp>;
  parentFlagNodeScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  parentScopeFlagNode?: InputMaybe<ScopeFlagNodesBoolExp>;
  parentScopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  propertyName?: InputMaybe<StringComparisonExp>;
  propertyNameOrArrayIndex?: InputMaybe<StringComparisonExp>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesBoolExp>;
  scopeFlagNodeId?: InputMaybe<IntComparisonExp>;
  targetScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  targetScopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "inherited_valued_flag_nodes". */
export type InheritedValuedFlagNodesOrderBy = {
  arrayIndex?: InputMaybe<OrderBy>;
  arrayOrdinal?: InputMaybe<OrderBy>;
  definedInScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  definedInScopeSnapshotId?: InputMaybe<OrderBy>;
  effectiveValue?: InputMaybe<OrderBy>;
  flagJsonpath?: InputMaybe<OrderBy>;
  flagJsonpathText?: InputMaybe<OrderBy>;
  flagNode?: InputMaybe<FlagNodesOrderBy>;
  flagNodeId?: InputMaybe<OrderBy>;
  flagNodeType?: InputMaybe<OrderBy>;
  flagValue?: InputMaybe<FlagValuesOrderBy>;
  flagValueAppliedInScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  flagValueAppliedInScopeSnapshotId?: InputMaybe<OrderBy>;
  flagValueId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinalWithinIfns?: InputMaybe<OrderBy>;
  parentFlagNodeScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  parentScopeFlagNode?: InputMaybe<ScopeFlagNodesOrderBy>;
  parentScopeFlagNodeId?: InputMaybe<OrderBy>;
  propertyName?: InputMaybe<OrderBy>;
  propertyNameOrArrayIndex?: InputMaybe<OrderBy>;
  scopeFlagNode?: InputMaybe<ScopeFlagNodesOrderBy>;
  scopeFlagNodeId?: InputMaybe<OrderBy>;
  targetScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  targetScopeSnapshotId?: InputMaybe<OrderBy>;
};

/** select columns of table "inherited_valued_flag_nodes" */
export enum InheritedValuedFlagNodesSelectColumn {
  /** column name */
  ArrayIndex = 'arrayIndex',
  /** column name */
  ArrayOrdinal = 'arrayOrdinal',
  /** column name */
  DefinedInScopeSnapshotId = 'definedInScopeSnapshotId',
  /** column name */
  EffectiveValue = 'effectiveValue',
  /** column name */
  FlagJsonpath = 'flagJsonpath',
  /** column name */
  FlagJsonpathText = 'flagJsonpathText',
  /** column name */
  FlagNodeId = 'flagNodeId',
  /** column name */
  FlagNodeType = 'flagNodeType',
  /** column name */
  FlagValueAppliedInScopeSnapshotId = 'flagValueAppliedInScopeSnapshotId',
  /** column name */
  FlagValueId = 'flagValueId',
  /** column name */
  Id = 'id',
  /** column name */
  OrdinalWithinIfns = 'ordinalWithinIfns',
  /** column name */
  ParentScopeFlagNodeId = 'parentScopeFlagNodeId',
  /** column name */
  PropertyName = 'propertyName',
  /** column name */
  PropertyNameOrArrayIndex = 'propertyNameOrArrayIndex',
  /** column name */
  ScopeFlagNodeId = 'scopeFlagNodeId',
  /** column name */
  TargetScopeSnapshotId = 'targetScopeSnapshotId'
}

/** Streaming cursor of the table "inherited_valued_flag_nodes" */
export type InheritedValuedFlagNodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InheritedValuedFlagNodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InheritedValuedFlagNodesStreamCursorValueInput = {
  /** This is the array index (starts at 0) of an array element within its parent flag node. Only available in this table as it cannot be available in flag_nodes, since we need to compute an ivfn refresh to calculate the final array index. */
  arrayIndex?: InputMaybe<Scalars['Int']>;
  /** Same as flag_node.array_ordinal. Simply here to re-ensure the validity of this value returned by the refresh ivfn function - see check constraints for more info. */
  arrayOrdinal?: InputMaybe<Scalars['Int']>;
  /** Same as flag_nodes.defined_in_scope_snapshot_id. */
  definedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** The final, effective value for this flag node after considering all inherited values. Null if either there is no flag value applied to this flag node within this ss inheritance tree, or the actual effective value is null. To determine which, simply check if flag_value_id is null. Remember, just like flag_nodes.value, only the SQL NULL is allowed, not null::jsonb, and there is a check constraint here to enforce this as well. */
  effectiveValue?: InputMaybe<Scalars['jsonb']>;
  /** Like flag_path, except in postgres' jsonpath type. */
  flagJsonpath?: InputMaybe<Scalars['jsonpath']>;
  /** flag_jsonpath casted to text so that we can enforce (inherited_in_scope_snapshot_id, flag_jsonpath_text) unique constraint, giving us unique flag paths across a scope snapshot's entire inheritance tree. */
  flagJsonpathText?: InputMaybe<Scalars['String']>;
  /** Same as flag_nodes.id. */
  flagNodeId?: InputMaybe<Scalars['Int']>;
  /** Same as flag_nodes.type. */
  flagNodeType?: InputMaybe<Scalars['String']>;
  /** Same as flag_values.applied_in_scope_snapshot_id. Null if there is no flag_value for this flag_node in this ss inheritance tree. */
  flagValueAppliedInScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  /** Same as flag_values.id. Null if there is no flag_value for this flag_node in this ss inheritance tree. */
  flagValueId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Use this as the canonical order for the ivfns of a target scope snapshot. */
  ordinalWithinIfns?: InputMaybe<Scalars['Int']>;
  /** Same as flag_nodes.parent_scope_flag_node_id. */
  parentScopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** Same as flag_nodes.property_name. */
  propertyName?: InputMaybe<Scalars['String']>;
  /** Needed here to ensure (via a check constraint) that flag_path's last element = property_name_or_array_index. */
  propertyNameOrArrayIndex?: InputMaybe<Scalars['String']>;
  /** Same as flag_nodes.scope_flag_node_id. */
  scopeFlagNodeId?: InputMaybe<Scalars['Int']>;
  /** The scope snapshot for which this row represents the inherited flag node and value. It does not necessarily indicate the snapshot where the flag node or value was originally defined. In many cases, however, defined_in_scope_snapshot_id will indeed be identical to target_scope_snapshot_id, because, remember, every scope snapshot inherits itself (per the ss_inheritances table). */
  targetScopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

export type InsertSsDirectInheritance = {
  __typename?: 'InsertSsDirectInheritance';
  directlyInheritedScopeId: Scalars['Int'];
  directlyInheritedScopeSnapshotId: Scalars['Int'];
  ordinal: Scalars['Int'];
  scopeSnapshotId: Scalars['Int'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['Int']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']>>;
  _eq?: InputMaybe<Array<Scalars['Int']>>;
  _gt?: InputMaybe<Array<Scalars['Int']>>;
  _gte?: InputMaybe<Array<Scalars['Int']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['Int']>>;
  _lte?: InputMaybe<Array<Scalars['Int']>>;
  _neq?: InputMaybe<Array<Scalars['Int']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonbPathExists?: InputMaybe<Scalars['String']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonbPathMatch?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** Boolean expression to compare columns of type "jsonpath". All fields are combined with logical 'AND'. */
export type JsonpathComparisonExp = {
  _eq?: InputMaybe<Scalars['jsonpath']>;
  _gt?: InputMaybe<Scalars['jsonpath']>;
  _gte?: InputMaybe<Scalars['jsonpath']>;
  _in?: InputMaybe<Array<Scalars['jsonpath']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonpath']>;
  _lte?: InputMaybe<Scalars['jsonpath']>;
  _neq?: InputMaybe<Scalars['jsonpath']>;
  _nin?: InputMaybe<Array<Scalars['jsonpath']>>;
};

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'Logs';
  action: Scalars['String'];
  actionTstampClk: Scalars['timestamptz'];
  actionTstampStm: Scalars['timestamptz'];
  actionTstampTx: Scalars['timestamptz'];
  changedFields: Maybe<Scalars['jsonb']>;
  clientAddr: Maybe<Scalars['inet']>;
  id: Scalars['Int'];
  rowData: Maybe<Scalars['jsonb']>;
  tableName: Scalars['String'];
  tenantId: Maybe<Scalars['uuid']>;
  transactionId: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['String']>;
};


/** columns and relationships of "logs" */
export type LogsChangedFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "logs" */
export type LogsRowDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "logs" */
export type LogsAggregate = {
  __typename?: 'LogsAggregate';
  aggregate: LogsAggregateFields;
  nodes: Array<Logs>;
};

/** aggregate fields of "logs" */
export type LogsAggregateFields = {
  __typename?: 'LogsAggregateFields';
  avg: Maybe<LogsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<LogsMaxFields>;
  min: Maybe<LogsMinFields>;
  stddev: Maybe<LogsStddevFields>;
  stddevPop: Maybe<LogsStddevPopFields>;
  stddevSamp: Maybe<LogsStddevSampFields>;
  sum: Maybe<LogsSumFields>;
  varPop: Maybe<LogsVarPopFields>;
  varSamp: Maybe<LogsVarSampFields>;
  variance: Maybe<LogsVarianceFields>;
};


/** aggregate fields of "logs" */
export type LogsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LogsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LogsAvgFields = {
  __typename?: 'LogsAvgFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type LogsBoolExp = {
  _and?: InputMaybe<Array<LogsBoolExp>>;
  _not?: InputMaybe<LogsBoolExp>;
  _or?: InputMaybe<Array<LogsBoolExp>>;
  action?: InputMaybe<StringComparisonExp>;
  actionTstampClk?: InputMaybe<TimestamptzComparisonExp>;
  actionTstampStm?: InputMaybe<TimestamptzComparisonExp>;
  actionTstampTx?: InputMaybe<TimestamptzComparisonExp>;
  changedFields?: InputMaybe<JsonbComparisonExp>;
  clientAddr?: InputMaybe<InetComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  rowData?: InputMaybe<JsonbComparisonExp>;
  tableName?: InputMaybe<StringComparisonExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  transactionId?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type LogsMaxFields = {
  __typename?: 'LogsMaxFields';
  action: Maybe<Scalars['String']>;
  actionTstampClk: Maybe<Scalars['timestamptz']>;
  actionTstampStm: Maybe<Scalars['timestamptz']>;
  actionTstampTx: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  tableName: Maybe<Scalars['String']>;
  tenantId: Maybe<Scalars['uuid']>;
  transactionId: Maybe<Scalars['bigint']>;
  userId: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LogsMinFields = {
  __typename?: 'LogsMinFields';
  action: Maybe<Scalars['String']>;
  actionTstampClk: Maybe<Scalars['timestamptz']>;
  actionTstampStm: Maybe<Scalars['timestamptz']>;
  actionTstampTx: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  tableName: Maybe<Scalars['String']>;
  tenantId: Maybe<Scalars['uuid']>;
  transactionId: Maybe<Scalars['bigint']>;
  userId: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "logs". */
export type LogsOrderBy = {
  action?: InputMaybe<OrderBy>;
  actionTstampClk?: InputMaybe<OrderBy>;
  actionTstampStm?: InputMaybe<OrderBy>;
  actionTstampTx?: InputMaybe<OrderBy>;
  changedFields?: InputMaybe<OrderBy>;
  clientAddr?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rowData?: InputMaybe<OrderBy>;
  tableName?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "logs" */
export enum LogsSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstampClk = 'actionTstampClk',
  /** column name */
  ActionTstampStm = 'actionTstampStm',
  /** column name */
  ActionTstampTx = 'actionTstampTx',
  /** column name */
  ChangedFields = 'changedFields',
  /** column name */
  ClientAddr = 'clientAddr',
  /** column name */
  Id = 'id',
  /** column name */
  RowData = 'rowData',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type LogsStddevFields = {
  __typename?: 'LogsStddevFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type LogsStddevPopFields = {
  __typename?: 'LogsStddevPopFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type LogsStddevSampFields = {
  __typename?: 'LogsStddevSampFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "logs" */
export type LogsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LogsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LogsStreamCursorValueInput = {
  action?: InputMaybe<Scalars['String']>;
  actionTstampClk?: InputMaybe<Scalars['timestamptz']>;
  actionTstampStm?: InputMaybe<Scalars['timestamptz']>;
  actionTstampTx?: InputMaybe<Scalars['timestamptz']>;
  changedFields?: InputMaybe<Scalars['jsonb']>;
  clientAddr?: InputMaybe<Scalars['inet']>;
  id?: InputMaybe<Scalars['Int']>;
  rowData?: InputMaybe<Scalars['jsonb']>;
  tableName?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  transactionId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LogsSumFields = {
  __typename?: 'LogsSumFields';
  id: Maybe<Scalars['Int']>;
  transactionId: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type LogsVarPopFields = {
  __typename?: 'LogsVarPopFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type LogsVarSampFields = {
  __typename?: 'LogsVarSampFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LogsVarianceFields = {
  __typename?: 'LogsVarianceFields';
  id: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['Float']>;
};

export type OneSsInheritanceModifications = {
  expectedJsonConfigurationHashes?: InputMaybe<ExpectedJsonConfigurationHashes>;
  replacementScopeSnapshotIdsToDirectlyInherit?: InputMaybe<Array<Scalars['Int']>>;
  targetScopeSnapshotId: Scalars['Int'];
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type PrimitiveScopeSnapshot = {
  __typename?: 'PrimitiveScopeSnapshot';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
};

export type PrimitiveScopeSnapshotWithValidationDifference = {
  __typename?: 'PrimitiveScopeSnapshotWithValidationDifference';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  savedInheritance: Maybe<SavedSsInheritance>;
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
  validatedDirectParentIds: Array<Scalars['Int']>;
  validatedInheritances: Array<ValidatedSsInheritanceForDescendantSs>;
};

export type ReplicatedFlagsAndValues = {
  __typename?: 'ReplicatedFlagsAndValues';
  replicatedFlagsCount: Scalars['Int'];
  replicatedValuesCount: Scalars['Int'];
};

export type ReplicatedScopeSnapshot = {
  __typename?: 'ReplicatedScopeSnapshot';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  scopeId: Scalars['Int'];
  scopeSnapshot: Maybe<ScopeSnapshots>;
  scopeVersion: Scalars['String'];
};

/** Defines which scopes that a given role is allowed to edit. */
export type RoleScopes = {
  __typename?: 'RoleScopes';
  flagEditPermissionOverride: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['Int'];
  /** An object relationship */
  scope: Scopes;
  scopeId: Scalars['Int'];
  valueEditPermissionOverride: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "role_scopes" */
export type RoleScopesAggregate = {
  __typename?: 'RoleScopesAggregate';
  aggregate: Maybe<RoleScopesAggregateFields>;
  nodes: Array<RoleScopes>;
};

export type RoleScopesAggregateBoolExp = {
  bool_and?: InputMaybe<RoleScopesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RoleScopesAggregateBoolExpBoolOr>;
  count?: InputMaybe<RoleScopesAggregateBoolExpCount>;
};

/** aggregate fields of "role_scopes" */
export type RoleScopesAggregateFields = {
  __typename?: 'RoleScopesAggregateFields';
  avg: Maybe<RoleScopesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<RoleScopesMaxFields>;
  min: Maybe<RoleScopesMinFields>;
  stddev: Maybe<RoleScopesStddevFields>;
  stddevPop: Maybe<RoleScopesStddevPopFields>;
  stddevSamp: Maybe<RoleScopesStddevSampFields>;
  sum: Maybe<RoleScopesSumFields>;
  varPop: Maybe<RoleScopesVarPopFields>;
  varSamp: Maybe<RoleScopesVarSampFields>;
  variance: Maybe<RoleScopesVarianceFields>;
};


/** aggregate fields of "role_scopes" */
export type RoleScopesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RoleScopesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "role_scopes" */
export type RoleScopesAggregateOrderBy = {
  avg?: InputMaybe<RoleScopesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RoleScopesMaxOrderBy>;
  min?: InputMaybe<RoleScopesMinOrderBy>;
  stddev?: InputMaybe<RoleScopesStddevOrderBy>;
  stddevPop?: InputMaybe<RoleScopesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<RoleScopesStddevSampOrderBy>;
  sum?: InputMaybe<RoleScopesSumOrderBy>;
  varPop?: InputMaybe<RoleScopesVarPopOrderBy>;
  varSamp?: InputMaybe<RoleScopesVarSampOrderBy>;
  variance?: InputMaybe<RoleScopesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "role_scopes" */
export type RoleScopesArrRelInsertInput = {
  data: Array<RoleScopesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RoleScopesOnConflict>;
};

/** aggregate avg on columns */
export type RoleScopesAvgFields = {
  __typename?: 'RoleScopesAvgFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "role_scopes" */
export type RoleScopesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "role_scopes". All fields are combined with a logical 'AND'. */
export type RoleScopesBoolExp = {
  _and?: InputMaybe<Array<RoleScopesBoolExp>>;
  _not?: InputMaybe<RoleScopesBoolExp>;
  _or?: InputMaybe<Array<RoleScopesBoolExp>>;
  flagEditPermissionOverride?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  role?: InputMaybe<RolesBoolExp>;
  roleId?: InputMaybe<IntComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  valueEditPermissionOverride?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "role_scopes" */
export enum RoleScopesConstraint {
  /** unique or primary key constraint on columns "id" */
  RoleScopesPkey = 'role_scopes_pkey',
  /** unique or primary key constraint on columns "scope_id", "role_id" */
  RoleScopesRoleIdScopeIdKey = 'role_scopes_role_id_scope_id_key'
}

/** input type for incrementing numeric columns in table "role_scopes" */
export type RoleScopesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "role_scopes" */
export type RoleScopesInsertInput = {
  flagEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<RolesObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopesObjRelInsertInput>;
  scopeId?: InputMaybe<Scalars['Int']>;
  valueEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type RoleScopesMaxFields = {
  __typename?: 'RoleScopesMaxFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "role_scopes" */
export type RoleScopesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RoleScopesMinFields = {
  __typename?: 'RoleScopesMinFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "role_scopes" */
export type RoleScopesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "role_scopes" */
export type RoleScopesMutationResponse = {
  __typename?: 'RoleScopesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RoleScopes>;
};

/** on_conflict condition type for table "role_scopes" */
export type RoleScopesOnConflict = {
  constraint: RoleScopesConstraint;
  updateColumns?: Array<RoleScopesUpdateColumn>;
  where?: InputMaybe<RoleScopesBoolExp>;
};

/** Ordering options when selecting data from "role_scopes". */
export type RoleScopesOrderBy = {
  flagEditPermissionOverride?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  role?: InputMaybe<RolesOrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  valueEditPermissionOverride?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: role_scopes */
export type RoleScopesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "role_scopes" */
export enum RoleScopesSelectColumn {
  /** column name */
  FlagEditPermissionOverride = 'flagEditPermissionOverride',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ValueEditPermissionOverride = 'valueEditPermissionOverride'
}

/** select "roleScopesAggregateBoolExpBool_andArgumentsColumns" columns of table "role_scopes" */
export enum RoleScopesSelectColumnRoleScopesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FlagEditPermissionOverride = 'flagEditPermissionOverride',
  /** column name */
  ValueEditPermissionOverride = 'valueEditPermissionOverride'
}

/** select "roleScopesAggregateBoolExpBool_orArgumentsColumns" columns of table "role_scopes" */
export enum RoleScopesSelectColumnRoleScopesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FlagEditPermissionOverride = 'flagEditPermissionOverride',
  /** column name */
  ValueEditPermissionOverride = 'valueEditPermissionOverride'
}

/** input type for updating data in table "role_scopes" */
export type RoleScopesSetInput = {
  flagEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  valueEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type RoleScopesStddevFields = {
  __typename?: 'RoleScopesStddevFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "role_scopes" */
export type RoleScopesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type RoleScopesStddevPopFields = {
  __typename?: 'RoleScopesStddevPopFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "role_scopes" */
export type RoleScopesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type RoleScopesStddevSampFields = {
  __typename?: 'RoleScopesStddevSampFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "role_scopes" */
export type RoleScopesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "role_scopes" */
export type RoleScopesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RoleScopesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RoleScopesStreamCursorValueInput = {
  flagEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  valueEditPermissionOverride?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type RoleScopesSumFields = {
  __typename?: 'RoleScopesSumFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "role_scopes" */
export type RoleScopesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** update columns of table "role_scopes" */
export enum RoleScopesUpdateColumn {
  /** column name */
  FlagEditPermissionOverride = 'flagEditPermissionOverride',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ValueEditPermissionOverride = 'valueEditPermissionOverride'
}

export type RoleScopesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoleScopesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoleScopesSetInput>;
  /** filter the rows which have to be updated */
  where: RoleScopesBoolExp;
};

/** aggregate varPop on columns */
export type RoleScopesVarPopFields = {
  __typename?: 'RoleScopesVarPopFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "role_scopes" */
export type RoleScopesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type RoleScopesVarSampFields = {
  __typename?: 'RoleScopesVarSampFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "role_scopes" */
export type RoleScopesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RoleScopesVarianceFields = {
  __typename?: 'RoleScopesVarianceFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "role_scopes" */
export type RoleScopesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Roles such as 'engineer' or 'manager'. These will be used for defining permissions for different parts of the site such as being able to edit values or flags. */
export type Roles = {
  __typename?: 'Roles';
  flagEditPermission: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  roleScopes: Array<RoleScopes>;
  /** An aggregate relationship */
  roleScopesAggregate: RoleScopesAggregate;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  valueEditPermission: Scalars['Boolean'];
};


/** Roles such as 'engineer' or 'manager'. These will be used for defining permissions for different parts of the site such as being able to edit values or flags. */
export type RolesRoleScopesArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


/** Roles such as 'engineer' or 'manager'. These will be used for defining permissions for different parts of the site such as being able to edit values or flags. */
export type RolesRoleScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


/** Roles such as 'engineer' or 'manager'. These will be used for defining permissions for different parts of the site such as being able to edit values or flags. */
export type RolesUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** Roles such as 'engineer' or 'manager'. These will be used for defining permissions for different parts of the site such as being able to edit values or flags. */
export type RolesUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};

/** aggregated selection of "roles" */
export type RolesAggregate = {
  __typename?: 'RolesAggregate';
  aggregate: Maybe<RolesAggregateFields>;
  nodes: Array<Roles>;
};

export type RolesAggregateBoolExp = {
  bool_and?: InputMaybe<RolesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RolesAggregateBoolExpBoolOr>;
  count?: InputMaybe<RolesAggregateBoolExpCount>;
};

/** aggregate fields of "roles" */
export type RolesAggregateFields = {
  __typename?: 'RolesAggregateFields';
  avg: Maybe<RolesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<RolesMaxFields>;
  min: Maybe<RolesMinFields>;
  stddev: Maybe<RolesStddevFields>;
  stddevPop: Maybe<RolesStddevPopFields>;
  stddevSamp: Maybe<RolesStddevSampFields>;
  sum: Maybe<RolesSumFields>;
  varPop: Maybe<RolesVarPopFields>;
  varSamp: Maybe<RolesVarSampFields>;
  variance: Maybe<RolesVarianceFields>;
};


/** aggregate fields of "roles" */
export type RolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RolesAvgFields = {
  __typename?: 'RolesAvgFields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: InputMaybe<Array<RolesBoolExp>>;
  _not?: InputMaybe<RolesBoolExp>;
  _or?: InputMaybe<Array<RolesBoolExp>>;
  flagEditPermission?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  roleScopes?: InputMaybe<RoleScopesBoolExp>;
  roleScopesAggregate?: InputMaybe<RoleScopesAggregateBoolExp>;
  userRoles?: InputMaybe<UserRolesBoolExp>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateBoolExp>;
  valueEditPermission?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "roles" */
export enum RolesConstraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  RolesNameTenantIdKey = 'roles_name_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "roles" */
export type RolesInsertInput = {
  flagEditPermission?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roleScopes?: InputMaybe<RoleScopesArrRelInsertInput>;
  userRoles?: InputMaybe<UserRolesArrRelInsertInput>;
  valueEditPermission?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type RolesMaxFields = {
  __typename?: 'RolesMaxFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RolesMinFields = {
  __typename?: 'RolesMinFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type RolesMutationResponse = {
  __typename?: 'RolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type RolesObjRelInsertInput = {
  data: RolesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RolesOnConflict>;
};

/** on_conflict condition type for table "roles" */
export type RolesOnConflict = {
  constraint: RolesConstraint;
  updateColumns?: Array<RolesUpdateColumn>;
  where?: InputMaybe<RolesBoolExp>;
};

/** Ordering options when selecting data from "roles". */
export type RolesOrderBy = {
  flagEditPermission?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  roleScopesAggregate?: InputMaybe<RoleScopesAggregateOrderBy>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateOrderBy>;
  valueEditPermission?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: roles */
export type RolesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "roles" */
export enum RolesSelectColumn {
  /** column name */
  FlagEditPermission = 'flagEditPermission',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ValueEditPermission = 'valueEditPermission'
}

/** select "rolesAggregateBoolExpBool_andArgumentsColumns" columns of table "roles" */
export enum RolesSelectColumnRolesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FlagEditPermission = 'flagEditPermission',
  /** column name */
  ValueEditPermission = 'valueEditPermission'
}

/** select "rolesAggregateBoolExpBool_orArgumentsColumns" columns of table "roles" */
export enum RolesSelectColumnRolesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FlagEditPermission = 'flagEditPermission',
  /** column name */
  ValueEditPermission = 'valueEditPermission'
}

/** input type for updating data in table "roles" */
export type RolesSetInput = {
  flagEditPermission?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  valueEditPermission?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type RolesStddevFields = {
  __typename?: 'RolesStddevFields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type RolesStddevPopFields = {
  __typename?: 'RolesStddevPopFields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type RolesStddevSampFields = {
  __typename?: 'RolesStddevSampFields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "roles" */
export type RolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RolesStreamCursorValueInput = {
  flagEditPermission?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  valueEditPermission?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type RolesSumFields = {
  __typename?: 'RolesSumFields';
  id: Maybe<Scalars['Int']>;
};

/** update columns of table "roles" */
export enum RolesUpdateColumn {
  /** column name */
  FlagEditPermission = 'flagEditPermission',
  /** column name */
  Name = 'name',
  /** column name */
  ValueEditPermission = 'valueEditPermission'
}

export type RolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RolesSetInput>;
  /** filter the rows which have to be updated */
  where: RolesBoolExp;
};

/** aggregate varPop on columns */
export type RolesVarPopFields = {
  __typename?: 'RolesVarPopFields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type RolesVarSampFields = {
  __typename?: 'RolesVarSampFields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RolesVarianceFields = {
  __typename?: 'RolesVarianceFields';
  id: Maybe<Scalars['Float']>;
};

export type SavedSsInheritance = {
  __typename?: 'SavedSsInheritance';
  inheritedScopeSnapshot: PrimitiveScopeSnapshot;
  inheritedScopeSnapshotId: Scalars['Int'];
  isDirectInheritance: Scalars['Boolean'];
  isSelf: Scalars['Boolean'];
  ordinal: Scalars['Int'];
  ordinalWithinDirectInheritances: Scalars['Int'];
};

/** Each row holds one assignment for a scope definition, such as "env=dev". This would be one part of a larger scope_definition such as: env='dev,uat' + platform='ios'. ***IMPORTANT:*** Make sure the validate_scope_snapshot_ancestry_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeDefiners = {
  __typename?: 'ScopeDefiners';
  id: Scalars['Int'];
  /** An object relationship */
  scope: Scopes;
  scopeId: Scalars['Int'];
  /** An object relationship */
  scopeOption: ScopeOptions;
  scopeOptionId: Scalars['Int'];
};

/** aggregated selection of "scope_definers" */
export type ScopeDefinersAggregate = {
  __typename?: 'ScopeDefinersAggregate';
  aggregate: Maybe<ScopeDefinersAggregateFields>;
  nodes: Array<ScopeDefiners>;
};

export type ScopeDefinersAggregateBoolExp = {
  count?: InputMaybe<ScopeDefinersAggregateBoolExpCount>;
};

/** aggregate fields of "scope_definers" */
export type ScopeDefinersAggregateFields = {
  __typename?: 'ScopeDefinersAggregateFields';
  avg: Maybe<ScopeDefinersAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopeDefinersMaxFields>;
  min: Maybe<ScopeDefinersMinFields>;
  stddev: Maybe<ScopeDefinersStddevFields>;
  stddevPop: Maybe<ScopeDefinersStddevPopFields>;
  stddevSamp: Maybe<ScopeDefinersStddevSampFields>;
  sum: Maybe<ScopeDefinersSumFields>;
  varPop: Maybe<ScopeDefinersVarPopFields>;
  varSamp: Maybe<ScopeDefinersVarSampFields>;
  variance: Maybe<ScopeDefinersVarianceFields>;
};


/** aggregate fields of "scope_definers" */
export type ScopeDefinersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scope_definers" */
export type ScopeDefinersAggregateOrderBy = {
  avg?: InputMaybe<ScopeDefinersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScopeDefinersMaxOrderBy>;
  min?: InputMaybe<ScopeDefinersMinOrderBy>;
  stddev?: InputMaybe<ScopeDefinersStddevOrderBy>;
  stddevPop?: InputMaybe<ScopeDefinersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ScopeDefinersStddevSampOrderBy>;
  sum?: InputMaybe<ScopeDefinersSumOrderBy>;
  varPop?: InputMaybe<ScopeDefinersVarPopOrderBy>;
  varSamp?: InputMaybe<ScopeDefinersVarSampOrderBy>;
  variance?: InputMaybe<ScopeDefinersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scope_definers" */
export type ScopeDefinersArrRelInsertInput = {
  data: Array<ScopeDefinersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeDefinersOnConflict>;
};

/** aggregate avg on columns */
export type ScopeDefinersAvgFields = {
  __typename?: 'ScopeDefinersAvgFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scope_definers" */
export type ScopeDefinersAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scope_definers". All fields are combined with a logical 'AND'. */
export type ScopeDefinersBoolExp = {
  _and?: InputMaybe<Array<ScopeDefinersBoolExp>>;
  _not?: InputMaybe<ScopeDefinersBoolExp>;
  _or?: InputMaybe<Array<ScopeDefinersBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "scope_definers" */
export enum ScopeDefinersConstraint {
  /** unique or primary key constraint on columns "scope_option_id", "scope_id" */
  ScopeDefinersScopeIdScopeVariableValueIdKey = 'scope_definers_scope_id_scope_variable_value_id_key',
  /** unique or primary key constraint on columns "id" */
  ScopeDefinitionAssignmentsPkey1 = 'scope_definition_assignments_pkey1'
}

/** input type for incrementing numeric columns in table "scope_definers" */
export type ScopeDefinersIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_definers" */
export type ScopeDefinersInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopesObjRelInsertInput>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOption?: InputMaybe<ScopeOptionsObjRelInsertInput>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ScopeDefinersMaxFields = {
  __typename?: 'ScopeDefinersMaxFields';
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "scope_definers" */
export type ScopeDefinersMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScopeDefinersMinFields = {
  __typename?: 'ScopeDefinersMinFields';
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "scope_definers" */
export type ScopeDefinersMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scope_definers" */
export type ScopeDefinersMutationResponse = {
  __typename?: 'ScopeDefinersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeDefiners>;
};

/** on_conflict condition type for table "scope_definers" */
export type ScopeDefinersOnConflict = {
  constraint: ScopeDefinersConstraint;
  updateColumns?: Array<ScopeDefinersUpdateColumn>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};

/** Ordering options when selecting data from "scope_definers". */
export type ScopeDefinersOrderBy = {
  id?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scope_definers */
export type ScopeDefinersPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_definers" */
export enum ScopeDefinersSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeOptionId = 'scopeOptionId'
}

/** input type for updating data in table "scope_definers" */
export type ScopeDefinersSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ScopeDefinersStddevFields = {
  __typename?: 'ScopeDefinersStddevFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scope_definers" */
export type ScopeDefinersStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ScopeDefinersStddevPopFields = {
  __typename?: 'ScopeDefinersStddevPopFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "scope_definers" */
export type ScopeDefinersStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ScopeDefinersStddevSampFields = {
  __typename?: 'ScopeDefinersStddevSampFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "scope_definers" */
export type ScopeDefinersStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scope_definers" */
export type ScopeDefinersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeDefinersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeDefinersStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ScopeDefinersSumFields = {
  __typename?: 'ScopeDefinersSumFields';
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scope_definers" */
export type ScopeDefinersSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** update columns of table "scope_definers" */
export enum ScopeDefinersUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeOptionId = 'scopeOptionId'
}

export type ScopeDefinersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeDefinersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeDefinersSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeDefinersBoolExp;
};

/** aggregate varPop on columns */
export type ScopeDefinersVarPopFields = {
  __typename?: 'ScopeDefinersVarPopFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "scope_definers" */
export type ScopeDefinersVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ScopeDefinersVarSampFields = {
  __typename?: 'ScopeDefinersVarSampFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "scope_definers" */
export type ScopeDefinersVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScopeDefinersVarianceFields = {
  __typename?: 'ScopeDefinersVarianceFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
  scopeOptionId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scope_definers" */
export type ScopeDefinersVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** Consider deleting this view because it is redundant due to the scope_identifying_definition_jsonb column in comparable_scope_definitions. */
export type ScopeDefinitions = {
  __typename?: 'ScopeDefinitions';
  /** An object relationship */
  scope: Maybe<Scopes>;
  scopeId: Maybe<Scalars['Int']>;
  scopeOptionIds: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to filter rows from the table "scope_definitions". All fields are combined with a logical 'AND'. */
export type ScopeDefinitionsBoolExp = {
  _and?: InputMaybe<Array<ScopeDefinitionsBoolExp>>;
  _not?: InputMaybe<ScopeDefinitionsBoolExp>;
  _or?: InputMaybe<Array<ScopeDefinitionsBoolExp>>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeOptionIds?: InputMaybe<IntArrayComparisonExp>;
};

/** Ordering options when selecting data from "scope_definitions". */
export type ScopeDefinitionsOrderBy = {
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeOptionIds?: InputMaybe<OrderBy>;
};

/** select columns of table "scope_definitions" */
export enum ScopeDefinitionsSelectColumn {
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeOptionIds = 'scopeOptionIds'
}

/** Streaming cursor of the table "scope_definitions" */
export type ScopeDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeDefinitionsStreamCursorValueInput = {
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeOptionIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** These are abstract level flag nodes that serve as a common reference point for replicated flag nodes. Replicated flag nodes belong to the same scope but span different scope versions. For example, flag node A_1 can belong to scope S version 1 and flag node A_2 (which was replicated from A_1) can belong to scope S version 2, however both of them can belong to the same scope_flag_node (which also means that both A_1 and A_2 must belong to the same scope S). As a result, this scope_flag_nodes table allows us to identify how specific flag nodes have evolved over different scope versions, such as different values for names, etc. For example, flag node A_1 can have a name of 'background_color' and flag node A_2 can have an updated name of 'backgroundColor', but both can belong to the same scope flag node. This is useful in the case that flag nodes from a descendant scope snapshot of scope S are using A_1 as their parent flag node (because they are inheriting from scope S version 1), and then suddenly decide to inherit from scope S version 2 instead. We would then know that every flag node in that descendant scope snapshot that was using A_1 as their parent flag node should now use A_2 as their parent flag node instead. */
export type ScopeFlagNodes = {
  __typename?: 'ScopeFlagNodes';
  /** An array relationship */
  flagNodes: Array<FlagNodes>;
  /** An aggregate relationship */
  flagNodesAggregate: FlagNodesAggregate;
  /** An array relationship */
  flagValues: Array<FlagValues>;
  /** An aggregate relationship */
  flagValuesAggregate: FlagValuesAggregate;
  id: Scalars['Int'];
  /** An object relationship */
  scope: Scopes;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Scalars['Int'];
};


/** These are abstract level flag nodes that serve as a common reference point for replicated flag nodes. Replicated flag nodes belong to the same scope but span different scope versions. For example, flag node A_1 can belong to scope S version 1 and flag node A_2 (which was replicated from A_1) can belong to scope S version 2, however both of them can belong to the same scope_flag_node (which also means that both A_1 and A_2 must belong to the same scope S). As a result, this scope_flag_nodes table allows us to identify how specific flag nodes have evolved over different scope versions, such as different values for names, etc. For example, flag node A_1 can have a name of 'background_color' and flag node A_2 can have an updated name of 'backgroundColor', but both can belong to the same scope flag node. This is useful in the case that flag nodes from a descendant scope snapshot of scope S are using A_1 as their parent flag node (because they are inheriting from scope S version 1), and then suddenly decide to inherit from scope S version 2 instead. We would then know that every flag node in that descendant scope snapshot that was using A_1 as their parent flag node should now use A_2 as their parent flag node instead. */
export type ScopeFlagNodesFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/** These are abstract level flag nodes that serve as a common reference point for replicated flag nodes. Replicated flag nodes belong to the same scope but span different scope versions. For example, flag node A_1 can belong to scope S version 1 and flag node A_2 (which was replicated from A_1) can belong to scope S version 2, however both of them can belong to the same scope_flag_node (which also means that both A_1 and A_2 must belong to the same scope S). As a result, this scope_flag_nodes table allows us to identify how specific flag nodes have evolved over different scope versions, such as different values for names, etc. For example, flag node A_1 can have a name of 'background_color' and flag node A_2 can have an updated name of 'backgroundColor', but both can belong to the same scope flag node. This is useful in the case that flag nodes from a descendant scope snapshot of scope S are using A_1 as their parent flag node (because they are inheriting from scope S version 1), and then suddenly decide to inherit from scope S version 2 instead. We would then know that every flag node in that descendant scope snapshot that was using A_1 as their parent flag node should now use A_2 as their parent flag node instead. */
export type ScopeFlagNodesFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/** These are abstract level flag nodes that serve as a common reference point for replicated flag nodes. Replicated flag nodes belong to the same scope but span different scope versions. For example, flag node A_1 can belong to scope S version 1 and flag node A_2 (which was replicated from A_1) can belong to scope S version 2, however both of them can belong to the same scope_flag_node (which also means that both A_1 and A_2 must belong to the same scope S). As a result, this scope_flag_nodes table allows us to identify how specific flag nodes have evolved over different scope versions, such as different values for names, etc. For example, flag node A_1 can have a name of 'background_color' and flag node A_2 can have an updated name of 'backgroundColor', but both can belong to the same scope flag node. This is useful in the case that flag nodes from a descendant scope snapshot of scope S are using A_1 as their parent flag node (because they are inheriting from scope S version 1), and then suddenly decide to inherit from scope S version 2 instead. We would then know that every flag node in that descendant scope snapshot that was using A_1 as their parent flag node should now use A_2 as their parent flag node instead. */
export type ScopeFlagNodesFlagValuesArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


/** These are abstract level flag nodes that serve as a common reference point for replicated flag nodes. Replicated flag nodes belong to the same scope but span different scope versions. For example, flag node A_1 can belong to scope S version 1 and flag node A_2 (which was replicated from A_1) can belong to scope S version 2, however both of them can belong to the same scope_flag_node (which also means that both A_1 and A_2 must belong to the same scope S). As a result, this scope_flag_nodes table allows us to identify how specific flag nodes have evolved over different scope versions, such as different values for names, etc. For example, flag node A_1 can have a name of 'background_color' and flag node A_2 can have an updated name of 'backgroundColor', but both can belong to the same scope flag node. This is useful in the case that flag nodes from a descendant scope snapshot of scope S are using A_1 as their parent flag node (because they are inheriting from scope S version 1), and then suddenly decide to inherit from scope S version 2 instead. We would then know that every flag node in that descendant scope snapshot that was using A_1 as their parent flag node should now use A_2 as their parent flag node instead. */
export type ScopeFlagNodesFlagValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};

/** aggregated selection of "scope_flag_nodes" */
export type ScopeFlagNodesAggregate = {
  __typename?: 'ScopeFlagNodesAggregate';
  aggregate: Maybe<ScopeFlagNodesAggregateFields>;
  nodes: Array<ScopeFlagNodes>;
};

/** aggregate fields of "scope_flag_nodes" */
export type ScopeFlagNodesAggregateFields = {
  __typename?: 'ScopeFlagNodesAggregateFields';
  avg: Maybe<ScopeFlagNodesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopeFlagNodesMaxFields>;
  min: Maybe<ScopeFlagNodesMinFields>;
  stddev: Maybe<ScopeFlagNodesStddevFields>;
  stddevPop: Maybe<ScopeFlagNodesStddevPopFields>;
  stddevSamp: Maybe<ScopeFlagNodesStddevSampFields>;
  sum: Maybe<ScopeFlagNodesSumFields>;
  varPop: Maybe<ScopeFlagNodesVarPopFields>;
  varSamp: Maybe<ScopeFlagNodesVarSampFields>;
  variance: Maybe<ScopeFlagNodesVarianceFields>;
};


/** aggregate fields of "scope_flag_nodes" */
export type ScopeFlagNodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopeFlagNodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ScopeFlagNodesAvgFields = {
  __typename?: 'ScopeFlagNodesAvgFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scope_flag_nodes". All fields are combined with a logical 'AND'. */
export type ScopeFlagNodesBoolExp = {
  _and?: InputMaybe<Array<ScopeFlagNodesBoolExp>>;
  _not?: InputMaybe<ScopeFlagNodesBoolExp>;
  _or?: InputMaybe<Array<ScopeFlagNodesBoolExp>>;
  flagNodes?: InputMaybe<FlagNodesBoolExp>;
  flagNodesAggregate?: InputMaybe<FlagNodesAggregateBoolExp>;
  flagValues?: InputMaybe<FlagValuesBoolExp>;
  flagValuesAggregate?: InputMaybe<FlagValuesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "scope_flag_nodes" */
export enum ScopeFlagNodesConstraint {
  /** unique or primary key constraint on columns "id" */
  FlagNodesPkey = 'flag_nodes_pkey',
  /** unique or primary key constraint on columns "id", "scope_id" */
  ScopeFlagNodesIdScopeIdKey = 'scope_flag_nodes_id_scope_id_key'
}

/** input type for incrementing numeric columns in table "scope_flag_nodes" */
export type ScopeFlagNodesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_flag_nodes" */
export type ScopeFlagNodesInsertInput = {
  flagNodes?: InputMaybe<FlagNodesArrRelInsertInput>;
  flagValues?: InputMaybe<FlagValuesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopesObjRelInsertInput>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ScopeFlagNodesMaxFields = {
  __typename?: 'ScopeFlagNodesMaxFields';
  id: Maybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ScopeFlagNodesMinFields = {
  __typename?: 'ScopeFlagNodesMinFields';
  id: Maybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "scope_flag_nodes" */
export type ScopeFlagNodesMutationResponse = {
  __typename?: 'ScopeFlagNodesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeFlagNodes>;
};

/** input type for inserting object relation for remote table "scope_flag_nodes" */
export type ScopeFlagNodesObjRelInsertInput = {
  data: ScopeFlagNodesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeFlagNodesOnConflict>;
};

/** on_conflict condition type for table "scope_flag_nodes" */
export type ScopeFlagNodesOnConflict = {
  constraint: ScopeFlagNodesConstraint;
  updateColumns?: Array<ScopeFlagNodesUpdateColumn>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};

/** Ordering options when selecting data from "scope_flag_nodes". */
export type ScopeFlagNodesOrderBy = {
  flagNodesAggregate?: InputMaybe<FlagNodesAggregateOrderBy>;
  flagValuesAggregate?: InputMaybe<FlagValuesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scope_flag_nodes */
export type ScopeFlagNodesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_flag_nodes" */
export enum ScopeFlagNodesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId'
}

/** input type for updating data in table "scope_flag_nodes" */
export type ScopeFlagNodesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ScopeFlagNodesStddevFields = {
  __typename?: 'ScopeFlagNodesStddevFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ScopeFlagNodesStddevPopFields = {
  __typename?: 'ScopeFlagNodesStddevPopFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ScopeFlagNodesStddevSampFields = {
  __typename?: 'ScopeFlagNodesStddevSampFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scope_flag_nodes" */
export type ScopeFlagNodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeFlagNodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeFlagNodesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ScopeFlagNodesSumFields = {
  __typename?: 'ScopeFlagNodesSumFields';
  id: Maybe<Scalars['Int']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Int']>;
};

/** update columns of table "scope_flag_nodes" */
export enum ScopeFlagNodesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId'
}

export type ScopeFlagNodesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeFlagNodesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeFlagNodesSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeFlagNodesBoolExp;
};

/** aggregate varPop on columns */
export type ScopeFlagNodesVarPopFields = {
  __typename?: 'ScopeFlagNodesVarPopFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ScopeFlagNodesVarSampFields = {
  __typename?: 'ScopeFlagNodesVarSampFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ScopeFlagNodesVarianceFields = {
  __typename?: 'ScopeFlagNodesVarianceFields';
  id: Maybe<Scalars['Float']>;
  /**
   * Ensures that a scope flag node is bound to a single scope. Since flag nodes belong to scope flag nodes, all flag nodes belonging to the same scope flag node therefore share the same scope_id. This guarantees that a flag node's dependent flag nodes and values can never create a requirement for the snapshots they're defined in to inherit from a snapshot belonging to a different scope as snapshot inheritances change. This is especially important when that scope is not even eligible for inheritance by the dependent flag node or value.
   * 
   * For example, suppose an Ontario snapshot inherits from a Canada snapshot, and an Ontario flag depends on a Canada flag. If scope flag nodes were not scope-bound, a Toronto flag could later belong to the same scope flag node as that Canada flag. Changes to the snapshot inheritance hierarchy could then cause the Ontario flag's existing dependency to require the Toronto flag instead. This would be impossible to satisfy because Ontario is not eligible to inherit from Toronto. Binding the scope flag node to Canada guarantees that the dependency can only ever require a flag node belonging to Canada.
   */
  scopeId: Maybe<Scalars['Float']>;
};

export type ScopeInheritabilities = {
  __typename?: 'ScopeInheritabilities';
  inheritableScope: Scopes;
  scope: Scopes;
};

/** columns and relationships of "scope_option_tree_edge_transitives_return_type" */
export type ScopeOptionTreeEdgeTransitivesReturnType = {
  __typename?: 'ScopeOptionTreeEdgeTransitivesReturnType';
  descendantChain: Maybe<Array<Scalars['Int']>>;
  descendantScopeOptionId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeOption: Maybe<ScopeOptions>;
  scopeOptionId: Maybe<Scalars['Int']>;
  sortableTreeChain: Maybe<Array<Scalars['sortable_scope_option_tree_node']>>;
};

/** Boolean expression to filter rows from the table "scope_option_tree_edge_transitives_return_type". All fields are combined with a logical 'AND'. */
export type ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp = {
  _and?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>>;
  _not?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
  _or?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>>;
  descendantChain?: InputMaybe<IntArrayComparisonExp>;
  descendantScopeOptionId?: InputMaybe<IntComparisonExp>;
  scopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionId?: InputMaybe<IntComparisonExp>;
  sortableTreeChain?: InputMaybe<SortableScopeOptionTreeNodeArrayComparisonExp>;
};

/** Ordering options when selecting data from "scope_option_tree_edge_transitives_return_type". */
export type ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy = {
  descendantChain?: InputMaybe<OrderBy>;
  descendantScopeOptionId?: InputMaybe<OrderBy>;
  scopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  sortableTreeChain?: InputMaybe<OrderBy>;
};

/** select columns of table "scope_option_tree_edge_transitives_return_type" */
export enum ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn {
  /** column name */
  DescendantChain = 'descendantChain',
  /** column name */
  DescendantScopeOptionId = 'descendantScopeOptionId',
  /** column name */
  ScopeOptionId = 'scopeOptionId',
  /** column name */
  SortableTreeChain = 'sortableTreeChain'
}

/** Streaming cursor of the table "scope_option_tree_edge_transitives_return_type" */
export type ScopeOptionTreeEdgeTransitivesReturnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeOptionTreeEdgeTransitivesReturnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeOptionTreeEdgeTransitivesReturnTypeStreamCursorValueInput = {
  descendantChain?: InputMaybe<Array<Scalars['Int']>>;
  descendantScopeOptionId?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  sortableTreeChain?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
};

/** Defines the direct edges of the scope option tree. ***IMPORTANT:*** When modifying triggers, do not accidentally change a deferred trigger to a non-deferred trigger. */
export type ScopeOptionTreeEdges = {
  __typename?: 'ScopeOptionTreeEdges';
  /** An object relationship */
  childScopeOption: Maybe<ScopeOptions>;
  childScopeOptionId: Scalars['Int'];
  id: Scalars['Int'];
  ordinal: Maybe<Scalars['Int']>;
  /** An object relationship */
  scopeOption: Maybe<ScopeOptions>;
  scopeOptionId: Scalars['Int'];
  /** An object relationship */
  scopeVariable: Maybe<ScopeVariables>;
};

/** order by aggregate values of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesAggregateOrderBy = {
  avg?: InputMaybe<ScopeOptionTreeEdgesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScopeOptionTreeEdgesMaxOrderBy>;
  min?: InputMaybe<ScopeOptionTreeEdgesMinOrderBy>;
  stddev?: InputMaybe<ScopeOptionTreeEdgesStddevOrderBy>;
  stddevPop?: InputMaybe<ScopeOptionTreeEdgesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ScopeOptionTreeEdgesStddevSampOrderBy>;
  sum?: InputMaybe<ScopeOptionTreeEdgesSumOrderBy>;
  varPop?: InputMaybe<ScopeOptionTreeEdgesVarPopOrderBy>;
  varSamp?: InputMaybe<ScopeOptionTreeEdgesVarSampOrderBy>;
  variance?: InputMaybe<ScopeOptionTreeEdgesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesArrRelInsertInput = {
  data: Array<ScopeOptionTreeEdgesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeOptionTreeEdgesOnConflict>;
};

/** order by avg() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesAvgOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scope_option_tree_edges". All fields are combined with a logical 'AND'. */
export type ScopeOptionTreeEdgesBoolExp = {
  _and?: InputMaybe<Array<ScopeOptionTreeEdgesBoolExp>>;
  _not?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
  _or?: InputMaybe<Array<ScopeOptionTreeEdgesBoolExp>>;
  childScopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  childScopeOptionId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
  scopeOption?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionId?: InputMaybe<IntComparisonExp>;
  scopeVariable?: InputMaybe<ScopeVariablesBoolExp>;
};

/** unique or primary key constraints on table "scope_option_tree_edges" */
export enum ScopeOptionTreeEdgesConstraint {
  /** unique or primary key constraint on columns "id" */
  ScopeOptionGroupDefinersPkey = 'scope_option_group_definers_pkey',
  /** unique or primary key constraint on columns "scope_option_id", "child_scope_option_id" */
  ScopeOptionTreeEdgesScopeOptionIdChildScopeOptionIdK = 'scope_option_tree_edges_scope_option_id_child_scope_option_id_k',
  /** unique or primary key constraint on columns "scope_option_id", "ordinal" */
  ScopeOptionTreeEdgesScopeOptionIdOrdinalKey = 'scope_option_tree_edges_scope_option_id_ordinal_key'
}

/** input type for incrementing numeric columns in table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesIncInput = {
  childScopeOptionId?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  /** Simply here to enforce both scope_option_id and child_scope_option_id belong to the same scope variable. This is done with the two foreign keys (scope_variable_id, scope_option_id) and (scope_variable_id, child_scope_option_id). */
  scopeVariableId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesInsertInput = {
  childScopeOption?: InputMaybe<ScopeOptionsObjRelInsertInput>;
  childScopeOptionId?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeOption?: InputMaybe<ScopeOptionsObjRelInsertInput>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  scopeVariable?: InputMaybe<ScopeVariablesObjRelInsertInput>;
  /** Simply here to enforce both scope_option_id and child_scope_option_id belong to the same scope variable. This is done with the two foreign keys (scope_variable_id, scope_option_id) and (scope_variable_id, child_scope_option_id). */
  scopeVariableId?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesMaxOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesMinOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesMutationResponse = {
  __typename?: 'ScopeOptionTreeEdgesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeOptionTreeEdges>;
};

/** on_conflict condition type for table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesOnConflict = {
  constraint: ScopeOptionTreeEdgesConstraint;
  updateColumns?: Array<ScopeOptionTreeEdgesUpdateColumn>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};

/** Ordering options when selecting data from "scope_option_tree_edges". */
export type ScopeOptionTreeEdgesOrderBy = {
  childScopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOption?: InputMaybe<ScopeOptionsOrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
  scopeVariable?: InputMaybe<ScopeVariablesOrderBy>;
};

/** primary key columns input for table: scope_option_tree_edges */
export type ScopeOptionTreeEdgesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_option_tree_edges" */
export enum ScopeOptionTreeEdgesSelectColumn {
  /** column name */
  ChildScopeOptionId = 'childScopeOptionId',
  /** column name */
  Id = 'id',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeOptionId = 'scopeOptionId'
}

/** input type for updating data in table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesSetInput = {
  childScopeOptionId?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
  /** Simply here to enforce both scope_option_id and child_scope_option_id belong to the same scope variable. This is done with the two foreign keys (scope_variable_id, scope_option_id) and (scope_variable_id, child_scope_option_id). */
  scopeVariableId?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesStddevOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesStddevPopOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesStddevSampOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeOptionTreeEdgesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeOptionTreeEdgesStreamCursorValueInput = {
  childScopeOptionId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeOptionId?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesSumOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** update columns of table "scope_option_tree_edges" */
export enum ScopeOptionTreeEdgesUpdateColumn {
  /** column name */
  ChildScopeOptionId = 'childScopeOptionId',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeOptionId = 'scopeOptionId',
  /** column name */
  ScopeVariableId = 'scopeVariableId'
}

export type ScopeOptionTreeEdgesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeOptionTreeEdgesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeOptionTreeEdgesSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeOptionTreeEdgesBoolExp;
};

/** order by varPop() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesVarPopOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesVarSampOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "scope_option_tree_edges" */
export type ScopeOptionTreeEdgesVarianceOrderBy = {
  childScopeOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionId?: InputMaybe<OrderBy>;
};

export type ScopeOptionWithinComparableScopeDefiner = {
  __typename?: 'ScopeOptionWithinComparableScopeDefiner';
  id: Scalars['Int'];
  ordinal: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptions = {
  __typename?: 'ScopeOptions';
  /** An array relationship */
  ancestorScopeOptionEdgeTransitives: Array<AllScopeOptionTreeEdgeTransitives>;
  /** An array relationship */
  descendantScopeOptionEdgeTransitives: Array<AllScopeOptionTreeEdgeTransitives>;
  id: Scalars['Int'];
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
  /** An array relationship */
  scopeDefiners: Array<ScopeDefiners>;
  /** An aggregate relationship */
  scopeDefinersAggregate: ScopeDefinersAggregate;
  /** An array relationship */
  scopeOptionTreeEdgeChildren: Array<ScopeOptionTreeEdges>;
  /** An array relationship */
  scopeOptionTreeEdgeParents: Array<ScopeOptionTreeEdges>;
  /** An object relationship */
  scopeVariable: ScopeVariables;
  scopeVariableId: Scalars['Int'];
  value: Scalars['String'];
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsAncestorScopeOptionEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesOrderBy>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsDescendantScopeOptionEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesOrderBy>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsScopeOptionTreeEdgeChildrenArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgesOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};


/** Each row defines a possible value for a scope variable. For example, 'production' would be a possible value for the 'environment' scope variable. ***IMPORTANT***: Make sure the refresh_scope_option_tree_closure_on_scope_options_trigger remains a DEFERRABLE INITIALLY DEFERRED trigger. */
export type ScopeOptionsScopeOptionTreeEdgeParentsArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgesOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};

/** aggregated selection of "scope_options" */
export type ScopeOptionsAggregate = {
  __typename?: 'ScopeOptionsAggregate';
  aggregate: Maybe<ScopeOptionsAggregateFields>;
  nodes: Array<ScopeOptions>;
};

export type ScopeOptionsAggregateBoolExp = {
  count?: InputMaybe<ScopeOptionsAggregateBoolExpCount>;
};

/** aggregate fields of "scope_options" */
export type ScopeOptionsAggregateFields = {
  __typename?: 'ScopeOptionsAggregateFields';
  avg: Maybe<ScopeOptionsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopeOptionsMaxFields>;
  min: Maybe<ScopeOptionsMinFields>;
  stddev: Maybe<ScopeOptionsStddevFields>;
  stddevPop: Maybe<ScopeOptionsStddevPopFields>;
  stddevSamp: Maybe<ScopeOptionsStddevSampFields>;
  sum: Maybe<ScopeOptionsSumFields>;
  varPop: Maybe<ScopeOptionsVarPopFields>;
  varSamp: Maybe<ScopeOptionsVarSampFields>;
  variance: Maybe<ScopeOptionsVarianceFields>;
};


/** aggregate fields of "scope_options" */
export type ScopeOptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scope_options" */
export type ScopeOptionsAggregateOrderBy = {
  avg?: InputMaybe<ScopeOptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScopeOptionsMaxOrderBy>;
  min?: InputMaybe<ScopeOptionsMinOrderBy>;
  stddev?: InputMaybe<ScopeOptionsStddevOrderBy>;
  stddevPop?: InputMaybe<ScopeOptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ScopeOptionsStddevSampOrderBy>;
  sum?: InputMaybe<ScopeOptionsSumOrderBy>;
  varPop?: InputMaybe<ScopeOptionsVarPopOrderBy>;
  varSamp?: InputMaybe<ScopeOptionsVarSampOrderBy>;
  variance?: InputMaybe<ScopeOptionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scope_options" */
export type ScopeOptionsArrRelInsertInput = {
  data: Array<ScopeOptionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeOptionsOnConflict>;
};

/** aggregate avg on columns */
export type ScopeOptionsAvgFields = {
  __typename?: 'ScopeOptionsAvgFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scope_options" */
export type ScopeOptionsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scope_options". All fields are combined with a logical 'AND'. */
export type ScopeOptionsBoolExp = {
  _and?: InputMaybe<Array<ScopeOptionsBoolExp>>;
  _not?: InputMaybe<ScopeOptionsBoolExp>;
  _or?: InputMaybe<Array<ScopeOptionsBoolExp>>;
  ancestorScopeOptionEdgeTransitives?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
  descendantScopeOptionEdgeTransitives?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
  scopeDefiners?: InputMaybe<ScopeDefinersBoolExp>;
  scopeDefinersAggregate?: InputMaybe<ScopeDefinersAggregateBoolExp>;
  scopeOptionTreeEdgeChildren?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
  scopeOptionTreeEdgeParents?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
  scopeVariable?: InputMaybe<ScopeVariablesBoolExp>;
  scopeVariableId?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "scope_options" */
export enum ScopeOptionsConstraint {
  /** unique or primary key constraint on columns "id" */
  GlobalVariableValuesPkey = 'global_variable_values_pkey',
  /** unique or primary key constraint on columns "id", "scope_variable_id" */
  ScopeOptionsScopeVariableIdIdKey = 'scope_options_scope_variable_id_id_key',
  /** unique or primary key constraint on columns "ordinal", "scope_variable_id" */
  ScopeOptionsScopeVariableIdOrdinalKey = 'scope_options_scope_variable_id_ordinal_key',
  /** unique or primary key constraint on columns "scope_variable_id", "value_for_uniqueness" */
  ScopeOptionsScopeVariableIdValueForUniquenessKey = 'scope_options_scope_variable_id_value_for_uniqueness_key',
  /** unique or primary key constraint on columns "value", "scope_variable_id" */
  ScopeVariableValuesScopeVariableIdValueKey = 'scope_variable_values_scope_variable_id_value_key'
}

/** input type for incrementing numeric columns in table "scope_options" */
export type ScopeOptionsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_options" */
export type ScopeOptionsInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeDefiners?: InputMaybe<ScopeDefinersArrRelInsertInput>;
  scopeOptionTreeEdgeChildren?: InputMaybe<ScopeOptionTreeEdgesArrRelInsertInput>;
  scopeOptionTreeEdgeParents?: InputMaybe<ScopeOptionTreeEdgesArrRelInsertInput>;
  scopeVariable?: InputMaybe<ScopeVariablesObjRelInsertInput>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ScopeOptionsMaxFields = {
  __typename?: 'ScopeOptionsMaxFields';
  id: Maybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
  value: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "scope_options" */
export type ScopeOptionsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScopeOptionsMinFields = {
  __typename?: 'ScopeOptionsMinFields';
  id: Maybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
  value: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "scope_options" */
export type ScopeOptionsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scope_options" */
export type ScopeOptionsMutationResponse = {
  __typename?: 'ScopeOptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeOptions>;
};

/** input type for inserting object relation for remote table "scope_options" */
export type ScopeOptionsObjRelInsertInput = {
  data: ScopeOptionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeOptionsOnConflict>;
};

/** on_conflict condition type for table "scope_options" */
export type ScopeOptionsOnConflict = {
  constraint: ScopeOptionsConstraint;
  updateColumns?: Array<ScopeOptionsUpdateColumn>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};

/** Ordering options when selecting data from "scope_options". */
export type ScopeOptionsOrderBy = {
  ancestorScopeOptionEdgeTransitivesAggregate?: InputMaybe<AllScopeOptionTreeEdgeTransitivesAggregateOrderBy>;
  descendantScopeOptionEdgeTransitivesAggregate?: InputMaybe<AllScopeOptionTreeEdgeTransitivesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeDefinersAggregate?: InputMaybe<ScopeDefinersAggregateOrderBy>;
  scopeOptionTreeEdgeChildrenAggregate?: InputMaybe<ScopeOptionTreeEdgesAggregateOrderBy>;
  scopeOptionTreeEdgeParentsAggregate?: InputMaybe<ScopeOptionTreeEdgesAggregateOrderBy>;
  scopeVariable?: InputMaybe<ScopeVariablesOrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scope_options */
export type ScopeOptionsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_options" */
export enum ScopeOptionsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeVariableId = 'scopeVariableId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "scope_options" */
export type ScopeOptionsSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ScopeOptionsStddevFields = {
  __typename?: 'ScopeOptionsStddevFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scope_options" */
export type ScopeOptionsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ScopeOptionsStddevPopFields = {
  __typename?: 'ScopeOptionsStddevPopFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "scope_options" */
export type ScopeOptionsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ScopeOptionsStddevSampFields = {
  __typename?: 'ScopeOptionsStddevSampFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "scope_options" */
export type ScopeOptionsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scope_options" */
export type ScopeOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeOptionsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ScopeOptionsSumFields = {
  __typename?: 'ScopeOptionsSumFields';
  id: Maybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
  scopeVariableId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scope_options" */
export type ScopeOptionsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** update columns of table "scope_options" */
export enum ScopeOptionsUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeVariableId = 'scopeVariableId',
  /** column name */
  Value = 'value'
}

export type ScopeOptionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeOptionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeOptionsSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeOptionsBoolExp;
};

/** aggregate varPop on columns */
export type ScopeOptionsVarPopFields = {
  __typename?: 'ScopeOptionsVarPopFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "scope_options" */
export type ScopeOptionsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ScopeOptionsVarSampFields = {
  __typename?: 'ScopeOptionsVarSampFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "scope_options" */
export type ScopeOptionsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScopeOptionsVarianceFields = {
  __typename?: 'ScopeOptionsVarianceFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
  scopeVariableId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scope_options" */
export type ScopeOptionsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<OrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

export type ScopeSnapshotWithOptionalFieldTest = {
  __typename?: 'ScopeSnapshotWithOptionalFieldTest';
  id: Scalars['Int'];
  optionalField: Maybe<Scalars['Int']>;
};

/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshots = {
  __typename?: 'ScopeSnapshots';
  /** An array relationship */
  childInheritances: Array<SsDirectInheritances>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  descendantInheritances: Array<SsInheritances>;
  /** An array relationship */
  directInheritances: Array<SsDirectInheritances>;
  /** An array relationship */
  flagNodes: Array<FlagNodes>;
  /** An aggregate relationship */
  flagNodesAggregate: FlagNodesAggregate;
  id: Scalars['Int'];
  /** An array relationship */
  inheritances: Array<SsInheritances>;
  /** A computed field, executes function "json_configuration_by_scope_snapshot_row" */
  jsonConfiguration: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  scope: Scopes;
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsChildInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsDirectInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsDirectInheritancesOrderBy>>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsDescendantInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsInheritancesOrderBy>>;
  where?: InputMaybe<SsInheritancesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsDirectInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsDirectInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsDirectInheritancesOrderBy>>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsInheritancesOrderBy>>;
  where?: InputMaybe<SsInheritancesBoolExp>;
};


/** A scope snapshot is represented uniquely by a scope_id and scope_version. The rows in flag_nodes and flag_values always reference a scope snapshot.     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). */
export type ScopeSnapshotsJsonConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "scope_snapshots" */
export type ScopeSnapshotsAggregate = {
  __typename?: 'ScopeSnapshotsAggregate';
  aggregate: Maybe<ScopeSnapshotsAggregateFields>;
  nodes: Array<ScopeSnapshots>;
};

export type ScopeSnapshotsAggregateBoolExp = {
  count?: InputMaybe<ScopeSnapshotsAggregateBoolExpCount>;
};

/** aggregate fields of "scope_snapshots" */
export type ScopeSnapshotsAggregateFields = {
  __typename?: 'ScopeSnapshotsAggregateFields';
  avg: Maybe<ScopeSnapshotsAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopeSnapshotsMaxFields>;
  min: Maybe<ScopeSnapshotsMinFields>;
  stddev: Maybe<ScopeSnapshotsStddevFields>;
  stddevPop: Maybe<ScopeSnapshotsStddevPopFields>;
  stddevSamp: Maybe<ScopeSnapshotsStddevSampFields>;
  sum: Maybe<ScopeSnapshotsSumFields>;
  varPop: Maybe<ScopeSnapshotsVarPopFields>;
  varSamp: Maybe<ScopeSnapshotsVarSampFields>;
  variance: Maybe<ScopeSnapshotsVarianceFields>;
};


/** aggregate fields of "scope_snapshots" */
export type ScopeSnapshotsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scope_snapshots" */
export type ScopeSnapshotsAggregateOrderBy = {
  avg?: InputMaybe<ScopeSnapshotsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScopeSnapshotsMaxOrderBy>;
  min?: InputMaybe<ScopeSnapshotsMinOrderBy>;
  stddev?: InputMaybe<ScopeSnapshotsStddevOrderBy>;
  stddevPop?: InputMaybe<ScopeSnapshotsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ScopeSnapshotsStddevSampOrderBy>;
  sum?: InputMaybe<ScopeSnapshotsSumOrderBy>;
  varPop?: InputMaybe<ScopeSnapshotsVarPopOrderBy>;
  varSamp?: InputMaybe<ScopeSnapshotsVarSampOrderBy>;
  variance?: InputMaybe<ScopeSnapshotsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scope_snapshots" */
export type ScopeSnapshotsArrRelInsertInput = {
  data: Array<ScopeSnapshotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeSnapshotsOnConflict>;
};

/** aggregate avg on columns */
export type ScopeSnapshotsAvgFields = {
  __typename?: 'ScopeSnapshotsAvgFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scope_snapshots" */
export type ScopeSnapshotsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scope_snapshots". All fields are combined with a logical 'AND'. */
export type ScopeSnapshotsBoolExp = {
  _and?: InputMaybe<Array<ScopeSnapshotsBoolExp>>;
  _not?: InputMaybe<ScopeSnapshotsBoolExp>;
  _or?: InputMaybe<Array<ScopeSnapshotsBoolExp>>;
  childInheritances?: InputMaybe<SsDirectInheritancesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  descendantInheritances?: InputMaybe<SsInheritancesBoolExp>;
  directInheritances?: InputMaybe<SsDirectInheritancesBoolExp>;
  flagNodes?: InputMaybe<FlagNodesBoolExp>;
  flagNodesAggregate?: InputMaybe<FlagNodesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  inheritances?: InputMaybe<SsInheritancesBoolExp>;
  jsonConfiguration?: InputMaybe<JsonbComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeVersion?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "scope_snapshots" */
export enum ScopeSnapshotsConstraint {
  /** unique or primary key constraint on columns "id", "scope_id" */
  ScopeSnapshotsIdScopeIdKey = 'scope_snapshots_id_scope_id_key',
  /** unique or primary key constraint on columns "id" */
  ScopeSnapshotsPkey = 'scope_snapshots_pkey',
  /** unique or primary key constraint on columns "scope_id", "scope_version" */
  ScopeSnapshotsScopeIdVersionKey = 'scope_snapshots_scope_id_version_key'
}

/** input type for incrementing numeric columns in table "scope_snapshots" */
export type ScopeSnapshotsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_snapshots" */
export type ScopeSnapshotsInsertInput = {
  childInheritances?: InputMaybe<SsDirectInheritancesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  directInheritances?: InputMaybe<SsDirectInheritancesArrRelInsertInput>;
  flagNodes?: InputMaybe<FlagNodesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopesObjRelInsertInput>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ScopeSnapshotsMaxFields = {
  __typename?: 'ScopeSnapshotsMaxFields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
  scopeVersion: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "scope_snapshots" */
export type ScopeSnapshotsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScopeSnapshotsMinFields = {
  __typename?: 'ScopeSnapshotsMinFields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
  scopeVersion: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "scope_snapshots" */
export type ScopeSnapshotsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scope_snapshots" */
export type ScopeSnapshotsMutationResponse = {
  __typename?: 'ScopeSnapshotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeSnapshots>;
};

/** input type for inserting object relation for remote table "scope_snapshots" */
export type ScopeSnapshotsObjRelInsertInput = {
  data: ScopeSnapshotsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeSnapshotsOnConflict>;
};

/** on_conflict condition type for table "scope_snapshots" */
export type ScopeSnapshotsOnConflict = {
  constraint: ScopeSnapshotsConstraint;
  updateColumns?: Array<ScopeSnapshotsUpdateColumn>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};

/** Ordering options when selecting data from "scope_snapshots". */
export type ScopeSnapshotsOrderBy = {
  childInheritancesAggregate?: InputMaybe<SsDirectInheritancesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  descendantInheritancesAggregate?: InputMaybe<SsInheritancesAggregateOrderBy>;
  directInheritancesAggregate?: InputMaybe<SsDirectInheritancesAggregateOrderBy>;
  flagNodesAggregate?: InputMaybe<FlagNodesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  inheritancesAggregate?: InputMaybe<SsInheritancesAggregateOrderBy>;
  jsonConfiguration?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeVersion?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scope_snapshots */
export type ScopeSnapshotsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_snapshots" */
export enum ScopeSnapshotsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeVersion = 'scopeVersion'
}

/** input type for updating data in table "scope_snapshots" */
export type ScopeSnapshotsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ScopeSnapshotsStddevFields = {
  __typename?: 'ScopeSnapshotsStddevFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scope_snapshots" */
export type ScopeSnapshotsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ScopeSnapshotsStddevPopFields = {
  __typename?: 'ScopeSnapshotsStddevPopFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "scope_snapshots" */
export type ScopeSnapshotsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ScopeSnapshotsStddevSampFields = {
  __typename?: 'ScopeSnapshotsStddevSampFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "scope_snapshots" */
export type ScopeSnapshotsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scope_snapshots" */
export type ScopeSnapshotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeSnapshotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeSnapshotsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeVersion?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ScopeSnapshotsSumFields = {
  __typename?: 'ScopeSnapshotsSumFields';
  id: Maybe<Scalars['Int']>;
  scopeId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scope_snapshots" */
export type ScopeSnapshotsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** update columns of table "scope_snapshots" */
export enum ScopeSnapshotsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeVersion = 'scopeVersion'
}

export type ScopeSnapshotsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeSnapshotsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeSnapshotsSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeSnapshotsBoolExp;
};

/** aggregate varPop on columns */
export type ScopeSnapshotsVarPopFields = {
  __typename?: 'ScopeSnapshotsVarPopFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "scope_snapshots" */
export type ScopeSnapshotsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ScopeSnapshotsVarSampFields = {
  __typename?: 'ScopeSnapshotsVarSampFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "scope_snapshots" */
export type ScopeSnapshotsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScopeSnapshotsVarianceFields = {
  __typename?: 'ScopeSnapshotsVarianceFields';
  id: Maybe<Scalars['Float']>;
  scopeId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scope_snapshots" */
export type ScopeSnapshotsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
};

export type ScopeVariableWithinComparableScopeDefiner = {
  __typename?: 'ScopeVariableWithinComparableScopeDefiner';
  id: Scalars['Int'];
  name: Scalars['String'];
  ordinal: Scalars['Int'];
};

/** Variables such as env and platform. */
export type ScopeVariables = {
  __typename?: 'ScopeVariables';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Scalars['Int'];
  /** An array relationship */
  scopeOptionTreeEdgeTransitives: Array<AllScopeOptionTreeEdgeTransitives>;
  /** An array relationship */
  scopeOptions: Array<ScopeOptions>;
  /** An aggregate relationship */
  scopeOptionsAggregate: ScopeOptionsAggregate;
};


/** Variables such as env and platform. */
export type ScopeVariablesScopeOptionTreeEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesOrderBy>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


/** Variables such as env and platform. */
export type ScopeVariablesScopeOptionsArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


/** Variables such as env and platform. */
export type ScopeVariablesScopeOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};

/** aggregated selection of "scope_variables" */
export type ScopeVariablesAggregate = {
  __typename?: 'ScopeVariablesAggregate';
  aggregate: ScopeVariablesAggregateFields;
  nodes: Array<ScopeVariables>;
};

export type ScopeVariablesAggregateBoolExp = {
  count?: InputMaybe<ScopeVariablesAggregateBoolExpCount>;
};

/** aggregate fields of "scope_variables" */
export type ScopeVariablesAggregateFields = {
  __typename?: 'ScopeVariablesAggregateFields';
  avg: Maybe<ScopeVariablesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopeVariablesMaxFields>;
  min: Maybe<ScopeVariablesMinFields>;
  stddev: Maybe<ScopeVariablesStddevFields>;
  stddevPop: Maybe<ScopeVariablesStddevPopFields>;
  stddevSamp: Maybe<ScopeVariablesStddevSampFields>;
  sum: Maybe<ScopeVariablesSumFields>;
  varPop: Maybe<ScopeVariablesVarPopFields>;
  varSamp: Maybe<ScopeVariablesVarSampFields>;
  variance: Maybe<ScopeVariablesVarianceFields>;
};


/** aggregate fields of "scope_variables" */
export type ScopeVariablesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ScopeVariablesAvgFields = {
  __typename?: 'ScopeVariablesAvgFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scope_variables". All fields are combined with a logical 'AND'. */
export type ScopeVariablesBoolExp = {
  _and?: InputMaybe<Array<ScopeVariablesBoolExp>>;
  _not?: InputMaybe<ScopeVariablesBoolExp>;
  _or?: InputMaybe<Array<ScopeVariablesBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
  scopeOptionTreeEdgeTransitives?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
  scopeOptions?: InputMaybe<ScopeOptionsBoolExp>;
  scopeOptionsAggregate?: InputMaybe<ScopeOptionsAggregateBoolExp>;
};

/** unique or primary key constraints on table "scope_variables" */
export enum ScopeVariablesConstraint {
  /** unique or primary key constraint on columns "id" */
  ScopeVariablesPkey = 'scope_variables_pkey',
  /** unique or primary key constraint on columns "name_for_uniqueness", "tenant_id" */
  ScopeVariablesTenantIdNameForUniquenessKey = 'scope_variables_tenant_id_name_for_uniqueness_key',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  ScopeVariablesTenantIdNameKey = 'scope_variables_tenant_id_name_key',
  /** unique or primary key constraint on columns "ordinal", "tenant_id" */
  ScopeVariablesTenantIdOrdinalKey = 'scope_variables_tenant_id_ordinal_key'
}

/** input type for incrementing numeric columns in table "scope_variables" */
export type ScopeVariablesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scope_variables" */
export type ScopeVariablesInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeOptions?: InputMaybe<ScopeOptionsArrRelInsertInput>;
};

/** aggregate max on columns */
export type ScopeVariablesMaxFields = {
  __typename?: 'ScopeVariablesMaxFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ScopeVariablesMinFields = {
  __typename?: 'ScopeVariablesMinFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "scope_variables" */
export type ScopeVariablesMutationResponse = {
  __typename?: 'ScopeVariablesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScopeVariables>;
};

/** input type for inserting object relation for remote table "scope_variables" */
export type ScopeVariablesObjRelInsertInput = {
  data: ScopeVariablesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ScopeVariablesOnConflict>;
};

/** on_conflict condition type for table "scope_variables" */
export type ScopeVariablesOnConflict = {
  constraint: ScopeVariablesConstraint;
  updateColumns?: Array<ScopeVariablesUpdateColumn>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};

/** Ordering options when selecting data from "scope_variables". */
export type ScopeVariablesOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeOptionTreeEdgeTransitivesAggregate?: InputMaybe<AllScopeOptionTreeEdgeTransitivesAggregateOrderBy>;
  scopeOptionsAggregate?: InputMaybe<ScopeOptionsAggregateOrderBy>;
};

/** primary key columns input for table: scope_variables */
export type ScopeVariablesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scope_variables" */
export enum ScopeVariablesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Ordinal = 'ordinal'
}

/** input type for updating data in table "scope_variables" */
export type ScopeVariablesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ScopeVariablesStddevFields = {
  __typename?: 'ScopeVariablesStddevFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ScopeVariablesStddevPopFields = {
  __typename?: 'ScopeVariablesStddevPopFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ScopeVariablesStddevSampFields = {
  __typename?: 'ScopeVariablesStddevSampFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scope_variables" */
export type ScopeVariablesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopeVariablesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopeVariablesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ScopeVariablesSumFields = {
  __typename?: 'ScopeVariablesSumFields';
  id: Maybe<Scalars['Int']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Int']>;
};

/** update columns of table "scope_variables" */
export enum ScopeVariablesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Ordinal = 'ordinal'
}

export type ScopeVariablesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopeVariablesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopeVariablesSetInput>;
  /** filter the rows which have to be updated */
  where: ScopeVariablesBoolExp;
};

/** aggregate varPop on columns */
export type ScopeVariablesVarPopFields = {
  __typename?: 'ScopeVariablesVarPopFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ScopeVariablesVarSampFields = {
  __typename?: 'ScopeVariablesVarSampFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ScopeVariablesVarianceFields = {
  __typename?: 'ScopeVariablesVarianceFields';
  id: Maybe<Scalars['Float']>;
  /** The columns scope_variables.ordinal and scope_options.ordinal play a role in generating an initially suggested order of parent scopes. This suggested order can be used for selecting the order of parent scope snapshots when creating/modifying a scope snapshot. See comparable_scope_definitions.sortable_scope_definition to see this suggested order. */
  ordinal: Maybe<Scalars['Float']>;
};

export type ScopeWithComparableScopeDefiners = {
  __typename?: 'ScopeWithComparableScopeDefiners';
  comparableScopeDefiners: Array<ComparableScopeDefinerWithScopeVariableAndOption>;
  id: Scalars['Int'];
};

/** columns and relationships of "scopes" */
export type Scopes = {
  __typename?: 'Scopes';
  /** An array relationship */
  comparableScopeDefiners: Array<AllComparableScopeDefiners>;
  /** An aggregate relationship */
  comparableScopeDefinersAggregate: AllComparableScopeDefinersAggregate;
  /** An object relationship */
  comparableScopeDefinition: Maybe<AllComparableScopeDefinitions>;
  /** An array relationship */
  deployments: Array<Deployments>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  /** An array relationship */
  roleScopes: Array<RoleScopes>;
  /** An aggregate relationship */
  roleScopesAggregate: RoleScopesAggregate;
  /** An array relationship */
  scopeDefiners: Array<ScopeDefiners>;
  /** An aggregate relationship */
  scopeDefinersAggregate: ScopeDefinersAggregate;
  /** An array relationship */
  scopeInheritabilities: Array<Scopes>;
  /** An aggregate relationship */
  scopeInheritabilitiesAggregate: ScopesAggregate;
  /** An array relationship */
  scopeSnapshots: Array<ScopeSnapshots>;
  /** An aggregate relationship */
  scopeSnapshotsAggregate: ScopeSnapshotsAggregate;
  tenantId: Scalars['uuid'];
  /** An array relationship */
  validatableScopeSnapshotChildInheritances: Array<AllValidatableScopeContainments>;
  /** An array relationship */
  validatableScopeSnapshotParentInheritances: Array<AllValidatableScopeContainments>;
};


/** columns and relationships of "scopes" */
export type ScopesComparableScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesComparableScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesDeploymentsArgs = {
  distinctOn?: InputMaybe<Array<DeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DeploymentsOrderBy>>;
  where?: InputMaybe<DeploymentsBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesRoleScopesArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesRoleScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeInheritabilitiesArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeInheritabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeSnapshotsArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesScopeSnapshotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesValidatableScopeSnapshotChildInheritancesArgs = {
  distinctOn?: InputMaybe<Array<AllValidatableScopeContainmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllValidatableScopeContainmentsOrderBy>>;
  where?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};


/** columns and relationships of "scopes" */
export type ScopesValidatableScopeSnapshotParentInheritancesArgs = {
  distinctOn?: InputMaybe<Array<AllValidatableScopeContainmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllValidatableScopeContainmentsOrderBy>>;
  where?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};

/** aggregated selection of "scopes" */
export type ScopesAggregate = {
  __typename?: 'ScopesAggregate';
  aggregate: Maybe<ScopesAggregateFields>;
  nodes: Array<Scopes>;
};

export type ScopesAggregateBoolExp = {
  count?: InputMaybe<ScopesAggregateBoolExpCount>;
};

/** aggregate fields of "scopes" */
export type ScopesAggregateFields = {
  __typename?: 'ScopesAggregateFields';
  avg: Maybe<ScopesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<ScopesMaxFields>;
  min: Maybe<ScopesMinFields>;
  stddev: Maybe<ScopesStddevFields>;
  stddevPop: Maybe<ScopesStddevPopFields>;
  stddevSamp: Maybe<ScopesStddevSampFields>;
  sum: Maybe<ScopesSumFields>;
  varPop: Maybe<ScopesVarPopFields>;
  varSamp: Maybe<ScopesVarSampFields>;
  variance: Maybe<ScopesVarianceFields>;
};


/** aggregate fields of "scopes" */
export type ScopesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScopesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scopes" */
export type ScopesAggregateOrderBy = {
  avg?: InputMaybe<ScopesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScopesMaxOrderBy>;
  min?: InputMaybe<ScopesMinOrderBy>;
  stddev?: InputMaybe<ScopesStddevOrderBy>;
  stddevPop?: InputMaybe<ScopesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ScopesStddevSampOrderBy>;
  sum?: InputMaybe<ScopesSumOrderBy>;
  varPop?: InputMaybe<ScopesVarPopOrderBy>;
  varSamp?: InputMaybe<ScopesVarSampOrderBy>;
  variance?: InputMaybe<ScopesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scopes" */
export type ScopesArrRelInsertInput = {
  data: Array<ScopesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ScopesOnConflict>;
};

/** aggregate avg on columns */
export type ScopesAvgFields = {
  __typename?: 'ScopesAvgFields';
  id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scopes" */
export type ScopesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scopes". All fields are combined with a logical 'AND'. */
export type ScopesBoolExp = {
  _and?: InputMaybe<Array<ScopesBoolExp>>;
  _not?: InputMaybe<ScopesBoolExp>;
  _or?: InputMaybe<Array<ScopesBoolExp>>;
  comparableScopeDefiners?: InputMaybe<AllComparableScopeDefinersBoolExp>;
  comparableScopeDefinersAggregate?: InputMaybe<AllComparableScopeDefinersAggregateBoolExp>;
  comparableScopeDefinition?: InputMaybe<AllComparableScopeDefinitionsBoolExp>;
  deployments?: InputMaybe<DeploymentsBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  roleScopes?: InputMaybe<RoleScopesBoolExp>;
  roleScopesAggregate?: InputMaybe<RoleScopesAggregateBoolExp>;
  scopeDefiners?: InputMaybe<ScopeDefinersBoolExp>;
  scopeDefinersAggregate?: InputMaybe<ScopeDefinersAggregateBoolExp>;
  scopeInheritabilities?: InputMaybe<ScopesBoolExp>;
  scopeInheritabilitiesAggregate?: InputMaybe<ScopesAggregateBoolExp>;
  scopeSnapshots?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeSnapshotsAggregate?: InputMaybe<ScopeSnapshotsAggregateBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  validatableScopeSnapshotChildInheritances?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
  validatableScopeSnapshotParentInheritances?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};

/** unique or primary key constraints on table "scopes" */
export enum ScopesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ScopesIdTenantIdKey = 'scopes_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  ScopesPkey = 'scopes_pkey',
  /** unique or primary key constraint on columns "name", "tenant_id" */
  ScopesTenantIdNameKey = 'scopes_tenant_id_name_key'
}

/** input type for incrementing numeric columns in table "scopes" */
export type ScopesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scopes" */
export type ScopesInsertInput = {
  deployments?: InputMaybe<DeploymentsArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  roleScopes?: InputMaybe<RoleScopesArrRelInsertInput>;
  scopeDefiners?: InputMaybe<ScopeDefinersArrRelInsertInput>;
  scopeInheritabilities?: InputMaybe<ScopesArrRelInsertInput>;
  scopeSnapshots?: InputMaybe<ScopeSnapshotsArrRelInsertInput>;
};

/** aggregate max on columns */
export type ScopesMaxFields = {
  __typename?: 'ScopesMaxFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  tenantId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "scopes" */
export type ScopesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScopesMinFields = {
  __typename?: 'ScopesMinFields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  tenantId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "scopes" */
export type ScopesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scopes" */
export type ScopesMutationResponse = {
  __typename?: 'ScopesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scopes>;
};

/** input type for inserting object relation for remote table "scopes" */
export type ScopesObjRelInsertInput = {
  data: ScopesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ScopesOnConflict>;
};

/** on_conflict condition type for table "scopes" */
export type ScopesOnConflict = {
  constraint: ScopesConstraint;
  updateColumns?: Array<ScopesUpdateColumn>;
  where?: InputMaybe<ScopesBoolExp>;
};

/** Ordering options when selecting data from "scopes". */
export type ScopesOrderBy = {
  comparableScopeDefinersAggregate?: InputMaybe<AllComparableScopeDefinersAggregateOrderBy>;
  comparableScopeDefinition?: InputMaybe<AllComparableScopeDefinitionsOrderBy>;
  deploymentsAggregate?: InputMaybe<DeploymentsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  roleScopesAggregate?: InputMaybe<RoleScopesAggregateOrderBy>;
  scopeDefinersAggregate?: InputMaybe<ScopeDefinersAggregateOrderBy>;
  scopeInheritabilitiesAggregate?: InputMaybe<ScopesAggregateOrderBy>;
  scopeSnapshotsAggregate?: InputMaybe<ScopeSnapshotsAggregateOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  validatableScopeSnapshotChildInheritancesAggregate?: InputMaybe<AllValidatableScopeContainmentsAggregateOrderBy>;
  validatableScopeSnapshotParentInheritancesAggregate?: InputMaybe<AllValidatableScopeContainmentsAggregateOrderBy>;
};

/** primary key columns input for table: scopes */
export type ScopesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scopes" */
export enum ScopesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenantId'
}

/** input type for updating data in table "scopes" */
export type ScopesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ScopesStddevFields = {
  __typename?: 'ScopesStddevFields';
  id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scopes" */
export type ScopesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ScopesStddevPopFields = {
  __typename?: 'ScopesStddevPopFields';
  id: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "scopes" */
export type ScopesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ScopesStddevSampFields = {
  __typename?: 'ScopesStddevSampFields';
  id: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "scopes" */
export type ScopesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scopes" */
export type ScopesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScopesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScopesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ScopesSumFields = {
  __typename?: 'ScopesSumFields';
  id: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scopes" */
export type ScopesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "scopes" */
export enum ScopesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type ScopesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScopesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScopesSetInput>;
  /** filter the rows which have to be updated */
  where: ScopesBoolExp;
};

/** aggregate varPop on columns */
export type ScopesVarPopFields = {
  __typename?: 'ScopesVarPopFields';
  id: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "scopes" */
export type ScopesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ScopesVarSampFields = {
  __typename?: 'ScopesVarSampFields';
  id: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "scopes" */
export type ScopesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScopesVarianceFields = {
  __typename?: 'ScopesVarianceFields';
  id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scopes" */
export type ScopesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Return type for set_scope_option_children(...). Exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type SetScopeOptionChildrenReturnType = {
  __typename?: 'SetScopeOptionChildrenReturnType';
  parentScopeOptionId: Maybe<Scalars['Int']>;
  parentScopeOptionTreeEdgesAfter: Maybe<Scalars['jsonb']>;
  parentScopeOptionTreeEdgesBefore: Maybe<Scalars['jsonb']>;
  reconciledScopes: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  scopeVariable: Maybe<ScopeVariables>;
  scopeVariableId: Maybe<Scalars['Int']>;
};


/** Return type for set_scope_option_children(...). Exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type SetScopeOptionChildrenReturnTypeParentScopeOptionTreeEdgesAfterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Return type for set_scope_option_children(...). Exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type SetScopeOptionChildrenReturnTypeParentScopeOptionTreeEdgesBeforeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Return type for set_scope_option_children(...). Exists only to provide a named composite return type for PostgreSQL/Hasura. */
export type SetScopeOptionChildrenReturnTypeReconciledScopesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "set_scope_option_children_return_type". All fields are combined with a logical 'AND'. */
export type SetScopeOptionChildrenReturnTypeBoolExp = {
  _and?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeBoolExp>>;
  _not?: InputMaybe<SetScopeOptionChildrenReturnTypeBoolExp>;
  _or?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeBoolExp>>;
  parentScopeOptionId?: InputMaybe<IntComparisonExp>;
  parentScopeOptionTreeEdgesAfter?: InputMaybe<JsonbComparisonExp>;
  parentScopeOptionTreeEdgesBefore?: InputMaybe<JsonbComparisonExp>;
  reconciledScopes?: InputMaybe<JsonbComparisonExp>;
  scopeVariable?: InputMaybe<ScopeVariablesBoolExp>;
  scopeVariableId?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "set_scope_option_children_return_type". */
export type SetScopeOptionChildrenReturnTypeOrderBy = {
  parentScopeOptionId?: InputMaybe<OrderBy>;
  parentScopeOptionTreeEdgesAfter?: InputMaybe<OrderBy>;
  parentScopeOptionTreeEdgesBefore?: InputMaybe<OrderBy>;
  reconciledScopes?: InputMaybe<OrderBy>;
  scopeVariable?: InputMaybe<ScopeVariablesOrderBy>;
  scopeVariableId?: InputMaybe<OrderBy>;
};

/** select columns of table "set_scope_option_children_return_type" */
export enum SetScopeOptionChildrenReturnTypeSelectColumn {
  /** column name */
  ParentScopeOptionId = 'parentScopeOptionId',
  /** column name */
  ParentScopeOptionTreeEdgesAfter = 'parentScopeOptionTreeEdgesAfter',
  /** column name */
  ParentScopeOptionTreeEdgesBefore = 'parentScopeOptionTreeEdgesBefore',
  /** column name */
  ReconciledScopes = 'reconciledScopes',
  /** column name */
  ScopeVariableId = 'scopeVariableId'
}

/** Streaming cursor of the table "set_scope_option_children_return_type" */
export type SetScopeOptionChildrenReturnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SetScopeOptionChildrenReturnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SetScopeOptionChildrenReturnTypeStreamCursorValueInput = {
  parentScopeOptionId?: InputMaybe<Scalars['Int']>;
  parentScopeOptionTreeEdgesAfter?: InputMaybe<Scalars['jsonb']>;
  parentScopeOptionTreeEdgesBefore?: InputMaybe<Scalars['jsonb']>;
  reconciledScopes?: InputMaybe<Scalars['jsonb']>;
  scopeVariableId?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "sortable_scope_option_tree_node". All fields are combined with logical 'AND'. */
export type SortableScopeOptionTreeNodeArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _eq?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _gt?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _gte?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _in?: InputMaybe<Array<Array<Scalars['sortable_scope_option_tree_node']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _lte?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _neq?: InputMaybe<Array<Scalars['sortable_scope_option_tree_node']>>;
  _nin?: InputMaybe<Array<Array<Scalars['sortable_scope_option_tree_node']>>>;
};

/** Exposes the ordinal position of each attribute in the sortable_scope_option_tree_node composite type. These ordinals define the comparison precedence used by PostgreSQL when comparing sortable scope option tree nodes. */
export type SortableScopeOptionTreeNodeAttributeOrdinals = {
  __typename?: 'SortableScopeOptionTreeNodeAttributeOrdinals';
  id: Maybe<Scalars['Int']>;
  ordinalWithinParent: Maybe<Scalars['Int']>;
  ordinalWithinParentIsNull: Maybe<Scalars['Int']>;
  soId: Maybe<Scalars['Int']>;
  soValue: Maybe<Scalars['Int']>;
  svOrdinal: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "sortable_scope_option_tree_node_attribute_ordinals". All fields are combined with a logical 'AND'. */
export type SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp = {
  _and?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>>;
  _not?: InputMaybe<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>;
  _or?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  ordinalWithinParent?: InputMaybe<IntComparisonExp>;
  ordinalWithinParentIsNull?: InputMaybe<IntComparisonExp>;
  soId?: InputMaybe<IntComparisonExp>;
  soValue?: InputMaybe<IntComparisonExp>;
  svOrdinal?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "sortable_scope_option_tree_node_attribute_ordinals". */
export type SortableScopeOptionTreeNodeAttributeOrdinalsOrderBy = {
  id?: InputMaybe<OrderBy>;
  ordinalWithinParent?: InputMaybe<OrderBy>;
  ordinalWithinParentIsNull?: InputMaybe<OrderBy>;
  soId?: InputMaybe<OrderBy>;
  soValue?: InputMaybe<OrderBy>;
  svOrdinal?: InputMaybe<OrderBy>;
};

/** select columns of table "sortable_scope_option_tree_node_attribute_ordinals" */
export enum SortableScopeOptionTreeNodeAttributeOrdinalsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  OrdinalWithinParent = 'ordinalWithinParent',
  /** column name */
  OrdinalWithinParentIsNull = 'ordinalWithinParentIsNull',
  /** column name */
  SoId = 'soId',
  /** column name */
  SoValue = 'soValue',
  /** column name */
  SvOrdinal = 'svOrdinal'
}

/** Streaming cursor of the table "sortable_scope_option_tree_node_attribute_ordinals" */
export type SortableScopeOptionTreeNodeAttributeOrdinalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SortableScopeOptionTreeNodeAttributeOrdinalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SortableScopeOptionTreeNodeAttributeOrdinalsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  ordinalWithinParent?: InputMaybe<Scalars['Int']>;
  ordinalWithinParentIsNull?: InputMaybe<Scalars['Int']>;
  soId?: InputMaybe<Scalars['Int']>;
  soValue?: InputMaybe<Scalars['Int']>;
  svOrdinal?: InputMaybe<Scalars['Int']>;
};

/** Links a scope snapshot to it's parent scope snapshots in order to implement scope snapshot inheritance. A scope snapshot can have multiple parent scope snapshots. Scope snapshot inheritance results in all of the flag nodes and flag values (unless overridden) in the ancestor scope snapshots being made available to the current scope snapshot. See scope_snapshot_inheritances if you want to see all of the ancestors of a scope snapshot., rather than just it's parents. Keep in mind that a scope_snapshot can only define it's parents, not it's grandparents or further ancestors. This is to ensure that a parent scope snapshot, when inherited, consistently holds the same data and always has it's dependencies fulfilled (dependencies such as specific ancestor scope snapshots, along with their flag nodes/values).     ----------     ***IMPORTANT***: Make sure the refresh_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction, thus allowing the ensure_integrity_of_ss_inheritances_trigger on the ss_inheritances table to validate the final correct inheritances data (as opposed to failing on intermediate data). Same goes for the validate_scope_snapshot_ancestry_trigger (make sure it stays as a DEFERRABLE INITIALLY DEFERRED trigger). */
export type SsDirectInheritances = {
  __typename?: 'SsDirectInheritances';
  /** An object relationship */
  directlyInheritedScope: Maybe<Scopes>;
  directlyInheritedScopeId: Scalars['Int'];
  /** An object relationship */
  directlyInheritedScopeSnapshot: Maybe<ScopeSnapshots>;
  directlyInheritedScopeSnapshotId: Scalars['Int'];
  id: Scalars['Int'];
  inheritedScopeSnapshot: ScopeSnapshots;
  ordinal: Scalars['Int'];
  /** An object relationship */
  scopeSnapshot: ScopeSnapshots;
  scopeSnapshotId: Scalars['Int'];
};

/** order by aggregate values of table "ss_direct_inheritances" */
export type SsDirectInheritancesAggregateOrderBy = {
  avg?: InputMaybe<SsDirectInheritancesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SsDirectInheritancesMaxOrderBy>;
  min?: InputMaybe<SsDirectInheritancesMinOrderBy>;
  stddev?: InputMaybe<SsDirectInheritancesStddevOrderBy>;
  stddevPop?: InputMaybe<SsDirectInheritancesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SsDirectInheritancesStddevSampOrderBy>;
  sum?: InputMaybe<SsDirectInheritancesSumOrderBy>;
  varPop?: InputMaybe<SsDirectInheritancesVarPopOrderBy>;
  varSamp?: InputMaybe<SsDirectInheritancesVarSampOrderBy>;
  variance?: InputMaybe<SsDirectInheritancesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ss_direct_inheritances" */
export type SsDirectInheritancesArrRelInsertInput = {
  data: Array<SsDirectInheritancesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SsDirectInheritancesOnConflict>;
};

/** order by avg() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesAvgOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ss_direct_inheritances". All fields are combined with a logical 'AND'. */
export type SsDirectInheritancesBoolExp = {
  _and?: InputMaybe<Array<SsDirectInheritancesBoolExp>>;
  _not?: InputMaybe<SsDirectInheritancesBoolExp>;
  _or?: InputMaybe<Array<SsDirectInheritancesBoolExp>>;
  directlyInheritedScope?: InputMaybe<ScopesBoolExp>;
  directlyInheritedScopeId?: InputMaybe<IntComparisonExp>;
  directlyInheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  directlyInheritedScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  ordinal?: InputMaybe<IntComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "ss_direct_inheritances" */
export enum SsDirectInheritancesConstraint {
  /** unique or primary key constraint on columns "id" */
  ScopeLinksPkey = 'scope_links_pkey',
  /** unique or primary key constraint on columns "ordinal", "scope_snapshot_id" */
  ScopeSnapshotParentConnectionsScopeSnapshotIdOrdinalKey = 'scope_snapshot_parent_connections_scope_snapshot_id_ordinal_key',
  /** unique or primary key constraint on columns "scope_snapshot_id", "directly_inherited_scope_id" */
  ScopeSnapshotParentConnectionsScopeSnapshotIdParentScop = 'scope_snapshot_parent_connections_scope_snapshot_id_parent_scop'
}

/** input type for incrementing numeric columns in table "ss_direct_inheritances" */
export type SsDirectInheritancesIncInput = {
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ss_direct_inheritances" */
export type SsDirectInheritancesInsertInput = {
  directlyInheritedScope?: InputMaybe<ScopesObjRelInsertInput>;
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsObjRelInsertInput>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsObjRelInsertInput>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesMaxOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesMinOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ss_direct_inheritances" */
export type SsDirectInheritancesMutationResponse = {
  __typename?: 'SsDirectInheritancesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SsDirectInheritances>;
};

/** on_conflict condition type for table "ss_direct_inheritances" */
export type SsDirectInheritancesOnConflict = {
  constraint: SsDirectInheritancesConstraint;
  updateColumns?: Array<SsDirectInheritancesUpdateColumn>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};

/** Ordering options when selecting data from "ss_direct_inheritances". */
export type SsDirectInheritancesOrderBy = {
  directlyInheritedScope?: InputMaybe<ScopesOrderBy>;
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ss_direct_inheritances */
export type SsDirectInheritancesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "ss_direct_inheritances" */
export enum SsDirectInheritancesSelectColumn {
  /** column name */
  DirectlyInheritedScopeId = 'directlyInheritedScopeId',
  /** column name */
  DirectlyInheritedScopeSnapshotId = 'directlyInheritedScopeSnapshotId',
  /** column name */
  Id = 'id',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId'
}

/** input type for updating data in table "ss_direct_inheritances" */
export type SsDirectInheritancesSetInput = {
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesStddevOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesStddevPopOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesStddevSampOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ss_direct_inheritances" */
export type SsDirectInheritancesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SsDirectInheritancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SsDirectInheritancesStreamCursorValueInput = {
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ordinal?: InputMaybe<Scalars['Int']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesSumOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** update columns of table "ss_direct_inheritances" */
export enum SsDirectInheritancesUpdateColumn {
  /** column name */
  DirectlyInheritedScopeId = 'directlyInheritedScopeId',
  /** column name */
  DirectlyInheritedScopeSnapshotId = 'directlyInheritedScopeSnapshotId',
  /** column name */
  Id = 'id',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId'
}

export type SsDirectInheritancesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SsDirectInheritancesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SsDirectInheritancesSetInput>;
  /** filter the rows which have to be updated */
  where: SsDirectInheritancesBoolExp;
};

/** order by varPop() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesVarPopOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesVarSampOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "ss_direct_inheritances" */
export type SsDirectInheritancesVarianceOrderBy = {
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** DO NOT UPDATE THIS TABLE MANUALLY! It is only to be automatically updated by the trigger functions on the direct_inheritances table whenever it's rows are inserted/updated/deleted. Also, although this inheritances table may seem like a duplicate of the inheritance_references view, this table serves different purposes: (1) It is so that we can enforce foreign key constraints from other tables, such as the flag_nodes table. Specifically, we want to avoid flag nodes from pointing to parent flag nodes where such parent flag nodes belong to a scope snapshot that is not an ancestor of the flag node's scope snapshot. These flag nodes, that point to parent flag nodes which aren't in it's scope snapshot ancestor tree, would be considered "orphan flag nodes". By having this table, along with a foreign key constraint on the flag_nodes table referencing this table, we avoid the possibility of orphan flag nodes entirely. (2) For improving query performance when finding ancestors. Although this performance reason is a moot point, since the recursive queries in the reference view are presumably fast enough to be relied on anyway.     ----------     ***IMPORTANT***: Make sure the ensure_integrity_of_ss_inheritances_trigger() here remains a DEFERRABLE INITIALLY DEFERRED trigger if you ever need to modify it. This is necessary to ensure that it runs at the end of the transaction and validates the final correct inheritances data (as opposed to failing on intermediate data). Same applies for the refresh_inherited_valued_flag_nodes_trigger - it needs to be a DEFERRABLE INITALLY DEFERRED trigger so that it executes after all ss_inheritances have been updated. Also, if you modify this table schema, make sure to update ensure_integrity_of_ss_inheritances_trigger (and its internal function calls) accordingly. */
export type SsInheritances = {
  __typename?: 'SsInheritances';
  /** An object relationship */
  directInheritance: Maybe<SsDirectInheritances>;
  id: Scalars['Int'];
  /** An object relationship */
  inheritedScope: Maybe<Scopes>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId: Scalars['Int'];
  /** An object relationship */
  inheritedScopeSnapshot: ScopeSnapshots;
  inheritedScopeSnapshotId: Scalars['Int'];
  isDirectInheritance: Scalars['Boolean'];
  isSelf: Scalars['Boolean'];
  ordinal: Scalars['bigint'];
  ordinalWithinDirectInheritances: Maybe<Scalars['bigint']>;
  /** An object relationship */
  scopeSnapshot: ScopeSnapshots;
  scopeSnapshotId: Scalars['Int'];
};

/** order by aggregate values of table "ss_inheritances" */
export type SsInheritancesAggregateOrderBy = {
  avg?: InputMaybe<SsInheritancesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SsInheritancesMaxOrderBy>;
  min?: InputMaybe<SsInheritancesMinOrderBy>;
  stddev?: InputMaybe<SsInheritancesStddevOrderBy>;
  stddevPop?: InputMaybe<SsInheritancesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SsInheritancesStddevSampOrderBy>;
  sum?: InputMaybe<SsInheritancesSumOrderBy>;
  varPop?: InputMaybe<SsInheritancesVarPopOrderBy>;
  varSamp?: InputMaybe<SsInheritancesVarSampOrderBy>;
  variance?: InputMaybe<SsInheritancesVarianceOrderBy>;
};

/** order by avg() on columns of table "ss_inheritances" */
export type SsInheritancesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ss_inheritances". All fields are combined with a logical 'AND'. */
export type SsInheritancesBoolExp = {
  _and?: InputMaybe<Array<SsInheritancesBoolExp>>;
  _not?: InputMaybe<SsInheritancesBoolExp>;
  _or?: InputMaybe<Array<SsInheritancesBoolExp>>;
  directInheritance?: InputMaybe<SsDirectInheritancesBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  inheritedScope?: InputMaybe<ScopesBoolExp>;
  inheritedScopeId?: InputMaybe<IntComparisonExp>;
  inheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  inheritedScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  isDirectInheritance?: InputMaybe<BooleanComparisonExp>;
  isSelf?: InputMaybe<BooleanComparisonExp>;
  ordinal?: InputMaybe<BigintComparisonExp>;
  ordinalWithinDirectInheritances?: InputMaybe<BigintComparisonExp>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsBoolExp>;
  scopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "ss_inheritances" */
export type SsInheritancesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "ss_inheritances" */
export type SsInheritancesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "ss_inheritances". */
export type SsInheritancesOrderBy = {
  directInheritance?: InputMaybe<SsDirectInheritancesOrderBy>;
  id?: InputMaybe<OrderBy>;
  inheritedScope?: InputMaybe<ScopesOrderBy>;
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  isDirectInheritance?: InputMaybe<OrderBy>;
  isSelf?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshot?: InputMaybe<ScopeSnapshotsOrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** select columns of table "ss_inheritances" */
export enum SsInheritancesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  InheritedScopeId = 'inheritedScopeId',
  /** column name */
  InheritedScopeSnapshotId = 'inheritedScopeSnapshotId',
  /** column name */
  IsDirectInheritance = 'isDirectInheritance',
  /** column name */
  IsSelf = 'isSelf',
  /** column name */
  Ordinal = 'ordinal',
  /** column name */
  OrdinalWithinDirectInheritances = 'ordinalWithinDirectInheritances',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId'
}

/** order by stddev() on columns of table "ss_inheritances" */
export type SsInheritancesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "ss_inheritances" */
export type SsInheritancesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "ss_inheritances" */
export type SsInheritancesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ss_inheritances" */
export type SsInheritancesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SsInheritancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SsInheritancesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<Scalars['Int']>;
  inheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  isDirectInheritance?: InputMaybe<Scalars['Boolean']>;
  isSelf?: InputMaybe<Scalars['Boolean']>;
  ordinal?: InputMaybe<Scalars['bigint']>;
  ordinalWithinDirectInheritances?: InputMaybe<Scalars['bigint']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ss_inheritances" */
export type SsInheritancesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "ss_inheritances" */
export type SsInheritancesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "ss_inheritances" */
export type SsInheritancesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "ss_inheritances" */
export type SsInheritancesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  /** This seems redundant since we already have inherited_scope_snapshot_id, but it is needed to enforce the unique constraint (scope_snapshot_id, inherited_scope_id). This says, a scope snapshot can only inherit at most one snapshot from the same scope. */
  inheritedScopeId?: InputMaybe<OrderBy>;
  inheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  ordinalWithinDirectInheritances?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: InputMaybe<Array<TenantsBoolExp>>;
  _not?: InputMaybe<TenantsBoolExp>;
  _or?: InputMaybe<Array<TenantsBoolExp>>;
  rolesAggregate?: InputMaybe<RolesAggregateBoolExp>;
  scopeVariablesAggregate?: InputMaybe<ScopeVariablesAggregateBoolExp>;
  scopesAggregate?: InputMaybe<ScopesAggregateBoolExp>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateBoolExp>;
};

/** response of any mutation on the table "tenants" */
export type TenantsMutationResponse = {
  __typename?: 'TenantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
};

/** input type for updating data in table "tenants" */
export type TenantsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type TenantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantsSetInput>;
  /** filter the rows which have to be updated */
  where: TenantsBoolExp;
};

/** columns and relationships of "test_hasura_session" */
export type TestHasuraSession = {
  __typename?: 'TestHasuraSession';
  hasuraUser: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "test_hasura_session". All fields are combined with a logical 'AND'. */
export type TestHasuraSessionBoolExp = {
  _and?: InputMaybe<Array<TestHasuraSessionBoolExp>>;
  _not?: InputMaybe<TestHasuraSessionBoolExp>;
  _or?: InputMaybe<Array<TestHasuraSessionBoolExp>>;
  hasuraUser?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "test_hasura_session". */
export type TestHasuraSessionOrderBy = {
  hasuraUser?: InputMaybe<OrderBy>;
};

/** select columns of table "test_hasura_session" */
export enum TestHasuraSessionSelectColumn {
  /** column name */
  HasuraUser = 'hasuraUser'
}

/** Streaming cursor of the table "test_hasura_session" */
export type TestHasuraSessionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TestHasuraSessionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TestHasuraSessionStreamCursorValueInput = {
  hasuraUser?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type UpdateSsDirectInheritance = {
  __typename?: 'UpdateSsDirectInheritance';
  _set: UpdateSsDirectInheritanceSet;
  where: UpdateSsDirectInheritanceWhere;
};

export type UpdateSsDirectInheritanceSet = {
  __typename?: 'UpdateSsDirectInheritanceSet';
  directlyInheritedScopeSnapshotId: Scalars['Int'];
  ordinal: Scalars['Int'];
};

export type UpdateSsDirectInheritanceWhere = {
  __typename?: 'UpdateSsDirectInheritanceWhere';
  directlyInheritedScopeId: EqualToIntExpression;
  scopeSnapshotId: EqualToIntExpression;
};

/** The roles assigned to a user. For example, a user could be an engineer or a manager, or both. */
export type UserRoles = {
  __typename?: 'UserRoles';
  id: Scalars['Int'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['Int'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "user_roles" */
export type UserRolesAggregate = {
  __typename?: 'UserRolesAggregate';
  aggregate: Maybe<UserRolesAggregateFields>;
  nodes: Array<UserRoles>;
};

export type UserRolesAggregateBoolExp = {
  count?: InputMaybe<UserRolesAggregateBoolExpCount>;
};

/** aggregate fields of "user_roles" */
export type UserRolesAggregateFields = {
  __typename?: 'UserRolesAggregateFields';
  avg: Maybe<UserRolesAvgFields>;
  count: Scalars['Int'];
  max: Maybe<UserRolesMaxFields>;
  min: Maybe<UserRolesMinFields>;
  stddev: Maybe<UserRolesStddevFields>;
  stddevPop: Maybe<UserRolesStddevPopFields>;
  stddevSamp: Maybe<UserRolesStddevSampFields>;
  sum: Maybe<UserRolesSumFields>;
  varPop: Maybe<UserRolesVarPopFields>;
  varSamp: Maybe<UserRolesVarSampFields>;
  variance: Maybe<UserRolesVarianceFields>;
};


/** aggregate fields of "user_roles" */
export type UserRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type UserRolesAggregateOrderBy = {
  avg?: InputMaybe<UserRolesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserRolesMaxOrderBy>;
  min?: InputMaybe<UserRolesMinOrderBy>;
  stddev?: InputMaybe<UserRolesStddevOrderBy>;
  stddevPop?: InputMaybe<UserRolesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserRolesStddevSampOrderBy>;
  sum?: InputMaybe<UserRolesSumOrderBy>;
  varPop?: InputMaybe<UserRolesVarPopOrderBy>;
  varSamp?: InputMaybe<UserRolesVarSampOrderBy>;
  variance?: InputMaybe<UserRolesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_roles" */
export type UserRolesArrRelInsertInput = {
  data: Array<UserRolesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserRolesOnConflict>;
};

/** aggregate avg on columns */
export type UserRolesAvgFields = {
  __typename?: 'UserRolesAvgFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_roles" */
export type UserRolesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type UserRolesBoolExp = {
  _and?: InputMaybe<Array<UserRolesBoolExp>>;
  _not?: InputMaybe<UserRolesBoolExp>;
  _or?: InputMaybe<Array<UserRolesBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  role?: InputMaybe<RolesBoolExp>;
  roleId?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum UserRolesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role_id" */
  UserRolesRoleIdUserIdKey = 'user_roles_role_id_user_id_key'
}

/** input type for incrementing numeric columns in table "user_roles" */
export type UserRolesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles" */
export type UserRolesInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<RolesObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserRolesMaxFields = {
  __typename?: 'UserRolesMaxFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
  userId: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_roles" */
export type UserRolesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserRolesMinFields = {
  __typename?: 'UserRolesMinFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
  userId: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_roles" */
export type UserRolesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_roles" */
export type UserRolesMutationResponse = {
  __typename?: 'UserRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoles>;
};

/** on_conflict condition type for table "user_roles" */
export type UserRolesOnConflict = {
  constraint: UserRolesConstraint;
  updateColumns?: Array<UserRolesUpdateColumn>;
  where?: InputMaybe<UserRolesBoolExp>;
};

/** Ordering options when selecting data from "user_roles". */
export type UserRolesOrderBy = {
  id?: InputMaybe<OrderBy>;
  role?: InputMaybe<RolesOrderBy>;
  roleId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_roles */
export type UserRolesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "user_roles" */
export enum UserRolesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_roles" */
export type UserRolesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserRolesStddevFields = {
  __typename?: 'UserRolesStddevFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_roles" */
export type UserRolesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserRolesStddevPopFields = {
  __typename?: 'UserRolesStddevPopFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_roles" */
export type UserRolesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserRolesStddevSampFields = {
  __typename?: 'UserRolesStddevSampFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_roles" */
export type UserRolesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_roles" */
export type UserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserRolesSumFields = {
  __typename?: 'UserRolesSumFields';
  id: Maybe<Scalars['Int']>;
  roleId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_roles" */
export type UserRolesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** update columns of table "user_roles" */
export enum UserRolesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UserId = 'userId'
}

export type UserRolesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserRolesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRolesSetInput>;
  /** filter the rows which have to be updated */
  where: UserRolesBoolExp;
};

/** aggregate varPop on columns */
export type UserRolesVarPopFields = {
  __typename?: 'UserRolesVarPopFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_roles" */
export type UserRolesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserRolesVarSampFields = {
  __typename?: 'UserRolesVarSampFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_roles" */
export type UserRolesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserRolesVarianceFields = {
  __typename?: 'UserRolesVarianceFields';
  id: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_roles" */
export type UserRolesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** Memberships between users and tenants. A user may belong to multiple tenants. Tenants are presented as Projects in the frontend. */
export type UserTenants = {
  __typename?: 'UserTenants';
  createdAt: Scalars['timestamptz'];
  /** The tenant/project the user belongs to. */
  tenantId: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  /** The user who belongs to the tenant. */
  userId: Scalars['String'];
};

/** aggregated selection of "user_tenants" */
export type UserTenantsAggregate = {
  __typename?: 'UserTenantsAggregate';
  aggregate: Maybe<UserTenantsAggregateFields>;
  nodes: Array<UserTenants>;
};

export type UserTenantsAggregateBoolExp = {
  count?: InputMaybe<UserTenantsAggregateBoolExpCount>;
};

/** aggregate fields of "user_tenants" */
export type UserTenantsAggregateFields = {
  __typename?: 'UserTenantsAggregateFields';
  count: Scalars['Int'];
  max: Maybe<UserTenantsMaxFields>;
  min: Maybe<UserTenantsMinFields>;
};


/** aggregate fields of "user_tenants" */
export type UserTenantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_tenants" */
export type UserTenantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTenantsMaxOrderBy>;
  min?: InputMaybe<UserTenantsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: InputMaybe<Array<UserTenantsBoolExp>>;
  _not?: InputMaybe<UserTenantsBoolExp>;
  _or?: InputMaybe<Array<UserTenantsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type UserTenantsMaxFields = {
  __typename?: 'UserTenantsMaxFields';
  createdAt: Maybe<Scalars['timestamptz']>;
  /** The tenant/project the user belongs to. */
  tenantId: Maybe<Scalars['uuid']>;
  /** The user who belongs to the tenant. */
  userId: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_tenants" */
export type UserTenantsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  /** The tenant/project the user belongs to. */
  tenantId?: InputMaybe<OrderBy>;
  /** The user who belongs to the tenant. */
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserTenantsMinFields = {
  __typename?: 'UserTenantsMinFields';
  createdAt: Maybe<Scalars['timestamptz']>;
  /** The tenant/project the user belongs to. */
  tenantId: Maybe<Scalars['uuid']>;
  /** The user who belongs to the tenant. */
  userId: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_tenants" */
export type UserTenantsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  /** The tenant/project the user belongs to. */
  tenantId?: InputMaybe<OrderBy>;
  /** The user who belongs to the tenant. */
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_tenants". */
export type UserTenantsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_tenants" */
export enum UserTenantsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_tenants" */
export type UserTenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTenantsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The tenant/project the user belongs to. */
  tenantId?: InputMaybe<Scalars['uuid']>;
  /** The user who belongs to the tenant. */
  userId?: InputMaybe<Scalars['String']>;
};

/** List of users. Typically synced from auth0 after signup. */
export type Users = {
  __typename?: 'Users';
  email: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
};


/** List of users. Typically synced from auth0 after signup. */
export type UsersUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** List of users. Typically synced from auth0 after signup. */
export type UsersUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** List of users. Typically synced from auth0 after signup. */
export type UsersUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


/** List of users. Typically synced from auth0 after signup. */
export type UsersUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  userRoles?: InputMaybe<UserRolesBoolExp>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateBoolExp>;
  userTenants?: InputMaybe<UserTenantsBoolExp>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateOrderBy>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateOrderBy>;
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "validatable_scope_containments_return_type" */
export type ValidatableScopeContainmentsReturnType = {
  __typename?: 'ValidatableScopeContainmentsReturnType';
  containableDirectlyInheritedScopeDefinition: Maybe<Array<Scalars['String']>>;
  containableScopeDefinition: Maybe<Array<Scalars['String']>>;
  directlyInheritedScopeId: Maybe<Scalars['Int']>;
  directlyInheritedScopeSnapshotId: Maybe<Scalars['Int']>;
  /** An object relationship */
  scope: Maybe<Scopes>;
  scopeId: Maybe<Scalars['Int']>;
  scopeSnapshotId: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "validatable_scope_containments_return_type". All fields are combined with a logical 'AND'. */
export type ValidatableScopeContainmentsReturnTypeBoolExp = {
  _and?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeBoolExp>>;
  _not?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
  _or?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeBoolExp>>;
  containableDirectlyInheritedScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  containableScopeDefinition?: InputMaybe<StringArrayComparisonExp>;
  directlyInheritedScopeId?: InputMaybe<IntComparisonExp>;
  directlyInheritedScopeSnapshotId?: InputMaybe<IntComparisonExp>;
  scope?: InputMaybe<ScopesBoolExp>;
  scopeId?: InputMaybe<IntComparisonExp>;
  scopeSnapshotId?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "validatable_scope_containments_return_type". */
export type ValidatableScopeContainmentsReturnTypeOrderBy = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<OrderBy>;
  containableScopeDefinition?: InputMaybe<OrderBy>;
  directlyInheritedScopeId?: InputMaybe<OrderBy>;
  directlyInheritedScopeSnapshotId?: InputMaybe<OrderBy>;
  scope?: InputMaybe<ScopesOrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeSnapshotId?: InputMaybe<OrderBy>;
};

/** select columns of table "validatable_scope_containments_return_type" */
export enum ValidatableScopeContainmentsReturnTypeSelectColumn {
  /** column name */
  ContainableDirectlyInheritedScopeDefinition = 'containableDirectlyInheritedScopeDefinition',
  /** column name */
  ContainableScopeDefinition = 'containableScopeDefinition',
  /** column name */
  DirectlyInheritedScopeId = 'directlyInheritedScopeId',
  /** column name */
  DirectlyInheritedScopeSnapshotId = 'directlyInheritedScopeSnapshotId',
  /** column name */
  ScopeId = 'scopeId',
  /** column name */
  ScopeSnapshotId = 'scopeSnapshotId'
}

/** Streaming cursor of the table "validatable_scope_containments_return_type" */
export type ValidatableScopeContainmentsReturnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ValidatableScopeContainmentsReturnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidatableScopeContainmentsReturnTypeStreamCursorValueInput = {
  containableDirectlyInheritedScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  containableScopeDefinition?: InputMaybe<Array<Scalars['String']>>;
  directlyInheritedScopeId?: InputMaybe<Scalars['Int']>;
  directlyInheritedScopeSnapshotId?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['Int']>;
  scopeSnapshotId?: InputMaybe<Scalars['Int']>;
};

export type ValidatedSsInheritance = {
  __typename?: 'ValidatedSsInheritance';
  directChildrenIdsLimitedToInheritancesOfTarget: Array<Scalars['Int']>;
  inheritedScopeSnapshot: PrimitiveScopeSnapshot;
  inheritedScopeSnapshotId: Scalars['Int'];
  isDirectInheritance: Scalars['Boolean'];
  isSelf: Scalars['Boolean'];
  ordinal: Scalars['Int'];
  ordinalWithinDirectInheritances: Scalars['Int'];
};

export type ValidatedSsInheritanceForDescendantSs = {
  __typename?: 'ValidatedSsInheritanceForDescendantSs';
  inheritedScopeSnapshot: PrimitiveScopeSnapshot;
  inheritedScopeSnapshotId: Scalars['Int'];
  isDirectInheritance: Scalars['Boolean'];
  isSelf: Scalars['Boolean'];
  ordinal: Scalars['Int'];
  ordinalWithinDirectInheritances: Scalars['Int'];
};

export type ValidatedSsInheritanceModifications = {
  __typename?: 'ValidatedSsInheritanceModifications';
  aggregateModifications: AggregateValidatedSsInheritanceModifications;
  validationsByTargetScopeSnapshots: Array<ValidatedSsInheritanceModificationsOfOneTarget>;
};

export type ValidatedSsInheritanceModificationsOfOneTarget = {
  __typename?: 'ValidatedSsInheritanceModificationsOfOneTarget';
  ancestorScopeDifferences: Array<AncestorScopeDifference>;
  conflictsByFlagPath: Array<ConflictsForFlagPath>;
  descendantScopeDifferences: Array<DescendantScopeDifference>;
  incompatibleFlagNodes: Array<IncompatibleFlagNode>;
  incompatibleFlagValues: Array<IncompatibleFlagValue>;
  jsonConfigurationAfterModifications: Scalars['jsonb'];
  jsonConfigurationBeforeModifications: Scalars['jsonb'];
  targetScopeSnapshot: PrimitiveScopeSnapshot;
};

export type AllComparableScopeDefinersAggregateBoolExpBoolAnd = {
  arguments: AllComparableScopeDefinersSelectColumnAllComparableScopeDefinersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllComparableScopeDefinersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AllComparableScopeDefinersAggregateBoolExpBoolOr = {
  arguments: AllComparableScopeDefinersSelectColumnAllComparableScopeDefinersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllComparableScopeDefinersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AllComparableScopeDefinersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllComparableScopeDefinersBoolExp>;
  predicate: IntComparisonExp;
};

export type CompactFlagNodeArrayOrdinalsArgs = {
  defined_in_scope_snapshot_id?: InputMaybe<Scalars['Int']>;
  parent_scope_flag_node_ids?: InputMaybe<Scalars['_int4']>;
};

export type ConfigImportOperationsArgs = {
  array_import_option?: InputMaybe<Scalars['String']>;
  flag_node_import_option?: InputMaybe<Scalars['String']>;
  flag_value_import_option?: InputMaybe<Scalars['String']>;
  import_config?: InputMaybe<Scalars['jsonb']>;
  scope_snapshot_id?: InputMaybe<Scalars['Int']>;
};

export type ConfigurationArgs = {
  scope_snapshot_id?: InputMaybe<Scalars['Int']>;
};

export type ConfigurationReferencesArgs = {
  auto_remove_direct_inheritances_when_indirect_exists?: InputMaybe<Scalars['Boolean']>;
  scope_snapshot_ids?: InputMaybe<Scalars['_int4']>;
  target_ss_direct_inheritances_replacements?: InputMaybe<Scalars['_target_ss_direct_inheritances_replacement']>;
};

export type ConfigurationsArgs = {
  scope_snapshot_ids?: InputMaybe<Scalars['_int4']>;
};

export type FlagNodesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FlagNodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FlagNodesBoolExp>;
  predicate: IntComparisonExp;
};

export type FlagValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FlagValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FlagValuesBoolExp>;
  predicate: IntComparisonExp;
};

export type ImportConfigArgs = {
  array_import_option?: InputMaybe<Scalars['String']>;
  flag_node_import_option?: InputMaybe<Scalars['String']>;
  flag_value_import_option?: InputMaybe<Scalars['String']>;
  import_config?: InputMaybe<Scalars['jsonb']>;
  scope_snapshot_id?: InputMaybe<Scalars['Int']>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** execute VOLATILE function "compact_flag_node_array_ordinals" which returns "flag_nodes" */
  compactFlagNodeArrayOrdinals: Array<FlagNodes>;
  /** delete data from the table: "deployments" */
  deleteDeployments: Maybe<DeploymentsMutationResponse>;
  /** delete single row from the table: "deployments" */
  deleteDeploymentsByPk: Maybe<Deployments>;
  /** delete data from the table: "flag_nodes" */
  deleteFlagNodes: Maybe<FlagNodesMutationResponse>;
  /** delete single row from the table: "flag_nodes" */
  deleteFlagNodesByPk: Maybe<FlagNodes>;
  /** delete data from the table: "flag_values" */
  deleteFlagValues: Maybe<FlagValuesMutationResponse>;
  /** delete single row from the table: "flag_values" */
  deleteFlagValuesByPk: Maybe<FlagValues>;
  /** delete data from the table: "role_scopes" */
  deleteRoleScopes: Maybe<RoleScopesMutationResponse>;
  /** delete single row from the table: "role_scopes" */
  deleteRoleScopesByPk: Maybe<RoleScopes>;
  /** delete data from the table: "roles" */
  deleteRoles: Maybe<RolesMutationResponse>;
  /** delete single row from the table: "roles" */
  deleteRolesByPk: Maybe<Roles>;
  /** delete data from the table: "scope_definers" */
  deleteScopeDefiners: Maybe<ScopeDefinersMutationResponse>;
  /** delete single row from the table: "scope_definers" */
  deleteScopeDefinersByPk: Maybe<ScopeDefiners>;
  /** delete data from the table: "scope_flag_nodes" */
  deleteScopeFlagNodes: Maybe<ScopeFlagNodesMutationResponse>;
  /** delete single row from the table: "scope_flag_nodes" */
  deleteScopeFlagNodesByPk: Maybe<ScopeFlagNodes>;
  /** delete data from the table: "scope_option_tree_edges" */
  deleteScopeOptionTreeEdges: Maybe<ScopeOptionTreeEdgesMutationResponse>;
  /** delete single row from the table: "scope_option_tree_edges" */
  deleteScopeOptionTreeEdgesByPk: Maybe<ScopeOptionTreeEdges>;
  /** delete data from the table: "scope_options" */
  deleteScopeOptions: Maybe<ScopeOptionsMutationResponse>;
  /** delete single row from the table: "scope_options" */
  deleteScopeOptionsByPk: Maybe<ScopeOptions>;
  /** delete data from the table: "scope_snapshots" */
  deleteScopeSnapshots: Maybe<ScopeSnapshotsMutationResponse>;
  /** delete single row from the table: "scope_snapshots" */
  deleteScopeSnapshotsByPk: Maybe<ScopeSnapshots>;
  /** delete data from the table: "scope_variables" */
  deleteScopeVariables: Maybe<ScopeVariablesMutationResponse>;
  /** delete single row from the table: "scope_variables" */
  deleteScopeVariablesByPk: Maybe<ScopeVariables>;
  /** delete data from the table: "scopes" */
  deleteScopes: Maybe<ScopesMutationResponse>;
  /** delete single row from the table: "scopes" */
  deleteScopesByPk: Maybe<Scopes>;
  /** delete data from the table: "ss_direct_inheritances" */
  deleteSsDirectInheritances: Maybe<SsDirectInheritancesMutationResponse>;
  /** delete single row from the table: "ss_direct_inheritances" */
  deleteSsDirectInheritancesByPk: Maybe<SsDirectInheritances>;
  /** delete data from the table: "user_roles" */
  deleteUserRoles: Maybe<UserRolesMutationResponse>;
  /** delete single row from the table: "user_roles" */
  deleteUserRolesByPk: Maybe<UserRoles>;
  /** execute VOLATILE function "import_config" which returns "config_import_operations_return_type" */
  importConfig: Array<ConfigImportOperationsReturnType>;
  /** Import JSON as flags and values into a scope snapshot */
  importJsonIntoScopeSnapshot: Maybe<ImportedFlagNodesAndValues>;
  /** insert data into the table: "deployments" */
  insertDeployments: Maybe<DeploymentsMutationResponse>;
  /** insert a single row into the table: "deployments" */
  insertDeploymentsOne: Maybe<Deployments>;
  /** insert data into the table: "flag_nodes" */
  insertFlagNodes: Maybe<FlagNodesMutationResponse>;
  /** insert a single row into the table: "flag_nodes" */
  insertFlagNodesOne: Maybe<FlagNodes>;
  /** insert data into the table: "flag_values" */
  insertFlagValues: Maybe<FlagValuesMutationResponse>;
  /** insert a single row into the table: "flag_values" */
  insertFlagValuesOne: Maybe<FlagValues>;
  /** insert data into the table: "role_scopes" */
  insertRoleScopes: Maybe<RoleScopesMutationResponse>;
  /** insert a single row into the table: "role_scopes" */
  insertRoleScopesOne: Maybe<RoleScopes>;
  /** insert data into the table: "roles" */
  insertRoles: Maybe<RolesMutationResponse>;
  /** insert a single row into the table: "roles" */
  insertRolesOne: Maybe<Roles>;
  /** insert data into the table: "scope_definers" */
  insertScopeDefiners: Maybe<ScopeDefinersMutationResponse>;
  /** insert a single row into the table: "scope_definers" */
  insertScopeDefinersOne: Maybe<ScopeDefiners>;
  /** insert data into the table: "scope_flag_nodes" */
  insertScopeFlagNodes: Maybe<ScopeFlagNodesMutationResponse>;
  /** insert a single row into the table: "scope_flag_nodes" */
  insertScopeFlagNodesOne: Maybe<ScopeFlagNodes>;
  /** insert data into the table: "scope_option_tree_edges" */
  insertScopeOptionTreeEdges: Maybe<ScopeOptionTreeEdgesMutationResponse>;
  /** insert a single row into the table: "scope_option_tree_edges" */
  insertScopeOptionTreeEdgesOne: Maybe<ScopeOptionTreeEdges>;
  /** insert data into the table: "scope_options" */
  insertScopeOptions: Maybe<ScopeOptionsMutationResponse>;
  /** insert a single row into the table: "scope_options" */
  insertScopeOptionsOne: Maybe<ScopeOptions>;
  /** insert data into the table: "scope_snapshots" */
  insertScopeSnapshots: Maybe<ScopeSnapshotsMutationResponse>;
  /** insert a single row into the table: "scope_snapshots" */
  insertScopeSnapshotsOne: Maybe<ScopeSnapshots>;
  /** insert data into the table: "scope_variables" */
  insertScopeVariables: Maybe<ScopeVariablesMutationResponse>;
  /** insert a single row into the table: "scope_variables" */
  insertScopeVariablesOne: Maybe<ScopeVariables>;
  /** insert data into the table: "scopes" */
  insertScopes: Maybe<ScopesMutationResponse>;
  /** insert a single row into the table: "scopes" */
  insertScopesOne: Maybe<Scopes>;
  /** insert data into the table: "ss_direct_inheritances" */
  insertSsDirectInheritances: Maybe<SsDirectInheritancesMutationResponse>;
  /** insert a single row into the table: "ss_direct_inheritances" */
  insertSsDirectInheritancesOne: Maybe<SsDirectInheritances>;
  /** insert data into the table: "user_roles" */
  insertUserRoles: Maybe<UserRolesMutationResponse>;
  /** insert a single row into the table: "user_roles" */
  insertUserRolesOne: Maybe<UserRoles>;
  /** Replicate a scope snapshot's selected flags and values */
  replicateFlagsAndValues: Maybe<ReplicatedFlagsAndValues>;
  /** Replicate a scope snapshot, along with its flags and values. */
  replicateScopeSnapshot: Maybe<ReplicatedScopeSnapshot>;
  /** execute VOLATILE function "set_scope_option_children" which returns "set_scope_option_children_return_type" */
  setScopeOptionChildren: Array<SetScopeOptionChildrenReturnType>;
  /** update data of the table: "deployments" */
  updateDeployments: Maybe<DeploymentsMutationResponse>;
  /** update single row of the table: "deployments" */
  updateDeploymentsByPk: Maybe<Deployments>;
  /** update multiples rows of table: "deployments" */
  updateDeploymentsMany: Maybe<Array<Maybe<DeploymentsMutationResponse>>>;
  /** update data of the table: "flag_nodes" */
  updateFlagNodes: Maybe<FlagNodesMutationResponse>;
  /** update single row of the table: "flag_nodes" */
  updateFlagNodesByPk: Maybe<FlagNodes>;
  /** update multiples rows of table: "flag_nodes" */
  updateFlagNodesMany: Maybe<Array<Maybe<FlagNodesMutationResponse>>>;
  /** update data of the table: "flag_values" */
  updateFlagValues: Maybe<FlagValuesMutationResponse>;
  /** update single row of the table: "flag_values" */
  updateFlagValuesByPk: Maybe<FlagValues>;
  /** update multiples rows of table: "flag_values" */
  updateFlagValuesMany: Maybe<Array<Maybe<FlagValuesMutationResponse>>>;
  /** update data of the table: "role_scopes" */
  updateRoleScopes: Maybe<RoleScopesMutationResponse>;
  /** update single row of the table: "role_scopes" */
  updateRoleScopesByPk: Maybe<RoleScopes>;
  /** update multiples rows of table: "role_scopes" */
  updateRoleScopesMany: Maybe<Array<Maybe<RoleScopesMutationResponse>>>;
  /** update data of the table: "roles" */
  updateRoles: Maybe<RolesMutationResponse>;
  /** update single row of the table: "roles" */
  updateRolesByPk: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  updateRolesMany: Maybe<Array<Maybe<RolesMutationResponse>>>;
  /** update data of the table: "scope_definers" */
  updateScopeDefiners: Maybe<ScopeDefinersMutationResponse>;
  /** update single row of the table: "scope_definers" */
  updateScopeDefinersByPk: Maybe<ScopeDefiners>;
  /** update multiples rows of table: "scope_definers" */
  updateScopeDefinersMany: Maybe<Array<Maybe<ScopeDefinersMutationResponse>>>;
  /** update data of the table: "scope_flag_nodes" */
  updateScopeFlagNodes: Maybe<ScopeFlagNodesMutationResponse>;
  /** update single row of the table: "scope_flag_nodes" */
  updateScopeFlagNodesByPk: Maybe<ScopeFlagNodes>;
  /** update multiples rows of table: "scope_flag_nodes" */
  updateScopeFlagNodesMany: Maybe<Array<Maybe<ScopeFlagNodesMutationResponse>>>;
  /** update data of the table: "scope_option_tree_edges" */
  updateScopeOptionTreeEdges: Maybe<ScopeOptionTreeEdgesMutationResponse>;
  /** update single row of the table: "scope_option_tree_edges" */
  updateScopeOptionTreeEdgesByPk: Maybe<ScopeOptionTreeEdges>;
  /** update multiples rows of table: "scope_option_tree_edges" */
  updateScopeOptionTreeEdgesMany: Maybe<Array<Maybe<ScopeOptionTreeEdgesMutationResponse>>>;
  /** update data of the table: "scope_options" */
  updateScopeOptions: Maybe<ScopeOptionsMutationResponse>;
  /** update single row of the table: "scope_options" */
  updateScopeOptionsByPk: Maybe<ScopeOptions>;
  /** update multiples rows of table: "scope_options" */
  updateScopeOptionsMany: Maybe<Array<Maybe<ScopeOptionsMutationResponse>>>;
  /** update data of the table: "scope_snapshots" */
  updateScopeSnapshots: Maybe<ScopeSnapshotsMutationResponse>;
  /** update single row of the table: "scope_snapshots" */
  updateScopeSnapshotsByPk: Maybe<ScopeSnapshots>;
  /** update multiples rows of table: "scope_snapshots" */
  updateScopeSnapshotsMany: Maybe<Array<Maybe<ScopeSnapshotsMutationResponse>>>;
  /** update data of the table: "scope_variables" */
  updateScopeVariables: Maybe<ScopeVariablesMutationResponse>;
  /** update single row of the table: "scope_variables" */
  updateScopeVariablesByPk: Maybe<ScopeVariables>;
  /** update multiples rows of table: "scope_variables" */
  updateScopeVariablesMany: Maybe<Array<Maybe<ScopeVariablesMutationResponse>>>;
  /** update data of the table: "scopes" */
  updateScopes: Maybe<ScopesMutationResponse>;
  /** update single row of the table: "scopes" */
  updateScopesByPk: Maybe<Scopes>;
  /** update multiples rows of table: "scopes" */
  updateScopesMany: Maybe<Array<Maybe<ScopesMutationResponse>>>;
  /** update data of the table: "ss_direct_inheritances" */
  updateSsDirectInheritances: Maybe<SsDirectInheritancesMutationResponse>;
  /** update single row of the table: "ss_direct_inheritances" */
  updateSsDirectInheritancesByPk: Maybe<SsDirectInheritances>;
  /** update multiples rows of table: "ss_direct_inheritances" */
  updateSsDirectInheritancesMany: Maybe<Array<Maybe<SsDirectInheritancesMutationResponse>>>;
  /** update data of the table: "tenants" */
  updateTenants: Maybe<TenantsMutationResponse>;
  /** update multiples rows of table: "tenants" */
  updateTenantsMany: Maybe<Array<Maybe<TenantsMutationResponse>>>;
  /** update data of the table: "user_roles" */
  updateUserRoles: Maybe<UserRolesMutationResponse>;
  /** update single row of the table: "user_roles" */
  updateUserRolesByPk: Maybe<UserRoles>;
  /** update multiples rows of table: "user_roles" */
  updateUserRolesMany: Maybe<Array<Maybe<UserRolesMutationResponse>>>;
};


/** mutation root */
export type MutationRootCompactFlagNodeArrayOrdinalsArgs = {
  args: CompactFlagNodeArrayOrdinalsArgs;
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


/** mutation root */
export type MutationRootDeleteDeploymentsArgs = {
  where: DeploymentsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDeploymentsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteFlagNodesArgs = {
  where: FlagNodesBoolExp;
};


/** mutation root */
export type MutationRootDeleteFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteFlagValuesArgs = {
  where: FlagValuesBoolExp;
};


/** mutation root */
export type MutationRootDeleteFlagValuesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRoleScopesArgs = {
  where: RoleScopesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRoleScopesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRolesArgs = {
  where: RolesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRolesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeDefinersArgs = {
  where: ScopeDefinersBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeDefinersByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeFlagNodesArgs = {
  where: ScopeFlagNodesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeOptionTreeEdgesArgs = {
  where: ScopeOptionTreeEdgesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeOptionTreeEdgesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeOptionsArgs = {
  where: ScopeOptionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeOptionsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeSnapshotsArgs = {
  where: ScopeSnapshotsBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeSnapshotsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopeVariablesArgs = {
  where: ScopeVariablesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopeVariablesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScopesArgs = {
  where: ScopesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScopesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSsDirectInheritancesArgs = {
  where: SsDirectInheritancesBoolExp;
};


/** mutation root */
export type MutationRootDeleteSsDirectInheritancesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserRolesArgs = {
  where: UserRolesBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserRolesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootImportConfigArgs = {
  args: ImportConfigArgs;
  distinctOn?: InputMaybe<Array<ConfigImportOperationsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConfigImportOperationsReturnTypeOrderBy>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


/** mutation root */
export type MutationRootImportJsonIntoScopeSnapshotArgs = {
  flagValueImportOption: FlagValueImportOptionOld;
  importIntoScopeSnapshotId: Scalars['Int'];
  importJson: Scalars['jsonb'];
};


/** mutation root */
export type MutationRootInsertDeploymentsArgs = {
  objects: Array<DeploymentsInsertInput>;
  onConflict?: InputMaybe<DeploymentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeploymentsOneArgs = {
  object: DeploymentsInsertInput;
  onConflict?: InputMaybe<DeploymentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFlagNodesArgs = {
  objects: Array<FlagNodesInsertInput>;
  onConflict?: InputMaybe<FlagNodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertFlagNodesOneArgs = {
  object: FlagNodesInsertInput;
  onConflict?: InputMaybe<FlagNodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertFlagValuesArgs = {
  objects: Array<FlagValuesInsertInput>;
  onConflict?: InputMaybe<FlagValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertFlagValuesOneArgs = {
  object: FlagValuesInsertInput;
  onConflict?: InputMaybe<FlagValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRoleScopesArgs = {
  objects: Array<RoleScopesInsertInput>;
  onConflict?: InputMaybe<RoleScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRoleScopesOneArgs = {
  object: RoleScopesInsertInput;
  onConflict?: InputMaybe<RoleScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRolesArgs = {
  objects: Array<RolesInsertInput>;
  onConflict?: InputMaybe<RolesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRolesOneArgs = {
  object: RolesInsertInput;
  onConflict?: InputMaybe<RolesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeDefinersArgs = {
  objects: Array<ScopeDefinersInsertInput>;
  onConflict?: InputMaybe<ScopeDefinersOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeDefinersOneArgs = {
  object: ScopeDefinersInsertInput;
  onConflict?: InputMaybe<ScopeDefinersOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeFlagNodesArgs = {
  objects: Array<ScopeFlagNodesInsertInput>;
  onConflict?: InputMaybe<ScopeFlagNodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeFlagNodesOneArgs = {
  object: ScopeFlagNodesInsertInput;
  onConflict?: InputMaybe<ScopeFlagNodesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeOptionTreeEdgesArgs = {
  objects: Array<ScopeOptionTreeEdgesInsertInput>;
  onConflict?: InputMaybe<ScopeOptionTreeEdgesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeOptionTreeEdgesOneArgs = {
  object: ScopeOptionTreeEdgesInsertInput;
  onConflict?: InputMaybe<ScopeOptionTreeEdgesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeOptionsArgs = {
  objects: Array<ScopeOptionsInsertInput>;
  onConflict?: InputMaybe<ScopeOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeOptionsOneArgs = {
  object: ScopeOptionsInsertInput;
  onConflict?: InputMaybe<ScopeOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeSnapshotsArgs = {
  objects: Array<ScopeSnapshotsInsertInput>;
  onConflict?: InputMaybe<ScopeSnapshotsOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeSnapshotsOneArgs = {
  object: ScopeSnapshotsInsertInput;
  onConflict?: InputMaybe<ScopeSnapshotsOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeVariablesArgs = {
  objects: Array<ScopeVariablesInsertInput>;
  onConflict?: InputMaybe<ScopeVariablesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopeVariablesOneArgs = {
  object: ScopeVariablesInsertInput;
  onConflict?: InputMaybe<ScopeVariablesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopesArgs = {
  objects: Array<ScopesInsertInput>;
  onConflict?: InputMaybe<ScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScopesOneArgs = {
  object: ScopesInsertInput;
  onConflict?: InputMaybe<ScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertSsDirectInheritancesArgs = {
  objects: Array<SsDirectInheritancesInsertInput>;
  onConflict?: InputMaybe<SsDirectInheritancesOnConflict>;
};


/** mutation root */
export type MutationRootInsertSsDirectInheritancesOneArgs = {
  object: SsDirectInheritancesInsertInput;
  onConflict?: InputMaybe<SsDirectInheritancesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesArgs = {
  objects: Array<UserRolesInsertInput>;
  onConflict?: InputMaybe<UserRolesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesOneArgs = {
  object: UserRolesInsertInput;
  onConflict?: InputMaybe<UserRolesOnConflict>;
};


/** mutation root */
export type MutationRootReplicateFlagsAndValuesArgs = {
  destinationScopeSnapshotId: Scalars['Int'];
  replicateFlagsOfScopeFlagNodeIds: Array<Scalars['Int']>;
  replicateFromScopeSnapshotId: Scalars['Int'];
  replicateValuesOfScopeFlagNodeIds: Array<Scalars['Int']>;
};


/** mutation root */
export type MutationRootReplicateScopeSnapshotArgs = {
  newDirectlyInheritedScopeSnapshotIds: Array<Scalars['Int']>;
  newScopeVersion: Scalars['String'];
  replicateScopeSnapshotId: Scalars['Int'];
};


/** mutation root */
export type MutationRootSetScopeOptionChildrenArgs = {
  args: SetScopeOptionChildrenArgs;
  distinctOn?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeOrderBy>>;
  where?: InputMaybe<SetScopeOptionChildrenReturnTypeBoolExp>;
};


/** mutation root */
export type MutationRootUpdateDeploymentsArgs = {
  _inc?: InputMaybe<DeploymentsIncInput>;
  _set?: InputMaybe<DeploymentsSetInput>;
  where: DeploymentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDeploymentsByPkArgs = {
  _inc?: InputMaybe<DeploymentsIncInput>;
  _set?: InputMaybe<DeploymentsSetInput>;
  pkColumns: DeploymentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDeploymentsManyArgs = {
  updates: Array<DeploymentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateFlagNodesArgs = {
  _inc?: InputMaybe<FlagNodesIncInput>;
  _set?: InputMaybe<FlagNodesSetInput>;
  where: FlagNodesBoolExp;
};


/** mutation root */
export type MutationRootUpdateFlagNodesByPkArgs = {
  _inc?: InputMaybe<FlagNodesIncInput>;
  _set?: InputMaybe<FlagNodesSetInput>;
  pkColumns: FlagNodesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFlagNodesManyArgs = {
  updates: Array<FlagNodesUpdates>;
};


/** mutation root */
export type MutationRootUpdateFlagValuesArgs = {
  _append?: InputMaybe<FlagValuesAppendInput>;
  _deleteAtPath?: InputMaybe<FlagValuesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<FlagValuesDeleteElemInput>;
  _deleteKey?: InputMaybe<FlagValuesDeleteKeyInput>;
  _inc?: InputMaybe<FlagValuesIncInput>;
  _prepend?: InputMaybe<FlagValuesPrependInput>;
  _set?: InputMaybe<FlagValuesSetInput>;
  where: FlagValuesBoolExp;
};


/** mutation root */
export type MutationRootUpdateFlagValuesByPkArgs = {
  _append?: InputMaybe<FlagValuesAppendInput>;
  _deleteAtPath?: InputMaybe<FlagValuesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<FlagValuesDeleteElemInput>;
  _deleteKey?: InputMaybe<FlagValuesDeleteKeyInput>;
  _inc?: InputMaybe<FlagValuesIncInput>;
  _prepend?: InputMaybe<FlagValuesPrependInput>;
  _set?: InputMaybe<FlagValuesSetInput>;
  pkColumns: FlagValuesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFlagValuesManyArgs = {
  updates: Array<FlagValuesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRoleScopesArgs = {
  _inc?: InputMaybe<RoleScopesIncInput>;
  _set?: InputMaybe<RoleScopesSetInput>;
  where: RoleScopesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRoleScopesByPkArgs = {
  _inc?: InputMaybe<RoleScopesIncInput>;
  _set?: InputMaybe<RoleScopesSetInput>;
  pkColumns: RoleScopesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRoleScopesManyArgs = {
  updates: Array<RoleScopesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRolesArgs = {
  _set?: InputMaybe<RolesSetInput>;
  where: RolesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRolesByPkArgs = {
  _set?: InputMaybe<RolesSetInput>;
  pkColumns: RolesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRolesManyArgs = {
  updates: Array<RolesUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeDefinersArgs = {
  _inc?: InputMaybe<ScopeDefinersIncInput>;
  _set?: InputMaybe<ScopeDefinersSetInput>;
  where: ScopeDefinersBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeDefinersByPkArgs = {
  _inc?: InputMaybe<ScopeDefinersIncInput>;
  _set?: InputMaybe<ScopeDefinersSetInput>;
  pkColumns: ScopeDefinersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeDefinersManyArgs = {
  updates: Array<ScopeDefinersUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeFlagNodesArgs = {
  _inc?: InputMaybe<ScopeFlagNodesIncInput>;
  _set?: InputMaybe<ScopeFlagNodesSetInput>;
  where: ScopeFlagNodesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeFlagNodesByPkArgs = {
  _inc?: InputMaybe<ScopeFlagNodesIncInput>;
  _set?: InputMaybe<ScopeFlagNodesSetInput>;
  pkColumns: ScopeFlagNodesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeFlagNodesManyArgs = {
  updates: Array<ScopeFlagNodesUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeOptionTreeEdgesArgs = {
  _inc?: InputMaybe<ScopeOptionTreeEdgesIncInput>;
  _set?: InputMaybe<ScopeOptionTreeEdgesSetInput>;
  where: ScopeOptionTreeEdgesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeOptionTreeEdgesByPkArgs = {
  _inc?: InputMaybe<ScopeOptionTreeEdgesIncInput>;
  _set?: InputMaybe<ScopeOptionTreeEdgesSetInput>;
  pkColumns: ScopeOptionTreeEdgesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeOptionTreeEdgesManyArgs = {
  updates: Array<ScopeOptionTreeEdgesUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeOptionsArgs = {
  _inc?: InputMaybe<ScopeOptionsIncInput>;
  _set?: InputMaybe<ScopeOptionsSetInput>;
  where: ScopeOptionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeOptionsByPkArgs = {
  _inc?: InputMaybe<ScopeOptionsIncInput>;
  _set?: InputMaybe<ScopeOptionsSetInput>;
  pkColumns: ScopeOptionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeOptionsManyArgs = {
  updates: Array<ScopeOptionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeSnapshotsArgs = {
  _inc?: InputMaybe<ScopeSnapshotsIncInput>;
  _set?: InputMaybe<ScopeSnapshotsSetInput>;
  where: ScopeSnapshotsBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeSnapshotsByPkArgs = {
  _inc?: InputMaybe<ScopeSnapshotsIncInput>;
  _set?: InputMaybe<ScopeSnapshotsSetInput>;
  pkColumns: ScopeSnapshotsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeSnapshotsManyArgs = {
  updates: Array<ScopeSnapshotsUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopeVariablesArgs = {
  _inc?: InputMaybe<ScopeVariablesIncInput>;
  _set?: InputMaybe<ScopeVariablesSetInput>;
  where: ScopeVariablesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopeVariablesByPkArgs = {
  _inc?: InputMaybe<ScopeVariablesIncInput>;
  _set?: InputMaybe<ScopeVariablesSetInput>;
  pkColumns: ScopeVariablesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopeVariablesManyArgs = {
  updates: Array<ScopeVariablesUpdates>;
};


/** mutation root */
export type MutationRootUpdateScopesArgs = {
  _inc?: InputMaybe<ScopesIncInput>;
  _set?: InputMaybe<ScopesSetInput>;
  where: ScopesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScopesByPkArgs = {
  _inc?: InputMaybe<ScopesIncInput>;
  _set?: InputMaybe<ScopesSetInput>;
  pkColumns: ScopesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScopesManyArgs = {
  updates: Array<ScopesUpdates>;
};


/** mutation root */
export type MutationRootUpdateSsDirectInheritancesArgs = {
  _inc?: InputMaybe<SsDirectInheritancesIncInput>;
  _set?: InputMaybe<SsDirectInheritancesSetInput>;
  where: SsDirectInheritancesBoolExp;
};


/** mutation root */
export type MutationRootUpdateSsDirectInheritancesByPkArgs = {
  _inc?: InputMaybe<SsDirectInheritancesIncInput>;
  _set?: InputMaybe<SsDirectInheritancesSetInput>;
  pkColumns: SsDirectInheritancesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSsDirectInheritancesManyArgs = {
  updates: Array<SsDirectInheritancesUpdates>;
};


/** mutation root */
export type MutationRootUpdateTenantsArgs = {
  _set?: InputMaybe<TenantsSetInput>;
  where: TenantsBoolExp;
};


/** mutation root */
export type MutationRootUpdateTenantsManyArgs = {
  updates: Array<TenantsUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserRolesArgs = {
  _inc?: InputMaybe<UserRolesIncInput>;
  _set?: InputMaybe<UserRolesSetInput>;
  where: UserRolesBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserRolesByPkArgs = {
  _inc?: InputMaybe<UserRolesIncInput>;
  _set?: InputMaybe<UserRolesSetInput>;
  pkColumns: UserRolesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserRolesManyArgs = {
  updates: Array<UserRolesUpdates>;
};

export type OldComparableScopeDefinitionsArgs = {
  scope_ids?: InputMaybe<Scalars['_int4']>;
};

export type OldScopeOptionTreeEdgeTransitivesByScopeOptionIdArgs = {
  scope_option_id?: InputMaybe<Scalars['Int']>;
};

export type OldScopeOptionTreeEdgeTransitivesByScopeVariableIdsArgs = {
  scope_variable_ids?: InputMaybe<Scalars['_int4']>;
};

export type OldValidatableScopeContainmentsArgs = {
  scope_ids?: InputMaybe<Scalars['_int4']>;
};

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "all_comparable_scope_definers" */
  allComparableScopeDefiners: Array<AllComparableScopeDefiners>;
  /** fetch aggregated fields from the table: "all_comparable_scope_definers" */
  allComparableScopeDefinersAggregate: AllComparableScopeDefinersAggregate;
  /** fetch data from the table: "all_comparable_scope_definitions" */
  allComparableScopeDefinitions: Array<AllComparableScopeDefinitions>;
  /** fetch data from the table: "all_configurations" */
  allConfigurations: Array<AllConfigurations>;
  /** fetch data from the table: "all_scope_option_tree_edge_transitives" */
  allScopeOptionTreeEdgeTransitives: Array<AllScopeOptionTreeEdgeTransitives>;
  /** fetch data from the table: "all_sortable_scope_option_tree_nodes" */
  allSortableScopeOptionTreeNodes: Array<AllSortableScopeOptionTreeNodes>;
  /** fetch data from the table: "all_validatable_scope_containments" */
  allValidatableScopeContainments: Array<AllValidatableScopeContainments>;
  /** fetch data from the table: "array_import_options" */
  arrayImportOptions: Array<ArrayImportOptions>;
  /** fetch data from the table: "array_import_options" using primary key columns */
  arrayImportOptionsByPk: Maybe<ArrayImportOptions>;
  /** fetch data from the table: "comparable_scope_definitions_return_type" */
  comparableScopeDefinitionsReturnType: Array<ComparableScopeDefinitionsReturnType>;
  /** execute function "config_import_operations" which returns "config_import_operations_return_type" */
  configImportOperations: Array<ConfigImportOperationsReturnType>;
  /** fetch data from the table: "config_import_operations_return_type" */
  configImportOperationsReturnType: Array<ConfigImportOperationsReturnType>;
  /** execute function "configuration" which returns "all_configurations" */
  configuration: Array<AllConfigurations>;
  /** execute function "configuration_references" which returns "all_configurations" */
  configurationReferences: Array<AllConfigurations>;
  /** execute function "configurations" which returns "all_configurations" */
  configurations: Array<AllConfigurations>;
  /** An array relationship */
  deployments: Array<Deployments>;
  /** fetch data from the table: "deployments" using primary key columns */
  deploymentsByPk: Maybe<Deployments>;
  /** fetch data from the table: "flag_node_import_options" */
  flagNodeImportOptions: Array<FlagNodeImportOptions>;
  /** fetch data from the table: "flag_node_import_options" using primary key columns */
  flagNodeImportOptionsByPk: Maybe<FlagNodeImportOptions>;
  /** An array relationship */
  flagNodes: Array<FlagNodes>;
  /** An aggregate relationship */
  flagNodesAggregate: FlagNodesAggregate;
  /** fetch data from the table: "flag_nodes" using primary key columns */
  flagNodesByPk: Maybe<FlagNodes>;
  /** fetch data from the table: "flag_value_import_options" */
  flagValueImportOptions: Array<FlagValueImportOptions>;
  /** fetch data from the table: "flag_value_import_options" using primary key columns */
  flagValueImportOptionsByPk: Maybe<FlagValueImportOptions>;
  /** An array relationship */
  flagValues: Array<FlagValues>;
  /** An aggregate relationship */
  flagValuesAggregate: FlagValuesAggregate;
  /** fetch data from the table: "flag_values" using primary key columns */
  flagValuesByPk: Maybe<FlagValues>;
  /** fetch data from the table: "inherited_valued_flag_nodes" */
  inheritedValuedFlagNodes: Array<InheritedValuedFlagNodes>;
  /** fetch data from the table: "inherited_valued_flag_nodes" using primary key columns */
  inheritedValuedFlagNodesByPk: Maybe<InheritedValuedFlagNodes>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logsAggregate: LogsAggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logsByPk: Maybe<Logs>;
  /** execute function "old_comparable_scope_definitions" which returns "comparable_scope_definitions_return_type" */
  oldComparableScopeDefinitions: Array<ComparableScopeDefinitionsReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitives: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives_by_scope_option_id" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitivesByScopeOptionId: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives_by_scope_variable_ids" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitivesByScopeVariableIds: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_validatable_scope_containments" which returns "validatable_scope_containments_return_type" */
  oldValidatableScopeContainments: Array<ValidatableScopeContainmentsReturnType>;
  /** An array relationship */
  roleScopes: Array<RoleScopes>;
  /** An aggregate relationship */
  roleScopesAggregate: RoleScopesAggregate;
  /** fetch data from the table: "role_scopes" using primary key columns */
  roleScopesByPk: Maybe<RoleScopes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  rolesAggregate: RolesAggregate;
  /** fetch data from the table: "roles" using primary key columns */
  rolesByPk: Maybe<Roles>;
  /** An array relationship */
  scopeDefiners: Array<ScopeDefiners>;
  /** An aggregate relationship */
  scopeDefinersAggregate: ScopeDefinersAggregate;
  /** fetch data from the table: "scope_definers" using primary key columns */
  scopeDefinersByPk: Maybe<ScopeDefiners>;
  /** fetch data from the table: "scope_definitions" */
  scopeDefinitions: Array<ScopeDefinitions>;
  /** fetch data from the table: "scope_flag_nodes" */
  scopeFlagNodes: Array<ScopeFlagNodes>;
  /** fetch aggregated fields from the table: "scope_flag_nodes" */
  scopeFlagNodesAggregate: ScopeFlagNodesAggregate;
  /** fetch data from the table: "scope_flag_nodes" using primary key columns */
  scopeFlagNodesByPk: Maybe<ScopeFlagNodes>;
  /** fetch data from the table: "scope_option_tree_edge_transitives_return_type" */
  scopeOptionTreeEdgeTransitivesReturnType: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** fetch data from the table: "scope_option_tree_edges" */
  scopeOptionTreeEdges: Array<ScopeOptionTreeEdges>;
  /** fetch data from the table: "scope_option_tree_edges" using primary key columns */
  scopeOptionTreeEdgesByPk: Maybe<ScopeOptionTreeEdges>;
  /** An array relationship */
  scopeOptions: Array<ScopeOptions>;
  /** An aggregate relationship */
  scopeOptionsAggregate: ScopeOptionsAggregate;
  /** fetch data from the table: "scope_options" using primary key columns */
  scopeOptionsByPk: Maybe<ScopeOptions>;
  scopeSnapshotTest: Maybe<Array<Maybe<ScopeSnapshotWithOptionalFieldTest>>>;
  /** An array relationship */
  scopeSnapshots: Array<ScopeSnapshots>;
  /** An aggregate relationship */
  scopeSnapshotsAggregate: ScopeSnapshotsAggregate;
  /** fetch data from the table: "scope_snapshots" using primary key columns */
  scopeSnapshotsByPk: Maybe<ScopeSnapshots>;
  /** fetch data from the table: "scope_variables" */
  scopeVariables: Array<ScopeVariables>;
  /** fetch aggregated fields from the table: "scope_variables" */
  scopeVariablesAggregate: ScopeVariablesAggregate;
  /** fetch data from the table: "scope_variables" using primary key columns */
  scopeVariablesByPk: Maybe<ScopeVariables>;
  /** fetch data from the table: "scopes" */
  scopes: Array<Scopes>;
  /** fetch aggregated fields from the table: "scopes" */
  scopesAggregate: ScopesAggregate;
  /** fetch data from the table: "scopes" using primary key columns */
  scopesByPk: Maybe<Scopes>;
  /** fetch data from the table: "set_scope_option_children_return_type" */
  setScopeOptionChildrenReturnType: Array<SetScopeOptionChildrenReturnType>;
  /** fetch data from the table: "sortable_scope_option_tree_node_attribute_ordinals" */
  sortableScopeOptionTreeNodeAttributeOrdinals: Array<SortableScopeOptionTreeNodeAttributeOrdinals>;
  /** fetch data from the table: "ss_direct_inheritances" */
  ssDirectInheritances: Array<SsDirectInheritances>;
  /** fetch data from the table: "ss_direct_inheritances" using primary key columns */
  ssDirectInheritancesByPk: Maybe<SsDirectInheritances>;
  /** fetch data from the table: "ss_inheritances" */
  ssInheritances: Array<SsInheritances>;
  /** fetch data from the table: "ss_inheritances" using primary key columns */
  ssInheritancesByPk: Maybe<SsInheritances>;
  /** fetch data from the table: "test_hasura_session" */
  testHasuraSession: Array<TestHasuraSession>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk: Maybe<UserRoles>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk: Maybe<UserTenants>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk: Maybe<Users>;
  /** fetch data from the table: "validatable_scope_containments_return_type" */
  validatableScopeContainmentsReturnType: Array<ValidatableScopeContainmentsReturnType>;
  /** Determine if the provided replacementScopeSnapshotIdsToDirectlyInherit can replace the direct inheritances of the provided validateScopeSnapshotId. This determination results in: (1) A list of direct inheritance ids that need to be deleted, (2) A list of incompatible flag node ids (if any), and (3) incompatible flag value ids (if any). */
  validateOrSaveSsInheritanceModifications: ValidatedSsInheritanceModifications;
};


export type QueryRootAllComparableScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


export type QueryRootAllComparableScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


export type QueryRootAllComparableScopeDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinitionsOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinitionsBoolExp>;
};


export type QueryRootAllConfigurationsArgs = {
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type QueryRootAllScopeOptionTreeEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesOrderBy>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


export type QueryRootAllSortableScopeOptionTreeNodesArgs = {
  distinctOn?: InputMaybe<Array<AllSortableScopeOptionTreeNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSortableScopeOptionTreeNodesOrderBy>>;
  where?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
};


export type QueryRootAllValidatableScopeContainmentsArgs = {
  distinctOn?: InputMaybe<Array<AllValidatableScopeContainmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllValidatableScopeContainmentsOrderBy>>;
  where?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};


export type QueryRootArrayImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<ArrayImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ArrayImportOptionsOrderBy>>;
  where?: InputMaybe<ArrayImportOptionsBoolExp>;
};


export type QueryRootArrayImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type QueryRootComparableScopeDefinitionsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeOrderBy>>;
  where?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
};


export type QueryRootConfigImportOperationsArgs = {
  args: ConfigImportOperationsArgs;
  distinctOn?: InputMaybe<Array<ConfigImportOperationsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConfigImportOperationsReturnTypeOrderBy>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


export type QueryRootConfigImportOperationsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ConfigImportOperationsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConfigImportOperationsReturnTypeOrderBy>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


export type QueryRootConfigurationArgs = {
  args: ConfigurationArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type QueryRootConfigurationReferencesArgs = {
  args: ConfigurationReferencesArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type QueryRootConfigurationsArgs = {
  args: ConfigurationsArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type QueryRootDeploymentsArgs = {
  distinctOn?: InputMaybe<Array<DeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DeploymentsOrderBy>>;
  where?: InputMaybe<DeploymentsBoolExp>;
};


export type QueryRootDeploymentsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootFlagNodeImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<FlagNodeImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodeImportOptionsOrderBy>>;
  where?: InputMaybe<FlagNodeImportOptionsBoolExp>;
};


export type QueryRootFlagNodeImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type QueryRootFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


export type QueryRootFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


export type QueryRootFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootFlagValueImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<FlagValueImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValueImportOptionsOrderBy>>;
  where?: InputMaybe<FlagValueImportOptionsBoolExp>;
};


export type QueryRootFlagValueImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type QueryRootFlagValuesArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


export type QueryRootFlagValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


export type QueryRootFlagValuesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootInheritedValuedFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<InheritedValuedFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InheritedValuedFlagNodesOrderBy>>;
  where?: InputMaybe<InheritedValuedFlagNodesBoolExp>;
};


export type QueryRootInheritedValuedFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootLogsArgs = {
  distinctOn?: InputMaybe<Array<LogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
  where?: InputMaybe<LogsBoolExp>;
};


export type QueryRootLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
  where?: InputMaybe<LogsBoolExp>;
};


export type QueryRootLogsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootOldComparableScopeDefinitionsArgs = {
  args: OldComparableScopeDefinitionsArgs;
  distinctOn?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeOrderBy>>;
  where?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
};


export type QueryRootOldScopeOptionTreeEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type QueryRootOldScopeOptionTreeEdgeTransitivesByScopeOptionIdArgs = {
  args: OldScopeOptionTreeEdgeTransitivesByScopeOptionIdArgs;
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type QueryRootOldScopeOptionTreeEdgeTransitivesByScopeVariableIdsArgs = {
  args: OldScopeOptionTreeEdgeTransitivesByScopeVariableIdsArgs;
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type QueryRootOldValidatableScopeContainmentsArgs = {
  args: OldValidatableScopeContainmentsArgs;
  distinctOn?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeOrderBy>>;
  where?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
};


export type QueryRootRoleScopesArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


export type QueryRootRoleScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


export type QueryRootRoleScopesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootRolesArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type QueryRootRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type QueryRootRolesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


export type QueryRootScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


export type QueryRootScopeDefinersByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinitionsOrderBy>>;
  where?: InputMaybe<ScopeDefinitionsBoolExp>;
};


export type QueryRootScopeFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<ScopeFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeFlagNodesOrderBy>>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};


export type QueryRootScopeFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeFlagNodesOrderBy>>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};


export type QueryRootScopeFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeOptionTreeEdgeTransitivesReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type QueryRootScopeOptionTreeEdgesArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgesOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};


export type QueryRootScopeOptionTreeEdgesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeOptionsArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


export type QueryRootScopeOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


export type QueryRootScopeOptionsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeSnapshotTestArgs = {
  test?: InputMaybe<Scalars['Int']>;
};


export type QueryRootScopeSnapshotsArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


export type QueryRootScopeSnapshotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


export type QueryRootScopeSnapshotsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopeVariablesArgs = {
  distinctOn?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeVariablesOrderBy>>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};


export type QueryRootScopeVariablesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeVariablesOrderBy>>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};


export type QueryRootScopeVariablesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScopesArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


export type QueryRootScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


export type QueryRootScopesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSetScopeOptionChildrenReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeOrderBy>>;
  where?: InputMaybe<SetScopeOptionChildrenReturnTypeBoolExp>;
};


export type QueryRootSortableScopeOptionTreeNodeAttributeOrdinalsArgs = {
  distinctOn?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsOrderBy>>;
  where?: InputMaybe<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>;
};


export type QueryRootSsDirectInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsDirectInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsDirectInheritancesOrderBy>>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};


export type QueryRootSsDirectInheritancesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSsInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsInheritancesOrderBy>>;
  where?: InputMaybe<SsInheritancesBoolExp>;
};


export type QueryRootSsInheritancesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTestHasuraSessionArgs = {
  distinctOn?: InputMaybe<Array<TestHasuraSessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestHasuraSessionOrderBy>>;
  where?: InputMaybe<TestHasuraSessionBoolExp>;
};


export type QueryRootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type QueryRootUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type QueryRootUserRolesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type QueryRootUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type QueryRootUserTenantsByPkArgs = {
  tenantId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type QueryRootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type QueryRootUsersByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootValidatableScopeContainmentsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeOrderBy>>;
  where?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
};


export type QueryRootValidateOrSaveSsInheritanceModificationsArgs = {
  modifications: Array<OneSsInheritanceModifications>;
  validateOnly: Scalars['Boolean'];
};

export type RoleScopesAggregateBoolExpBoolAnd = {
  arguments: RoleScopesSelectColumnRoleScopesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RoleScopesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RoleScopesAggregateBoolExpBoolOr = {
  arguments: RoleScopesSelectColumnRoleScopesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RoleScopesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RoleScopesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RoleScopesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RoleScopesBoolExp>;
  predicate: IntComparisonExp;
};

export type RolesAggregateBoolExpBoolAnd = {
  arguments: RolesSelectColumnRolesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RolesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RolesAggregateBoolExpBoolOr = {
  arguments: RolesSelectColumnRolesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RolesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RolesBoolExp>;
  predicate: IntComparisonExp;
};

export type ScopeDefinersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScopeDefinersBoolExp>;
  predicate: IntComparisonExp;
};

export type ScopeOptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScopeOptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type ScopeSnapshotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScopeSnapshotsBoolExp>;
  predicate: IntComparisonExp;
};

export type ScopeVariablesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScopeVariablesBoolExp>;
  predicate: IntComparisonExp;
};

export type ScopesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScopesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScopesBoolExp>;
  predicate: IntComparisonExp;
};

export type SetScopeOptionChildrenArgs = {
  complete_list_of_child_tree_edges?: InputMaybe<Scalars['jsonb']>;
  original_children_only_for_concurrency_check?: InputMaybe<Scalars['jsonb']>;
  parent_scope_option_id?: InputMaybe<Scalars['Int']>;
  prevent_scope_target_reduction?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "all_comparable_scope_definers" */
  allComparableScopeDefiners: Array<AllComparableScopeDefiners>;
  /** fetch aggregated fields from the table: "all_comparable_scope_definers" */
  allComparableScopeDefinersAggregate: AllComparableScopeDefinersAggregate;
  /** fetch data from the table in a streaming manner: "all_comparable_scope_definers" */
  allComparableScopeDefinersStream: Array<AllComparableScopeDefiners>;
  /** fetch data from the table: "all_comparable_scope_definitions" */
  allComparableScopeDefinitions: Array<AllComparableScopeDefinitions>;
  /** fetch data from the table in a streaming manner: "all_comparable_scope_definitions" */
  allComparableScopeDefinitionsStream: Array<AllComparableScopeDefinitions>;
  /** fetch data from the table: "all_configurations" */
  allConfigurations: Array<AllConfigurations>;
  /** fetch data from the table in a streaming manner: "all_configurations" */
  allConfigurationsStream: Array<AllConfigurations>;
  /** fetch data from the table: "all_scope_option_tree_edge_transitives" */
  allScopeOptionTreeEdgeTransitives: Array<AllScopeOptionTreeEdgeTransitives>;
  /** fetch data from the table in a streaming manner: "all_scope_option_tree_edge_transitives" */
  allScopeOptionTreeEdgeTransitivesStream: Array<AllScopeOptionTreeEdgeTransitives>;
  /** fetch data from the table: "all_sortable_scope_option_tree_nodes" */
  allSortableScopeOptionTreeNodes: Array<AllSortableScopeOptionTreeNodes>;
  /** fetch data from the table in a streaming manner: "all_sortable_scope_option_tree_nodes" */
  allSortableScopeOptionTreeNodesStream: Array<AllSortableScopeOptionTreeNodes>;
  /** fetch data from the table: "all_validatable_scope_containments" */
  allValidatableScopeContainments: Array<AllValidatableScopeContainments>;
  /** fetch data from the table in a streaming manner: "all_validatable_scope_containments" */
  allValidatableScopeContainmentsStream: Array<AllValidatableScopeContainments>;
  /** fetch data from the table: "array_import_options" */
  arrayImportOptions: Array<ArrayImportOptions>;
  /** fetch data from the table: "array_import_options" using primary key columns */
  arrayImportOptionsByPk: Maybe<ArrayImportOptions>;
  /** fetch data from the table in a streaming manner: "array_import_options" */
  arrayImportOptionsStream: Array<ArrayImportOptions>;
  /** fetch data from the table: "comparable_scope_definitions_return_type" */
  comparableScopeDefinitionsReturnType: Array<ComparableScopeDefinitionsReturnType>;
  /** fetch data from the table in a streaming manner: "comparable_scope_definitions_return_type" */
  comparableScopeDefinitionsReturnTypeStream: Array<ComparableScopeDefinitionsReturnType>;
  /** execute function "config_import_operations" which returns "config_import_operations_return_type" */
  configImportOperations: Array<ConfigImportOperationsReturnType>;
  /** fetch data from the table: "config_import_operations_return_type" */
  configImportOperationsReturnType: Array<ConfigImportOperationsReturnType>;
  /** fetch data from the table in a streaming manner: "config_import_operations_return_type" */
  configImportOperationsReturnTypeStream: Array<ConfigImportOperationsReturnType>;
  /** execute function "configuration" which returns "all_configurations" */
  configuration: Array<AllConfigurations>;
  /** execute function "configuration_references" which returns "all_configurations" */
  configurationReferences: Array<AllConfigurations>;
  /** execute function "configurations" which returns "all_configurations" */
  configurations: Array<AllConfigurations>;
  /** An array relationship */
  deployments: Array<Deployments>;
  /** fetch data from the table: "deployments" using primary key columns */
  deploymentsByPk: Maybe<Deployments>;
  /** fetch data from the table in a streaming manner: "deployments" */
  deploymentsStream: Array<Deployments>;
  /** fetch data from the table: "flag_node_import_options" */
  flagNodeImportOptions: Array<FlagNodeImportOptions>;
  /** fetch data from the table: "flag_node_import_options" using primary key columns */
  flagNodeImportOptionsByPk: Maybe<FlagNodeImportOptions>;
  /** fetch data from the table in a streaming manner: "flag_node_import_options" */
  flagNodeImportOptionsStream: Array<FlagNodeImportOptions>;
  /** An array relationship */
  flagNodes: Array<FlagNodes>;
  /** An aggregate relationship */
  flagNodesAggregate: FlagNodesAggregate;
  /** fetch data from the table: "flag_nodes" using primary key columns */
  flagNodesByPk: Maybe<FlagNodes>;
  /** fetch data from the table in a streaming manner: "flag_nodes" */
  flagNodesStream: Array<FlagNodes>;
  /** fetch data from the table: "flag_value_import_options" */
  flagValueImportOptions: Array<FlagValueImportOptions>;
  /** fetch data from the table: "flag_value_import_options" using primary key columns */
  flagValueImportOptionsByPk: Maybe<FlagValueImportOptions>;
  /** fetch data from the table in a streaming manner: "flag_value_import_options" */
  flagValueImportOptionsStream: Array<FlagValueImportOptions>;
  /** An array relationship */
  flagValues: Array<FlagValues>;
  /** An aggregate relationship */
  flagValuesAggregate: FlagValuesAggregate;
  /** fetch data from the table: "flag_values" using primary key columns */
  flagValuesByPk: Maybe<FlagValues>;
  /** fetch data from the table in a streaming manner: "flag_values" */
  flagValuesStream: Array<FlagValues>;
  /** fetch data from the table: "inherited_valued_flag_nodes" */
  inheritedValuedFlagNodes: Array<InheritedValuedFlagNodes>;
  /** fetch data from the table: "inherited_valued_flag_nodes" using primary key columns */
  inheritedValuedFlagNodesByPk: Maybe<InheritedValuedFlagNodes>;
  /** fetch data from the table in a streaming manner: "inherited_valued_flag_nodes" */
  inheritedValuedFlagNodesStream: Array<InheritedValuedFlagNodes>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logsAggregate: LogsAggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logsByPk: Maybe<Logs>;
  /** fetch data from the table in a streaming manner: "logs" */
  logsStream: Array<Logs>;
  /** execute function "old_comparable_scope_definitions" which returns "comparable_scope_definitions_return_type" */
  oldComparableScopeDefinitions: Array<ComparableScopeDefinitionsReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitives: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives_by_scope_option_id" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitivesByScopeOptionId: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_scope_option_tree_edge_transitives_by_scope_variable_ids" which returns "scope_option_tree_edge_transitives_return_type" */
  oldScopeOptionTreeEdgeTransitivesByScopeVariableIds: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** execute function "old_validatable_scope_containments" which returns "validatable_scope_containments_return_type" */
  oldValidatableScopeContainments: Array<ValidatableScopeContainmentsReturnType>;
  /** An array relationship */
  roleScopes: Array<RoleScopes>;
  /** An aggregate relationship */
  roleScopesAggregate: RoleScopesAggregate;
  /** fetch data from the table: "role_scopes" using primary key columns */
  roleScopesByPk: Maybe<RoleScopes>;
  /** fetch data from the table in a streaming manner: "role_scopes" */
  roleScopesStream: Array<RoleScopes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  rolesAggregate: RolesAggregate;
  /** fetch data from the table: "roles" using primary key columns */
  rolesByPk: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  rolesStream: Array<Roles>;
  /** An array relationship */
  scopeDefiners: Array<ScopeDefiners>;
  /** An aggregate relationship */
  scopeDefinersAggregate: ScopeDefinersAggregate;
  /** fetch data from the table: "scope_definers" using primary key columns */
  scopeDefinersByPk: Maybe<ScopeDefiners>;
  /** fetch data from the table in a streaming manner: "scope_definers" */
  scopeDefinersStream: Array<ScopeDefiners>;
  /** fetch data from the table: "scope_definitions" */
  scopeDefinitions: Array<ScopeDefinitions>;
  /** fetch data from the table in a streaming manner: "scope_definitions" */
  scopeDefinitionsStream: Array<ScopeDefinitions>;
  /** fetch data from the table: "scope_flag_nodes" */
  scopeFlagNodes: Array<ScopeFlagNodes>;
  /** fetch aggregated fields from the table: "scope_flag_nodes" */
  scopeFlagNodesAggregate: ScopeFlagNodesAggregate;
  /** fetch data from the table: "scope_flag_nodes" using primary key columns */
  scopeFlagNodesByPk: Maybe<ScopeFlagNodes>;
  /** fetch data from the table in a streaming manner: "scope_flag_nodes" */
  scopeFlagNodesStream: Array<ScopeFlagNodes>;
  /** fetch data from the table: "scope_option_tree_edge_transitives_return_type" */
  scopeOptionTreeEdgeTransitivesReturnType: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** fetch data from the table in a streaming manner: "scope_option_tree_edge_transitives_return_type" */
  scopeOptionTreeEdgeTransitivesReturnTypeStream: Array<ScopeOptionTreeEdgeTransitivesReturnType>;
  /** fetch data from the table: "scope_option_tree_edges" */
  scopeOptionTreeEdges: Array<ScopeOptionTreeEdges>;
  /** fetch data from the table: "scope_option_tree_edges" using primary key columns */
  scopeOptionTreeEdgesByPk: Maybe<ScopeOptionTreeEdges>;
  /** fetch data from the table in a streaming manner: "scope_option_tree_edges" */
  scopeOptionTreeEdgesStream: Array<ScopeOptionTreeEdges>;
  /** An array relationship */
  scopeOptions: Array<ScopeOptions>;
  /** An aggregate relationship */
  scopeOptionsAggregate: ScopeOptionsAggregate;
  /** fetch data from the table: "scope_options" using primary key columns */
  scopeOptionsByPk: Maybe<ScopeOptions>;
  /** fetch data from the table in a streaming manner: "scope_options" */
  scopeOptionsStream: Array<ScopeOptions>;
  /** An array relationship */
  scopeSnapshots: Array<ScopeSnapshots>;
  /** An aggregate relationship */
  scopeSnapshotsAggregate: ScopeSnapshotsAggregate;
  /** fetch data from the table: "scope_snapshots" using primary key columns */
  scopeSnapshotsByPk: Maybe<ScopeSnapshots>;
  /** fetch data from the table in a streaming manner: "scope_snapshots" */
  scopeSnapshotsStream: Array<ScopeSnapshots>;
  /** fetch data from the table: "scope_variables" */
  scopeVariables: Array<ScopeVariables>;
  /** fetch aggregated fields from the table: "scope_variables" */
  scopeVariablesAggregate: ScopeVariablesAggregate;
  /** fetch data from the table: "scope_variables" using primary key columns */
  scopeVariablesByPk: Maybe<ScopeVariables>;
  /** fetch data from the table in a streaming manner: "scope_variables" */
  scopeVariablesStream: Array<ScopeVariables>;
  /** fetch data from the table: "scopes" */
  scopes: Array<Scopes>;
  /** fetch aggregated fields from the table: "scopes" */
  scopesAggregate: ScopesAggregate;
  /** fetch data from the table: "scopes" using primary key columns */
  scopesByPk: Maybe<Scopes>;
  /** fetch data from the table in a streaming manner: "scopes" */
  scopesStream: Array<Scopes>;
  /** fetch data from the table: "set_scope_option_children_return_type" */
  setScopeOptionChildrenReturnType: Array<SetScopeOptionChildrenReturnType>;
  /** fetch data from the table in a streaming manner: "set_scope_option_children_return_type" */
  setScopeOptionChildrenReturnTypeStream: Array<SetScopeOptionChildrenReturnType>;
  /** fetch data from the table: "sortable_scope_option_tree_node_attribute_ordinals" */
  sortableScopeOptionTreeNodeAttributeOrdinals: Array<SortableScopeOptionTreeNodeAttributeOrdinals>;
  /** fetch data from the table in a streaming manner: "sortable_scope_option_tree_node_attribute_ordinals" */
  sortableScopeOptionTreeNodeAttributeOrdinalsStream: Array<SortableScopeOptionTreeNodeAttributeOrdinals>;
  /** fetch data from the table: "ss_direct_inheritances" */
  ssDirectInheritances: Array<SsDirectInheritances>;
  /** fetch data from the table: "ss_direct_inheritances" using primary key columns */
  ssDirectInheritancesByPk: Maybe<SsDirectInheritances>;
  /** fetch data from the table in a streaming manner: "ss_direct_inheritances" */
  ssDirectInheritancesStream: Array<SsDirectInheritances>;
  /** fetch data from the table: "ss_inheritances" */
  ssInheritances: Array<SsInheritances>;
  /** fetch data from the table: "ss_inheritances" using primary key columns */
  ssInheritancesByPk: Maybe<SsInheritances>;
  /** fetch data from the table in a streaming manner: "ss_inheritances" */
  ssInheritancesStream: Array<SsInheritances>;
  /** fetch data from the table: "test_hasura_session" */
  testHasuraSession: Array<TestHasuraSession>;
  /** fetch data from the table in a streaming manner: "test_hasura_session" */
  testHasuraSessionStream: Array<TestHasuraSession>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk: Maybe<UserRoles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  userRolesStream: Array<UserRoles>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk: Maybe<UserTenants>;
  /** fetch data from the table in a streaming manner: "user_tenants" */
  userTenantsStream: Array<UserTenants>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
  /** fetch data from the table: "validatable_scope_containments_return_type" */
  validatableScopeContainmentsReturnType: Array<ValidatableScopeContainmentsReturnType>;
  /** fetch data from the table in a streaming manner: "validatable_scope_containments_return_type" */
  validatableScopeContainmentsReturnTypeStream: Array<ValidatableScopeContainmentsReturnType>;
};


export type SubscriptionRootAllComparableScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


export type SubscriptionRootAllComparableScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinersOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


export type SubscriptionRootAllComparableScopeDefinersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllComparableScopeDefinersStreamCursorInput>>;
  where?: InputMaybe<AllComparableScopeDefinersBoolExp>;
};


export type SubscriptionRootAllComparableScopeDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<AllComparableScopeDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllComparableScopeDefinitionsOrderBy>>;
  where?: InputMaybe<AllComparableScopeDefinitionsBoolExp>;
};


export type SubscriptionRootAllComparableScopeDefinitionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllComparableScopeDefinitionsStreamCursorInput>>;
  where?: InputMaybe<AllComparableScopeDefinitionsBoolExp>;
};


export type SubscriptionRootAllConfigurationsArgs = {
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type SubscriptionRootAllConfigurationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllConfigurationsStreamCursorInput>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type SubscriptionRootAllScopeOptionTreeEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllScopeOptionTreeEdgeTransitivesOrderBy>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


export type SubscriptionRootAllScopeOptionTreeEdgeTransitivesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllScopeOptionTreeEdgeTransitivesStreamCursorInput>>;
  where?: InputMaybe<AllScopeOptionTreeEdgeTransitivesBoolExp>;
};


export type SubscriptionRootAllSortableScopeOptionTreeNodesArgs = {
  distinctOn?: InputMaybe<Array<AllSortableScopeOptionTreeNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSortableScopeOptionTreeNodesOrderBy>>;
  where?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
};


export type SubscriptionRootAllSortableScopeOptionTreeNodesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllSortableScopeOptionTreeNodesStreamCursorInput>>;
  where?: InputMaybe<AllSortableScopeOptionTreeNodesBoolExp>;
};


export type SubscriptionRootAllValidatableScopeContainmentsArgs = {
  distinctOn?: InputMaybe<Array<AllValidatableScopeContainmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllValidatableScopeContainmentsOrderBy>>;
  where?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};


export type SubscriptionRootAllValidatableScopeContainmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AllValidatableScopeContainmentsStreamCursorInput>>;
  where?: InputMaybe<AllValidatableScopeContainmentsBoolExp>;
};


export type SubscriptionRootArrayImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<ArrayImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ArrayImportOptionsOrderBy>>;
  where?: InputMaybe<ArrayImportOptionsBoolExp>;
};


export type SubscriptionRootArrayImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type SubscriptionRootArrayImportOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ArrayImportOptionsStreamCursorInput>>;
  where?: InputMaybe<ArrayImportOptionsBoolExp>;
};


export type SubscriptionRootComparableScopeDefinitionsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeOrderBy>>;
  where?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
};


export type SubscriptionRootComparableScopeDefinitionsReturnTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ComparableScopeDefinitionsReturnTypeStreamCursorInput>>;
  where?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
};


export type SubscriptionRootConfigImportOperationsArgs = {
  args: ConfigImportOperationsArgs;
  distinctOn?: InputMaybe<Array<ConfigImportOperationsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConfigImportOperationsReturnTypeOrderBy>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


export type SubscriptionRootConfigImportOperationsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ConfigImportOperationsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConfigImportOperationsReturnTypeOrderBy>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


export type SubscriptionRootConfigImportOperationsReturnTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigImportOperationsReturnTypeStreamCursorInput>>;
  where?: InputMaybe<ConfigImportOperationsReturnTypeBoolExp>;
};


export type SubscriptionRootConfigurationArgs = {
  args: ConfigurationArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type SubscriptionRootConfigurationReferencesArgs = {
  args: ConfigurationReferencesArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type SubscriptionRootConfigurationsArgs = {
  args: ConfigurationsArgs;
  distinctOn?: InputMaybe<Array<AllConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllConfigurationsOrderBy>>;
  where?: InputMaybe<AllConfigurationsBoolExp>;
};


export type SubscriptionRootDeploymentsArgs = {
  distinctOn?: InputMaybe<Array<DeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DeploymentsOrderBy>>;
  where?: InputMaybe<DeploymentsBoolExp>;
};


export type SubscriptionRootDeploymentsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDeploymentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DeploymentsStreamCursorInput>>;
  where?: InputMaybe<DeploymentsBoolExp>;
};


export type SubscriptionRootFlagNodeImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<FlagNodeImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodeImportOptionsOrderBy>>;
  where?: InputMaybe<FlagNodeImportOptionsBoolExp>;
};


export type SubscriptionRootFlagNodeImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type SubscriptionRootFlagNodeImportOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FlagNodeImportOptionsStreamCursorInput>>;
  where?: InputMaybe<FlagNodeImportOptionsBoolExp>;
};


export type SubscriptionRootFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


export type SubscriptionRootFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagNodesOrderBy>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


export type SubscriptionRootFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootFlagNodesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FlagNodesStreamCursorInput>>;
  where?: InputMaybe<FlagNodesBoolExp>;
};


export type SubscriptionRootFlagValueImportOptionsArgs = {
  distinctOn?: InputMaybe<Array<FlagValueImportOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValueImportOptionsOrderBy>>;
  where?: InputMaybe<FlagValueImportOptionsBoolExp>;
};


export type SubscriptionRootFlagValueImportOptionsByPkArgs = {
  name: Scalars['String'];
};


export type SubscriptionRootFlagValueImportOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FlagValueImportOptionsStreamCursorInput>>;
  where?: InputMaybe<FlagValueImportOptionsBoolExp>;
};


export type SubscriptionRootFlagValuesArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


export type SubscriptionRootFlagValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FlagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlagValuesOrderBy>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


export type SubscriptionRootFlagValuesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootFlagValuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FlagValuesStreamCursorInput>>;
  where?: InputMaybe<FlagValuesBoolExp>;
};


export type SubscriptionRootInheritedValuedFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<InheritedValuedFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InheritedValuedFlagNodesOrderBy>>;
  where?: InputMaybe<InheritedValuedFlagNodesBoolExp>;
};


export type SubscriptionRootInheritedValuedFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootInheritedValuedFlagNodesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InheritedValuedFlagNodesStreamCursorInput>>;
  where?: InputMaybe<InheritedValuedFlagNodesBoolExp>;
};


export type SubscriptionRootLogsArgs = {
  distinctOn?: InputMaybe<Array<LogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
  where?: InputMaybe<LogsBoolExp>;
};


export type SubscriptionRootLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
  where?: InputMaybe<LogsBoolExp>;
};


export type SubscriptionRootLogsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootLogsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LogsStreamCursorInput>>;
  where?: InputMaybe<LogsBoolExp>;
};


export type SubscriptionRootOldComparableScopeDefinitionsArgs = {
  args: OldComparableScopeDefinitionsArgs;
  distinctOn?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComparableScopeDefinitionsReturnTypeOrderBy>>;
  where?: InputMaybe<ComparableScopeDefinitionsReturnTypeBoolExp>;
};


export type SubscriptionRootOldScopeOptionTreeEdgeTransitivesArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type SubscriptionRootOldScopeOptionTreeEdgeTransitivesByScopeOptionIdArgs = {
  args: OldScopeOptionTreeEdgeTransitivesByScopeOptionIdArgs;
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type SubscriptionRootOldScopeOptionTreeEdgeTransitivesByScopeVariableIdsArgs = {
  args: OldScopeOptionTreeEdgeTransitivesByScopeVariableIdsArgs;
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type SubscriptionRootOldValidatableScopeContainmentsArgs = {
  args: OldValidatableScopeContainmentsArgs;
  distinctOn?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeOrderBy>>;
  where?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
};


export type SubscriptionRootRoleScopesArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


export type SubscriptionRootRoleScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoleScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


export type SubscriptionRootRoleScopesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootRoleScopesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RoleScopesStreamCursorInput>>;
  where?: InputMaybe<RoleScopesBoolExp>;
};


export type SubscriptionRootRolesArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type SubscriptionRootRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type SubscriptionRootRolesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RolesStreamCursorInput>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type SubscriptionRootScopeDefinersArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


export type SubscriptionRootScopeDefinersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinersOrderBy>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


export type SubscriptionRootScopeDefinersByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeDefinersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeDefinersStreamCursorInput>>;
  where?: InputMaybe<ScopeDefinersBoolExp>;
};


export type SubscriptionRootScopeDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<ScopeDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeDefinitionsOrderBy>>;
  where?: InputMaybe<ScopeDefinitionsBoolExp>;
};


export type SubscriptionRootScopeDefinitionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeDefinitionsStreamCursorInput>>;
  where?: InputMaybe<ScopeDefinitionsBoolExp>;
};


export type SubscriptionRootScopeFlagNodesArgs = {
  distinctOn?: InputMaybe<Array<ScopeFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeFlagNodesOrderBy>>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};


export type SubscriptionRootScopeFlagNodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeFlagNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeFlagNodesOrderBy>>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};


export type SubscriptionRootScopeFlagNodesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeFlagNodesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeFlagNodesStreamCursorInput>>;
  where?: InputMaybe<ScopeFlagNodesBoolExp>;
};


export type SubscriptionRootScopeOptionTreeEdgeTransitivesReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgeTransitivesReturnTypeOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type SubscriptionRootScopeOptionTreeEdgeTransitivesReturnTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeStreamCursorInput>>;
  where?: InputMaybe<ScopeOptionTreeEdgeTransitivesReturnTypeBoolExp>;
};


export type SubscriptionRootScopeOptionTreeEdgesArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionTreeEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionTreeEdgesOrderBy>>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};


export type SubscriptionRootScopeOptionTreeEdgesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeOptionTreeEdgesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeOptionTreeEdgesStreamCursorInput>>;
  where?: InputMaybe<ScopeOptionTreeEdgesBoolExp>;
};


export type SubscriptionRootScopeOptionsArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


export type SubscriptionRootScopeOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeOptionsOrderBy>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


export type SubscriptionRootScopeOptionsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeOptionsStreamCursorInput>>;
  where?: InputMaybe<ScopeOptionsBoolExp>;
};


export type SubscriptionRootScopeSnapshotsArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


export type SubscriptionRootScopeSnapshotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeSnapshotsOrderBy>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


export type SubscriptionRootScopeSnapshotsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeSnapshotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeSnapshotsStreamCursorInput>>;
  where?: InputMaybe<ScopeSnapshotsBoolExp>;
};


export type SubscriptionRootScopeVariablesArgs = {
  distinctOn?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeVariablesOrderBy>>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};


export type SubscriptionRootScopeVariablesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopeVariablesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopeVariablesOrderBy>>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};


export type SubscriptionRootScopeVariablesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopeVariablesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopeVariablesStreamCursorInput>>;
  where?: InputMaybe<ScopeVariablesBoolExp>;
};


export type SubscriptionRootScopesArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


export type SubscriptionRootScopesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
  where?: InputMaybe<ScopesBoolExp>;
};


export type SubscriptionRootScopesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScopesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScopesStreamCursorInput>>;
  where?: InputMaybe<ScopesBoolExp>;
};


export type SubscriptionRootSetScopeOptionChildrenReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SetScopeOptionChildrenReturnTypeOrderBy>>;
  where?: InputMaybe<SetScopeOptionChildrenReturnTypeBoolExp>;
};


export type SubscriptionRootSetScopeOptionChildrenReturnTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SetScopeOptionChildrenReturnTypeStreamCursorInput>>;
  where?: InputMaybe<SetScopeOptionChildrenReturnTypeBoolExp>;
};


export type SubscriptionRootSortableScopeOptionTreeNodeAttributeOrdinalsArgs = {
  distinctOn?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SortableScopeOptionTreeNodeAttributeOrdinalsOrderBy>>;
  where?: InputMaybe<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>;
};


export type SubscriptionRootSortableScopeOptionTreeNodeAttributeOrdinalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SortableScopeOptionTreeNodeAttributeOrdinalsStreamCursorInput>>;
  where?: InputMaybe<SortableScopeOptionTreeNodeAttributeOrdinalsBoolExp>;
};


export type SubscriptionRootSsDirectInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsDirectInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsDirectInheritancesOrderBy>>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};


export type SubscriptionRootSsDirectInheritancesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSsDirectInheritancesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SsDirectInheritancesStreamCursorInput>>;
  where?: InputMaybe<SsDirectInheritancesBoolExp>;
};


export type SubscriptionRootSsInheritancesArgs = {
  distinctOn?: InputMaybe<Array<SsInheritancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SsInheritancesOrderBy>>;
  where?: InputMaybe<SsInheritancesBoolExp>;
};


export type SubscriptionRootSsInheritancesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSsInheritancesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SsInheritancesStreamCursorInput>>;
  where?: InputMaybe<SsInheritancesBoolExp>;
};


export type SubscriptionRootTestHasuraSessionArgs = {
  distinctOn?: InputMaybe<Array<TestHasuraSessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestHasuraSessionOrderBy>>;
  where?: InputMaybe<TestHasuraSessionBoolExp>;
};


export type SubscriptionRootTestHasuraSessionStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TestHasuraSessionStreamCursorInput>>;
  where?: InputMaybe<TestHasuraSessionBoolExp>;
};


export type SubscriptionRootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUserRolesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUserRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserRolesStreamCursorInput>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type SubscriptionRootUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type SubscriptionRootUserTenantsByPkArgs = {
  tenantId: Scalars['uuid'];
  userId: Scalars['String'];
};


export type SubscriptionRootUserTenantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserTenantsStreamCursorInput>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type SubscriptionRootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type SubscriptionRootUsersByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type SubscriptionRootValidatableScopeContainmentsReturnTypeArgs = {
  distinctOn?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ValidatableScopeContainmentsReturnTypeOrderBy>>;
  where?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
};


export type SubscriptionRootValidatableScopeContainmentsReturnTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ValidatableScopeContainmentsReturnTypeStreamCursorInput>>;
  where?: InputMaybe<ValidatableScopeContainmentsReturnTypeBoolExp>;
};

export type UserRolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserRolesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserTenantsBoolExp>;
  predicate: IntComparisonExp;
};

export type DeploymentsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DeploymentsPageQuery = { __typename?: 'query_root', deployments: Array<{ __typename?: 'Deployments', id: number, key: string, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } }>, scopeVariables: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', descendantChain: Array<number>, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, ordinal: number | null, value: string, ancestorScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }>, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }> } }> }> };

export type DeleteDeploymentMutationVariables = Exact<{
  deploymentId: Scalars['Int'];
}>;


export type DeleteDeploymentMutation = { __typename?: 'mutation_root', deleteDeploymentsByPk: { __typename?: 'Deployments', id: number, key: string } | null };

export type UpdateDeploymentMutationVariables = Exact<{
  id: Scalars['Int'];
  setFields?: InputMaybe<DeploymentsSetInput>;
}>;


export type UpdateDeploymentMutation = { __typename?: 'mutation_root', updateDeploymentsByPk: { __typename?: 'Deployments', id: number, key: string, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } } | null };

export type InsertDeploymentMutationVariables = Exact<{
  key: Scalars['String'];
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
}>;


export type InsertDeploymentMutation = { __typename?: 'mutation_root', insertDeploymentsOne: { __typename?: 'Deployments', id: number, key: string, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } } | null };

export type InsertFlagValueMutationVariables = Exact<{
  scopeFlagNodeId: Scalars['Int'];
  flagNodeScopeSnapshotId: Scalars['Int'];
  appliedInScopeSnapshotId: Scalars['Int'];
  value?: InputMaybe<Scalars['jsonb']>;
}>;


export type InsertFlagValueMutation = { __typename?: 'mutation_root', insertFlagValuesOne: { __typename?: 'FlagValues', id: number } | null };

export type DeleteFlagValueMutationVariables = Exact<{
  scopeFlagNodeId: Scalars['Int'];
  flagNodeScopeSnapshotId: Scalars['Int'];
  appliedInScopeSnapshotId: Scalars['Int'];
}>;


export type DeleteFlagValueMutation = { __typename?: 'mutation_root', deleteFlagValues: { __typename?: 'FlagValuesMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'FlagValues', id: number }> } | null };

export type SaveFlagMutationVariables = Exact<{
  deleteFlagNodeIds?: Array<Scalars['Int']> | Scalars['Int'];
  updateFlagNodes?: Array<FlagNodesUpdates> | FlagNodesUpdates;
  insertFlagNodes?: Array<FlagNodesInsertInput> | FlagNodesInsertInput;
  compactArrayOrdinalsWithinScopeSnapshotId: Scalars['Int'];
  compactArrayOrdinalsForParentScopeFlagNodeIds: Scalars['_int4'];
}>;


export type SaveFlagMutation = { __typename?: 'mutation_root', deleteFlagNodes: { __typename?: 'FlagNodesMutationResponse', returning: Array<{ __typename?: 'FlagNodes', id: number, propertyName: string | null, arrayOrdinal: number | null }> } | null, updateFlagNodesMany: Array<{ __typename?: 'FlagNodesMutationResponse', returning: Array<{ __typename?: 'FlagNodes', id: number, propertyName: string | null, arrayOrdinal: number | null }> } | null> | null, insertFlagNodes: { __typename?: 'FlagNodesMutationResponse', returning: Array<{ __typename?: 'FlagNodes', propertyName: string | null, type: FlagNodeTypesEnum, arrayOrdinal: number | null }> } | null, compactFlagNodeArrayOrdinals: Array<{ __typename?: 'FlagNodes', id: number, arrayOrdinal: number | null }> };

export type ImportOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportOptionsQuery = { __typename?: 'query_root', flagNodeImportOptions: Array<{ __typename?: 'FlagNodeImportOptions', name: string, description: string }>, flagValueImportOptions: Array<{ __typename?: 'FlagValueImportOptions', name: string, description: string }>, arrayImportOptions: Array<{ __typename?: 'ArrayImportOptions', name: string, description: string }> };

export type ImportConfigMutationVariables = Exact<{
  scopeSnapshotId: Scalars['Int'];
  importConfig: Scalars['jsonb'];
  flagNodeImportOption: Scalars['String'];
  flagValueImportOption: Scalars['String'];
  arrayImportOption: Scalars['String'];
}>;


export type ImportConfigMutation = { __typename?: 'mutation_root', importConfig: Array<{ __typename?: 'ConfigImportOperationsReturnType', flagNodeOperation: string | null, flagValueOperation: string | null }> };

export type SaveParentConnectionsMutationVariables = Exact<{
  targetScopeSnapshotId: Scalars['Int'];
  deleteByParentScopeIds: Array<Scalars['Int']> | Scalars['Int'];
  updateParentConnections: Array<SsDirectInheritancesUpdates> | SsDirectInheritancesUpdates;
  insertParentConnections: Array<SsDirectInheritancesInsertInput> | SsDirectInheritancesInsertInput;
}>;


export type SaveParentConnectionsMutation = { __typename?: 'mutation_root', deleteSsDirectInheritances: { __typename?: 'SsDirectInheritancesMutationResponse', returning: Array<{ __typename?: 'SsDirectInheritances', id: number }> } | null, updateSsDirectInheritancesMany: Array<{ __typename?: 'SsDirectInheritancesMutationResponse', returning: Array<{ __typename?: 'SsDirectInheritances', id: number }> } | null> | null, insertSsDirectInheritances: { __typename?: 'SsDirectInheritancesMutationResponse', returning: Array<{ __typename?: 'SsDirectInheritances', id: number }> } | null };

export type ScopeSnapshotDataForScopeSnapshotPageQueryVariables = Exact<{
  scopeSnapshotId: Scalars['Int'];
}>;


export type ScopeSnapshotDataForScopeSnapshotPageQuery = { __typename?: 'query_root', scopeSnapshotsByPk: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, inheritances: Array<{ __typename?: 'SsInheritances', ordinal: any, isDirectInheritance: boolean, isSelf: boolean, inheritedScopeSnapshotId: number, ordinalWithinDirectInheritances: any | null, inheritedScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } }>, descendantInheritances: Array<{ __typename?: 'SsInheritances', ordinal: any, scopeSnapshotId: number, isDirectInheritance: boolean, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } }>, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } | null, scopeVariables: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', descendantChain: Array<number>, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, ordinal: number | null, value: string, ancestorScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }>, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }> } }> }> };

export type FlagsValuesDataQueryVariables = Exact<{
  scopeSnapshotId: Scalars['Int'];
}>;


export type FlagsValuesDataQuery = { __typename?: 'query_root', inheritedValuedFlagNodes: Array<{ __typename?: 'InheritedValuedFlagNodes', ivfnId: number, flagNode: { __typename?: 'FlagNodes', id: number, propertyName: string | null, arrayOrdinal: number | null, scopeFlagNodeId: number, definedInScopeSnapshotId: number, parentScopeFlagNodeId: number | null, type: FlagNodeTypesEnum, canonicalValuedFlagNode: { __typename?: 'InheritedValuedFlagNodes', id: number, propertyNameOrArrayIndex: string, arrayIndex: number | null }, parent: { __typename?: 'FlagNodes', id: number } | null, scopeFlagNode: { __typename?: 'ScopeFlagNodes', id: number, flagNodes: Array<{ __typename?: 'FlagNodes', id: number, propertyName: string | null, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeVersion: string }, canonicalValuedFlagNode: { __typename?: 'InheritedValuedFlagNodes', id: number, propertyNameOrArrayIndex: string } }>, flagValues: Array<{ __typename?: 'FlagValues', id: number, appliedInScopeSnapshotId: number, value: any | null, appliedInScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any } }> }, childrenAggregate: { __typename?: 'FlagNodesAggregate', aggregate: { __typename?: 'FlagNodesAggregateFields', count: number } }, flagValues: Array<{ __typename?: 'FlagValues', id: number, appliedInScopeSnapshotId: number, value: any | null, appliedInScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any } }>, flagValuesAggregate: { __typename?: 'FlagValuesAggregate', aggregate: { __typename?: 'FlagValuesAggregateFields', count: number } } }, flagValue: { __typename?: 'FlagValues', id: number, appliedInScopeSnapshotId: number, value: any | null, appliedInScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any } } | null }> };

export type ConfigurationForScopeSnapshotPageQueryVariables = Exact<{
  scopeSnapshotId: Scalars['Int'];
}>;


export type ConfigurationForScopeSnapshotPageQuery = { __typename?: 'query_root', configuration: Array<{ __typename?: 'AllConfigurations', scopeSnapshotId: number | null, jsonConfiguration: any | null }> };

export type ScopeSnapshotDataForCherryPickReplicationQueryVariables = Exact<{
  replicateToScopeSnapshotId: Scalars['Int'];
}>;


export type ScopeSnapshotDataForCherryPickReplicationQuery = { __typename?: 'query_root', inheritedValuedFlagNodes: Array<{ __typename?: 'InheritedValuedFlagNodes', id: number, flagJsonpathText: string, propertyNameOrArrayIndex: string, flagNode: { __typename?: 'FlagNodes', id: number, propertyName: string | null, scopeFlagNodeId: number, parentScopeFlagNodeId: number | null, type: FlagNodeTypesEnum }, flagValue: { __typename?: 'FlagValues', id: number, value: any | null, flagNodeScopeSnapshotId: number, appliedInScopeSnapshotId: number, scopeFlagNodeId: number } | null }> };

export type InitialDataForScopeSnapshotSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialDataForScopeSnapshotSelectorQuery = { __typename?: 'query_root', scopeVariables: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', descendantChain: Array<number>, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, ordinal: number | null, value: string, ancestorScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }>, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }> } }> }>, scopeSnapshotsAggregate: { __typename?: 'ScopeSnapshotsAggregate', aggregate: { __typename?: 'ScopeSnapshotsAggregateFields', count: number } | null } };

export type DeleteScopeSnapshotMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteScopeSnapshotMutation = { __typename?: 'mutation_root', deleteFlagValues: { __typename?: 'FlagValuesMutationResponse', returning: Array<{ __typename?: 'FlagValues', id: number }> } | null, deleteFlagNodes: { __typename?: 'FlagNodesMutationResponse', returning: Array<{ __typename?: 'FlagNodes', id: number }> } | null, deleteScopeSnapshotsByPk: { __typename?: 'ScopeSnapshots', id: number } | null };

export type CreateScopeAndSnapshotMutationVariables = Exact<{
  scopeDefiners: Array<ScopeDefinersInsertInput> | ScopeDefinersInsertInput;
  scopeVersion: Scalars['String'];
}>;


export type CreateScopeAndSnapshotMutation = { __typename?: 'mutation_root', insertScopeSnapshotsOne: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string } | null };

export type CreateScopeSnapshotMutationVariables = Exact<{
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
}>;


export type CreateScopeSnapshotMutation = { __typename?: 'mutation_root', insertScopeSnapshotsOne: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string } | null };

export type RenameScopeVersionMutationVariables = Exact<{
  scopeSnapshotId: Scalars['Int'];
  newScopeVersion: Scalars['String'];
}>;


export type RenameScopeVersionMutation = { __typename?: 'mutation_root', updateScopeSnapshotsByPk: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string } | null };

export type ScopeByOptionIdsQueryVariables = Exact<{
  scopeOptionIds: Scalars['jsonb'];
}>;


export type ScopeByOptionIdsQuery = { __typename?: 'query_root', allComparableScopeDefinitions: Array<{ __typename?: 'AllComparableScopeDefinitions', scopeId: number | null, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } }> };

export type ScopeByOptionIdsAndScopeUpdateValidatablesQueryVariables = Exact<{
  scopeOptionIds: Scalars['jsonb'];
}>;


export type ScopeByOptionIdsAndScopeUpdateValidatablesQuery = { __typename?: 'query_root', allComparableScopeDefinitions: Array<{ __typename?: 'AllComparableScopeDefinitions', scopeId: number | null, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } }>, allValidatableScopeContainments: Array<{ __typename?: 'AllValidatableScopeContainments', scopeId: number, containableScopeDefinition: Array<string>, scopeSnapshotId: number, directlyInheritedScopeId: number, containableDirectlyInheritedScopeDefinition: Array<string>, directlyInheritedScopeSnapshotId: number, scopeIdentifyingDefinition: Array<number>, directlyInheritedScopeIdentifyingDefinition: Array<number>, scopeSnapshot: { __typename?: 'ScopeSnapshots', scopeVersion: string, createdAt: any }, directlyInheritedScopeSnapshot: { __typename?: 'ScopeSnapshots', scopeVersion: string, createdAt: any } }> };

export type ReplicateScopeSnapshotAsNewVersionMutationVariables = Exact<{
  replicateScopeSnapshotId: Scalars['Int'];
  newDirectlyInheritedScopeSnapshotIds: Array<Scalars['Int']> | Scalars['Int'];
  newScopeVersion: Scalars['String'];
}>;


export type ReplicateScopeSnapshotAsNewVersionMutation = { __typename?: 'mutation_root', replicateScopeSnapshot: { __typename?: 'ReplicatedScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string, scopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } | null } | null };

export type ReplicateFlagsAndValuesMutationVariables = Exact<{
  replicateFromScopeSnapshotId: Scalars['Int'];
  replicateFlagsOfScopeFlagNodeIds: Array<Scalars['Int']> | Scalars['Int'];
  replicateValuesOfScopeFlagNodeIds: Array<Scalars['Int']> | Scalars['Int'];
  destinationScopeSnapshotId: Scalars['Int'];
}>;


export type ReplicateFlagsAndValuesMutation = { __typename?: 'mutation_root', replicateFlagsAndValues: { __typename?: 'ReplicatedFlagsAndValues', replicatedFlagsCount: number, replicatedValuesCount: number } | null };

export type CreateSnapshotWithNewScopeMutationVariables = Exact<{
  scopeDefiners: Array<ScopeDefinersInsertInput> | ScopeDefinersInsertInput;
  scopeVersion: Scalars['String'];
  directInheritances: Array<SsDirectInheritancesInsertInput> | SsDirectInheritancesInsertInput;
}>;


export type CreateSnapshotWithNewScopeMutation = { __typename?: 'mutation_root', insertScopeSnapshotsOne: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } | null };

export type CreateSnapshotInExistingScopeMutationVariables = Exact<{
  scopeId: Scalars['Int'];
  scopeVersion: Scalars['String'];
  directInheritances: Array<SsDirectInheritancesInsertInput> | SsDirectInheritancesInsertInput;
}>;


export type CreateSnapshotInExistingScopeMutation = { __typename?: 'mutation_root', insertScopeSnapshotsOne: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } } | null };

export type UpdateScopeDefinitionMutationVariables = Exact<{
  scopeId: Scalars['Int'];
  replaceWithScopeDefiners: Array<ScopeDefinersInsertInput> | ScopeDefinersInsertInput;
}>;


export type UpdateScopeDefinitionMutation = { __typename?: 'mutation_root', deleteScopeDefiners: { __typename?: 'ScopeDefinersMutationResponse', returning: Array<{ __typename?: 'ScopeDefiners', id: number, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } }> } | null, insertScopeDefiners: { __typename?: 'ScopeDefinersMutationResponse', returning: Array<{ __typename?: 'ScopeDefiners', id: number, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } }> } | null };

export type HistoryPageQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type HistoryPageQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'Logs', id: number, actionTstampTx: any, action: string, changedFields: any | null, clientAddr: any | null, rowData: any | null, tableName: string, tenantId: any | null, userId: string | null, transactionId: any | null, user: { __typename?: 'Users', id: string, name: string, email: string | null } | null }>, logsAggregate: { __typename?: 'LogsAggregate', aggregate: { __typename?: 'LogsAggregateFields', count: number } } };

export type ScopeVariablesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ScopeVariablesCountQuery = { __typename?: 'query_root', scopeVariablesAggregate: { __typename?: 'ScopeVariablesAggregate', aggregate: { __typename?: 'ScopeVariablesAggregateFields', count: number } } };

export type ScopeOptionFieldsForScopeVariablesPageFragment = { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> };

export type ScopeVariableFieldsForScopeVariablesPageFragment = { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, descendantChain: Array<number>, scopeVariableId: number, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number, descendantChain: Array<number>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', ordinal: number | null } | null }>, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }, sortableScopeOptionTreeNodes: Array<{ __typename?: 'AllSortableScopeOptionTreeNodes', id: string | null, sortableTreeChainOrdinal: number, svOrdinal: number, ordinalWithinParentIsNull: boolean, ordinalWithinParent: number | null, soValue: string, soId: number, scopeOptionTreeEdgeTransitive: { __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, scopeOptionTreeEdgeId: number | null } }>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', id: number, scopeOptionId: number, childScopeOptionId: number } | null }>, scopeOptionsAggregate: { __typename?: 'ScopeOptionsAggregate', aggregate: { __typename?: 'ScopeOptionsAggregateFields', count: number, max: { __typename?: 'ScopeOptionsMaxFields', ordinal: number | null } | null } | null }, scopeOptions: Array<{ __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }> };

export type ScopeVariablesPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ScopeVariablesPageDataQuery = { __typename?: 'query_root', scopeVariables: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, descendantChain: Array<number>, scopeVariableId: number, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number, descendantChain: Array<number>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', ordinal: number | null } | null }>, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }, sortableScopeOptionTreeNodes: Array<{ __typename?: 'AllSortableScopeOptionTreeNodes', id: string | null, sortableTreeChainOrdinal: number, svOrdinal: number, ordinalWithinParentIsNull: boolean, ordinalWithinParent: number | null, soValue: string, soId: number, scopeOptionTreeEdgeTransitive: { __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, scopeOptionTreeEdgeId: number | null } }>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', id: number, scopeOptionId: number, childScopeOptionId: number } | null }>, scopeOptionsAggregate: { __typename?: 'ScopeOptionsAggregate', aggregate: { __typename?: 'ScopeOptionsAggregateFields', count: number, max: { __typename?: 'ScopeOptionsMaxFields', ordinal: number | null } | null } | null }, scopeOptions: Array<{ __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }> }>, scopeVariablesAggregate: { __typename?: 'ScopeVariablesAggregate', aggregate: { __typename?: 'ScopeVariablesAggregateFields', count: number, max: { __typename?: 'ScopeVariablesMaxFields', ordinal: number | null } | null } }, sortableScopeOptionTreeNodeAttributeOrdinals: Array<{ __typename?: 'SortableScopeOptionTreeNodeAttributeOrdinals', svOrdinal: number | null, ordinalWithinParentIsNull: number | null, ordinalWithinParent: number | null, soValue: number | null, soId: number | null }> };

export type InsertChildScopeOptionMutationVariables = Exact<{
  value: Scalars['String'];
  scopeVariableId: Scalars['Int'];
  parentScopeOptionId: Scalars['Int'];
}>;


export type InsertChildScopeOptionMutation = { __typename?: 'mutation_root', insertScopeOptionTreeEdgesOne: { __typename?: 'ScopeOptionTreeEdges', id: number } | null };

export type InsertScopeVariableMutationVariables = Exact<{
  name: Scalars['String'];
  ordinal: Scalars['Int'];
}>;


export type InsertScopeVariableMutation = { __typename?: 'mutation_root', insertScopeVariablesOne: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, descendantChain: Array<number>, scopeVariableId: number, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number, descendantChain: Array<number>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', ordinal: number | null } | null }>, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }, sortableScopeOptionTreeNodes: Array<{ __typename?: 'AllSortableScopeOptionTreeNodes', id: string | null, sortableTreeChainOrdinal: number, svOrdinal: number, ordinalWithinParentIsNull: boolean, ordinalWithinParent: number | null, soValue: string, soId: number, scopeOptionTreeEdgeTransitive: { __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, scopeOptionTreeEdgeId: number | null } }>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', id: number, scopeOptionId: number, childScopeOptionId: number } | null }>, scopeOptionsAggregate: { __typename?: 'ScopeOptionsAggregate', aggregate: { __typename?: 'ScopeOptionsAggregateFields', count: number, max: { __typename?: 'ScopeOptionsMaxFields', ordinal: number | null } | null } | null }, scopeOptions: Array<{ __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }> } | null };

export type UpdateScopeVariableMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateScopeVariableMutation = { __typename?: 'mutation_root', updateScopeVariablesByPk: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, descendantChain: Array<number>, scopeVariableId: number, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number, descendantChain: Array<number>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', ordinal: number | null } | null }>, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }, sortableScopeOptionTreeNodes: Array<{ __typename?: 'AllSortableScopeOptionTreeNodes', id: string | null, sortableTreeChainOrdinal: number, svOrdinal: number, ordinalWithinParentIsNull: boolean, ordinalWithinParent: number | null, soValue: string, soId: number, scopeOptionTreeEdgeTransitive: { __typename?: 'AllScopeOptionTreeEdgeTransitives', id: string, scopeOptionTreeEdgeId: number | null } }>, scopeOptionTreeEdge: { __typename?: 'ScopeOptionTreeEdges', id: number, scopeOptionId: number, childScopeOptionId: number } | null }>, scopeOptionsAggregate: { __typename?: 'ScopeOptionsAggregate', aggregate: { __typename?: 'ScopeOptionsAggregateFields', count: number, max: { __typename?: 'ScopeOptionsMaxFields', ordinal: number | null } | null } | null }, scopeOptions: Array<{ __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> }> } | null };

export type DeleteScopeVariableMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteScopeVariableMutation = { __typename?: 'mutation_root', deleteScopeVariablesByPk: { __typename?: 'ScopeVariables', id: number } | null };

export type InsertScopeOptionMutationVariables = Exact<{
  value: Scalars['String'];
  scopeVariableId: Scalars['Int'];
}>;


export type InsertScopeOptionMutation = { __typename?: 'mutation_root', insertScopeOptionsOne: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> } | null };

export type UpdateScopeOptionMutationVariables = Exact<{
  id: Scalars['Int'];
  value: Scalars['String'];
  completeListOfChildTreeEdges: Scalars['jsonb'];
  originalChildrenOnlyForConcurrencyCheck: Scalars['jsonb'];
  preventScopeTargetReduction: Scalars['Boolean'];
}>;


export type UpdateScopeOptionMutation = { __typename?: 'mutation_root', updateScopeOptionsByPk: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, scopeDefinersAggregate: { __typename?: 'ScopeDefinersAggregate', aggregate: { __typename?: 'ScopeDefinersAggregateFields', count: number } | null }, scopeOptionTreeEdgeChildren: Array<{ __typename?: 'ScopeOptionTreeEdges', childScopeOptionId: number, ordinal: number | null }> } | null, setScopeOptionChildren: Array<{ __typename?: 'SetScopeOptionChildrenReturnType', parentScopeOptionId: number | null, parentScopeOptionTreeEdgesBefore: any | null, parentScopeOptionTreeEdgesAfter: any | null, reconciledScopes: any | null, scopeVariableId: number | null }> };

export type DeleteScopeOptionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteScopeOptionMutation = { __typename?: 'mutation_root', deleteScopeOptionTreeEdges: { __typename?: 'ScopeOptionTreeEdgesMutationResponse', affectedRows: number } | null, deleteScopeOptionsByPk: { __typename?: 'ScopeOptions', id: number } | null };

export type UpdateScopeVariableAndOptionOrdinalsMutationVariables = Exact<{
  scopeVariableOrdinals: Array<ScopeVariablesUpdates> | ScopeVariablesUpdates;
  scopeOptionOrdinals: Array<ScopeOptionsUpdates> | ScopeOptionsUpdates;
  scopeOptionTreeEdgeOrdinals: Array<ScopeOptionTreeEdgesUpdates> | ScopeOptionTreeEdgesUpdates;
}>;


export type UpdateScopeVariableAndOptionOrdinalsMutation = { __typename?: 'mutation_root', updateScopeVariablesMany: Array<{ __typename?: 'ScopeVariablesMutationResponse', returning: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }> } | null> | null, updateScopeOptionsMany: Array<{ __typename?: 'ScopeOptionsMutationResponse', returning: Array<{ __typename?: 'ScopeOptions', id: number, scopeVariableId: number, value: string, ordinal: number | null }> } | null> | null, updateScopeOptionTreeEdgesMany: Array<{ __typename?: 'ScopeOptionTreeEdgesMutationResponse', returning: Array<{ __typename?: 'ScopeOptionTreeEdges', id: number, scopeOptionId: number, childScopeOptionId: number, ordinal: number | null }> } | null> | null };

export type ScopesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ScopesPageQuery = { __typename?: 'query_root', scopes: Array<{ __typename?: 'Scopes', id: number, deployments: Array<{ __typename?: 'Deployments', id: number, key: string, scopeVersion: string }>, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> }>, scopeVariables: Array<{ __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', descendantChain: Array<number>, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, ordinal: number | null, value: string, ancestorScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }>, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }> } }> }> };

export type ValidateOrSaveInheritanceModificationsQueryVariables = Exact<{
  modifications: Array<OneSsInheritanceModifications> | OneSsInheritanceModifications;
  validateOnly: Scalars['Boolean'];
}>;


export type ValidateOrSaveInheritanceModificationsQuery = { __typename?: 'query_root', validateOrSaveSsInheritanceModifications: { __typename?: 'ValidatedSsInheritanceModifications', validationsByTargetScopeSnapshots: Array<{ __typename?: 'ValidatedSsInheritanceModificationsOfOneTarget', jsonConfigurationBeforeModifications: any, jsonConfigurationAfterModifications: any, targetScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string }, incompatibleFlagNodes: Array<{ __typename?: 'IncompatibleFlagNode', id: number, propertyName: string | null, arrayOrdinal: number | null, definedInScopeSnapshotId: number, scopeFlagNodeId: number, type: string, flagPath: Array<string>, valuedFlagAsJsonExtract: any }>, incompatibleFlagValues: Array<{ __typename?: 'IncompatibleFlagValue', id: number, value: any, appliedInScopeSnapshotId: number, flagNodeScopeSnapshotId: number, scopeFlagNodeId: number, flagPath: Array<string>, valuedFlagAsJsonExtract: any }>, conflictsByFlagPath: Array<{ __typename?: 'ConflictsForFlagPath', flagPath: Array<string>, redundantBecause: Array<FlagPathConflictRedundancyReason>, conflictingFlagNodeContexts: Array<{ __typename?: 'ConflictingFlagNodeContext', arrayOrdinal: number | null, definedInScopeSnapshotId: number, definedInScopeId: number, definedInScopeVersion: string, effectiveValue: any | null, flagNodeId: number, flagNodeType: string, flagPath: Array<string>, flagValueAppliedInScopeSnapshotId: number | null, flagValueId: number | null, propertyName: string | null, targetScopeSnapshotId: number, scopeFlagNodeId: number, valuedFlagAsJsonExtract: any, parentFlagNodeScopeSnapshotId: number | null }> }>, ancestorScopeDifferences: Array<{ __typename?: 'AncestorScopeDifference', ancestorScope: { __typename?: 'ScopeWithComparableScopeDefiners', id: number, comparableScopeDefiners: Array<{ __typename?: 'ComparableScopeDefinerWithScopeVariableAndOption', isScopeOptionIdExplicitlySelected: boolean, scopeVariable: { __typename?: 'ScopeVariableWithinComparableScopeDefiner', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptionWithinComparableScopeDefiner', id: number, ordinal: number | null, value: string } | null }> }, ancestorScopeSnapshots: Array<{ __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string }>, savedInheritance: { __typename?: 'SavedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean } | null, validatedInheritances: Array<{ __typename?: 'ValidatedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, directChildrenIdsLimitedToInheritancesOfTarget: Array<number> }> }>, descendantScopeDifferences: Array<{ __typename?: 'DescendantScopeDifference', descendantScope: { __typename?: 'ScopeWithComparableScopeDefiners', id: number, comparableScopeDefiners: Array<{ __typename?: 'ComparableScopeDefinerWithScopeVariableAndOption', isScopeOptionIdExplicitlySelected: boolean, scopeVariable: { __typename?: 'ScopeVariableWithinComparableScopeDefiner', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptionWithinComparableScopeDefiner', id: number, ordinal: number | null, value: string } | null }> }, descendantScopeSnapshots: Array<{ __typename?: 'PrimitiveScopeSnapshotWithValidationDifference', id: number, scopeId: number, scopeVersion: string, createdAt: string, validatedDirectParentIds: Array<number>, savedInheritance: { __typename?: 'SavedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, inheritedScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string } } | null, validatedInheritances: Array<{ __typename?: 'ValidatedSsInheritanceForDescendantSs', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, inheritedScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string } }> }> }> }>, aggregateModifications: { __typename?: 'AggregateValidatedSsInheritanceModifications', deleteSsDirectInheritancesWhere: Array<{ __typename?: 'DeleteSsDirectInheritancesWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeId: { __typename?: 'EqualToIntExpression', _eq: number } }>, updateSsDirectInheritances: Array<{ __typename?: 'UpdateSsDirectInheritance', where: { __typename?: 'UpdateSsDirectInheritanceWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeId: { __typename?: 'EqualToIntExpression', _eq: number } }, _set: { __typename?: 'UpdateSsDirectInheritanceSet', directlyInheritedScopeSnapshotId: number, ordinal: number } }>, insertSsDirectInheritances: Array<{ __typename?: 'InsertSsDirectInheritance', scopeSnapshotId: number, directlyInheritedScopeId: number, directlyInheritedScopeSnapshotId: number, ordinal: number }>, deleteConflictingSsDirectInheritancesWhere: Array<{ __typename?: 'DeleteConflictingSsDirectInheritanceWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number } }> } } };

export type DeleteScopeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteScopeMutation = { __typename?: 'mutation_root', deleteScopesByPk: { __typename?: 'Scopes', id: number } | null };

export type RolesPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesPageDataQuery = { __typename?: 'query_root', roles: Array<{ __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } }> };

export type InsertRoleMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type InsertRoleMutation = { __typename?: 'mutation_root', insertRolesOne: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } | null };

export type UpdateRoleNameAndPermissionsMutationVariables = Exact<{
  roleId: Scalars['Int'];
  name: Scalars['String'];
  flagEditPermission: Scalars['Boolean'];
  valueEditPermission: Scalars['Boolean'];
}>;


export type UpdateRoleNameAndPermissionsMutation = { __typename?: 'mutation_root', updateRolesByPk: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } | null };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['Int'];
}>;


export type DeleteRoleMutation = { __typename?: 'mutation_root', deleteRolesByPk: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } | null };

export type UserFieldsFragment = { __typename?: 'Users', id: string, name: string, email: string | null, userRoles: Array<{ __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } }> };

export type UserRoleFieldsFragment = { __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } };

export type UserWithRolesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserWithRolesQuery = { __typename?: 'query_root', usersByPk: { __typename?: 'Users', id: string, name: string, email: string | null, userRoles: Array<{ __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } }> } | null };

export type UsersAndRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersAndRolesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: string, name: string, email: string | null, userRoles: Array<{ __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } }> }>, roles: Array<{ __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } }> };

export type InsertAndDeleteUserRolesMutationVariables = Exact<{
  insertUserRoles?: InputMaybe<Array<UserRolesInsertInput> | UserRolesInsertInput>;
  deleteUserRoleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type InsertAndDeleteUserRolesMutation = { __typename?: 'mutation_root', insertUserRoles: { __typename?: 'UserRolesMutationResponse', returning: Array<{ __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } }> } | null, deleteUserRoles: { __typename?: 'UserRolesMutationResponse', returning: Array<{ __typename?: 'UserRoles', id: number, roleId: number, userId: string, role: { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } } }> } | null };

export type RoleFieldsFragment = { __typename?: 'Roles', id: number, name: string, flagEditPermission: boolean, valueEditPermission: boolean, userRolesAggregate: { __typename?: 'UserRolesAggregate', aggregate: { __typename?: 'UserRolesAggregateFields', count: number } | null }, roleScopesAggregate: { __typename?: 'RoleScopesAggregate', aggregate: { __typename?: 'RoleScopesAggregateFields', count: number } | null } };

export type FlagValueFieldsFragment = { __typename?: 'FlagValues', id: number, appliedInScopeSnapshotId: number, value: any | null, appliedInScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any } };

export type FlagValueFieldsWithAppliedInScopeSnapshotDetailsFragment = { __typename?: 'FlagValues', id: number, appliedInScopeSnapshotId: number, value: any | null, appliedInScopeSnapshot: { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any } };

export type ScopeVariableFieldsForScopeSnapshotSelectorFragment = { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string, scopeOptionTreeEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', descendantChain: Array<number>, isCanonicalRootPath: boolean, scopeOptionId: number, descendantScopeOption: { __typename?: 'ScopeOptions', id: number, scopeVariableId: number, ordinal: number | null, value: string, ancestorScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }>, descendantScopeOptionEdgeTransitives: Array<{ __typename?: 'AllScopeOptionTreeEdgeTransitives', scopeOptionId: number, descendantScopeOptionId: number }> } }> };

export type PrimitiveScopeSnapshotFieldsForScopeSnapshotSelectorFragment = { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any };

export type ScopeFieldsForStaticScopeSnapshotSelectorFragment = { __typename?: 'Scopes', id: number, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> };

export type ScopeFieldsForScopeSnapshotSelectorFragment = { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> };

export type ScopeSnapshotFieldsForScopeSnapshotSelectorFragment = { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, scopeSnapshots: Array<{ __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any }>, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } };

export type ScopeSnapshotFieldsForStaticScopeSnapshotSelectorFragment = { __typename?: 'ScopeSnapshots', id: number, scopeId: number, scopeVersion: string, createdAt: any, scope: { __typename?: 'Scopes', id: number, comparableScopeDefiners: Array<{ __typename?: 'AllComparableScopeDefiners', isScopeOptionIdExplicitlySelected: boolean | null, scopeVariable: { __typename?: 'ScopeVariables', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptions', id: number, ordinal: number | null, value: string } | null }> } };

export type ValidatedSsInheritanceModificationsFragment = { __typename?: 'ValidatedSsInheritanceModifications', validationsByTargetScopeSnapshots: Array<{ __typename?: 'ValidatedSsInheritanceModificationsOfOneTarget', jsonConfigurationBeforeModifications: any, jsonConfigurationAfterModifications: any, targetScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string }, incompatibleFlagNodes: Array<{ __typename?: 'IncompatibleFlagNode', id: number, propertyName: string | null, arrayOrdinal: number | null, definedInScopeSnapshotId: number, scopeFlagNodeId: number, type: string, flagPath: Array<string>, valuedFlagAsJsonExtract: any }>, incompatibleFlagValues: Array<{ __typename?: 'IncompatibleFlagValue', id: number, value: any, appliedInScopeSnapshotId: number, flagNodeScopeSnapshotId: number, scopeFlagNodeId: number, flagPath: Array<string>, valuedFlagAsJsonExtract: any }>, conflictsByFlagPath: Array<{ __typename?: 'ConflictsForFlagPath', flagPath: Array<string>, redundantBecause: Array<FlagPathConflictRedundancyReason>, conflictingFlagNodeContexts: Array<{ __typename?: 'ConflictingFlagNodeContext', arrayOrdinal: number | null, definedInScopeSnapshotId: number, definedInScopeId: number, definedInScopeVersion: string, effectiveValue: any | null, flagNodeId: number, flagNodeType: string, flagPath: Array<string>, flagValueAppliedInScopeSnapshotId: number | null, flagValueId: number | null, propertyName: string | null, targetScopeSnapshotId: number, scopeFlagNodeId: number, valuedFlagAsJsonExtract: any, parentFlagNodeScopeSnapshotId: number | null }> }>, ancestorScopeDifferences: Array<{ __typename?: 'AncestorScopeDifference', ancestorScope: { __typename?: 'ScopeWithComparableScopeDefiners', id: number, comparableScopeDefiners: Array<{ __typename?: 'ComparableScopeDefinerWithScopeVariableAndOption', isScopeOptionIdExplicitlySelected: boolean, scopeVariable: { __typename?: 'ScopeVariableWithinComparableScopeDefiner', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptionWithinComparableScopeDefiner', id: number, ordinal: number | null, value: string } | null }> }, ancestorScopeSnapshots: Array<{ __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string }>, savedInheritance: { __typename?: 'SavedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean } | null, validatedInheritances: Array<{ __typename?: 'ValidatedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, directChildrenIdsLimitedToInheritancesOfTarget: Array<number> }> }>, descendantScopeDifferences: Array<{ __typename?: 'DescendantScopeDifference', descendantScope: { __typename?: 'ScopeWithComparableScopeDefiners', id: number, comparableScopeDefiners: Array<{ __typename?: 'ComparableScopeDefinerWithScopeVariableAndOption', isScopeOptionIdExplicitlySelected: boolean, scopeVariable: { __typename?: 'ScopeVariableWithinComparableScopeDefiner', id: number, ordinal: number, name: string }, scopeOption: { __typename?: 'ScopeOptionWithinComparableScopeDefiner', id: number, ordinal: number | null, value: string } | null }> }, descendantScopeSnapshots: Array<{ __typename?: 'PrimitiveScopeSnapshotWithValidationDifference', id: number, scopeId: number, scopeVersion: string, createdAt: string, validatedDirectParentIds: Array<number>, savedInheritance: { __typename?: 'SavedSsInheritance', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, inheritedScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string } } | null, validatedInheritances: Array<{ __typename?: 'ValidatedSsInheritanceForDescendantSs', ordinal: number, ordinalWithinDirectInheritances: number, isSelf: boolean, inheritedScopeSnapshotId: number, isDirectInheritance: boolean, inheritedScopeSnapshot: { __typename?: 'PrimitiveScopeSnapshot', id: number, scopeId: number, scopeVersion: string, createdAt: string } }> }> }> }>, aggregateModifications: { __typename?: 'AggregateValidatedSsInheritanceModifications', deleteSsDirectInheritancesWhere: Array<{ __typename?: 'DeleteSsDirectInheritancesWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeId: { __typename?: 'EqualToIntExpression', _eq: number } }>, updateSsDirectInheritances: Array<{ __typename?: 'UpdateSsDirectInheritance', where: { __typename?: 'UpdateSsDirectInheritanceWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeId: { __typename?: 'EqualToIntExpression', _eq: number } }, _set: { __typename?: 'UpdateSsDirectInheritanceSet', directlyInheritedScopeSnapshotId: number, ordinal: number } }>, insertSsDirectInheritances: Array<{ __typename?: 'InsertSsDirectInheritance', scopeSnapshotId: number, directlyInheritedScopeId: number, directlyInheritedScopeSnapshotId: number, ordinal: number }>, deleteConflictingSsDirectInheritancesWhere: Array<{ __typename?: 'DeleteConflictingSsDirectInheritanceWhere', scopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number }, directlyInheritedScopeSnapshotId: { __typename?: 'EqualToIntExpression', _eq: number } }> } };

export const ScopeOptionFieldsForScopeVariablesPageFragmentDoc = gql`
    fragment scopeOptionFieldsForScopeVariablesPage on ScopeOptions {
  id
  scopeVariableId
  value
  scopeDefinersAggregate {
    aggregate {
      count(columns: scopeOptionId)
    }
  }
  scopeOptionTreeEdgeChildren {
    childScopeOptionId
    ordinal
  }
}
    `;
export const ScopeVariableFieldsForScopeVariablesPageFragmentDoc = gql`
    fragment scopeVariableFieldsForScopeVariablesPage on ScopeVariables {
  id
  ordinal
  name
  scopeOptionTreeEdgeTransitives(
    where: {isCanonicalRootPath: {_eq: true}}
    orderBy: {sortableTreeChain: ASC}
  ) {
    id
    descendantChain
    scopeVariableId
    isCanonicalRootPath
    scopeOptionId
    descendantScopeOption {
      ...scopeOptionFieldsForScopeVariablesPage
      descendantScopeOptionEdgeTransitives(
        distinctOn: [scopeOptionId, descendantScopeOptionId]
      ) {
        scopeOptionId
        descendantScopeOptionId
        descendantChain
        scopeOptionTreeEdge {
          ordinal
        }
      }
    }
    sortableScopeOptionTreeNodes {
      id
      scopeOptionTreeEdgeTransitive {
        id
        scopeOptionTreeEdgeId
      }
      sortableTreeChainOrdinal
      svOrdinal
      ordinalWithinParentIsNull
      ordinalWithinParent
      soValue
      soId
    }
    scopeOptionTreeEdge {
      id
      scopeOptionId
      childScopeOptionId
    }
  }
  scopeOptionsAggregate {
    aggregate {
      count
      max {
        ordinal
      }
    }
  }
  scopeOptions(orderBy: {ordinal: ASC}) {
    ...scopeOptionFieldsForScopeVariablesPage
  }
}
    ${ScopeOptionFieldsForScopeVariablesPageFragmentDoc}`;
export const RoleFieldsFragmentDoc = gql`
    fragment roleFields on Roles {
  id
  name
  flagEditPermission
  valueEditPermission
  userRolesAggregate {
    aggregate {
      count
    }
  }
  roleScopesAggregate {
    aggregate {
      count
    }
  }
}
    `;
export const UserRoleFieldsFragmentDoc = gql`
    fragment userRoleFields on UserRoles {
  id
  roleId
  userId
  role {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on Users {
  id
  name
  email
  userRoles {
    ...userRoleFields
  }
}
    ${UserRoleFieldsFragmentDoc}`;
export const FlagValueFieldsFragmentDoc = gql`
    fragment flagValueFields on FlagValues {
  id
  appliedInScopeSnapshotId
  value
  appliedInScopeSnapshot {
    id
    scopeId
    scopeVersion
    createdAt
  }
}
    `;
export const FlagValueFieldsWithAppliedInScopeSnapshotDetailsFragmentDoc = gql`
    fragment flagValueFieldsWithAppliedInScopeSnapshotDetails on FlagValues {
  ...flagValueFields
}
    ${FlagValueFieldsFragmentDoc}`;
export const ScopeVariableFieldsForScopeSnapshotSelectorFragmentDoc = gql`
    fragment scopeVariableFieldsForScopeSnapshotSelector on ScopeVariables {
  id
  ordinal
  name
  scopeOptionTreeEdgeTransitives(orderBy: {sortableTreeChain: ASC}) {
    descendantChain
    isCanonicalRootPath
    scopeOptionId
    descendantScopeOption {
      id
      scopeVariableId
      ordinal
      value
      ancestorScopeOptionEdgeTransitives(
        distinctOn: [scopeOptionId, descendantScopeOptionId]
      ) {
        scopeOptionId
        descendantScopeOptionId
      }
      descendantScopeOptionEdgeTransitives(
        distinctOn: [scopeOptionId, descendantScopeOptionId]
      ) {
        scopeOptionId
        descendantScopeOptionId
      }
    }
  }
}
    `;
export const PrimitiveScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc = gql`
    fragment primitiveScopeSnapshotFieldsForScopeSnapshotSelector on ScopeSnapshots {
  id
  scopeId
  scopeVersion
  createdAt
}
    `;
export const ScopeFieldsForStaticScopeSnapshotSelectorFragmentDoc = gql`
    fragment scopeFieldsForStaticScopeSnapshotSelector on Scopes {
  id
  comparableScopeDefiners {
    isScopeOptionIdExplicitlySelected
    scopeVariable {
      id
      ordinal
      name
    }
    scopeOption {
      id
      ordinal
      value
    }
  }
}
    `;
export const ScopeFieldsForScopeSnapshotSelectorFragmentDoc = gql`
    fragment scopeFieldsForScopeSnapshotSelector on Scopes {
  ...scopeFieldsForStaticScopeSnapshotSelector
  scopeSnapshots(orderBy: {scopeVersion: ASC}) {
    ...primitiveScopeSnapshotFieldsForScopeSnapshotSelector
  }
}
    ${ScopeFieldsForStaticScopeSnapshotSelectorFragmentDoc}
${PrimitiveScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;
export const ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc = gql`
    fragment scopeSnapshotFieldsForScopeSnapshotSelector on ScopeSnapshots {
  ...primitiveScopeSnapshotFieldsForScopeSnapshotSelector
  scope {
    ...scopeFieldsForScopeSnapshotSelector
  }
}
    ${PrimitiveScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}
${ScopeFieldsForScopeSnapshotSelectorFragmentDoc}`;
export const ScopeSnapshotFieldsForStaticScopeSnapshotSelectorFragmentDoc = gql`
    fragment scopeSnapshotFieldsForStaticScopeSnapshotSelector on ScopeSnapshots {
  ...primitiveScopeSnapshotFieldsForScopeSnapshotSelector
  scope {
    ...scopeFieldsForStaticScopeSnapshotSelector
  }
}
    ${PrimitiveScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}
${ScopeFieldsForStaticScopeSnapshotSelectorFragmentDoc}`;
export const ValidatedSsInheritanceModificationsFragmentDoc = gql`
    fragment validatedSsInheritanceModifications on ValidatedSsInheritanceModifications {
  validationsByTargetScopeSnapshots {
    targetScopeSnapshot {
      id
      scopeId
      scopeVersion
      createdAt
    }
    incompatibleFlagNodes {
      id
      propertyName
      arrayOrdinal
      definedInScopeSnapshotId
      scopeFlagNodeId
      type
      flagPath
      valuedFlagAsJsonExtract
    }
    incompatibleFlagValues {
      id
      value
      appliedInScopeSnapshotId
      flagNodeScopeSnapshotId
      scopeFlagNodeId
      flagPath
      valuedFlagAsJsonExtract
    }
    jsonConfigurationBeforeModifications
    jsonConfigurationAfterModifications
    conflictsByFlagPath {
      flagPath
      redundantBecause
      conflictingFlagNodeContexts {
        arrayOrdinal
        definedInScopeSnapshotId
        definedInScopeId
        definedInScopeVersion
        effectiveValue
        flagNodeId
        flagNodeType
        flagPath
        flagValueAppliedInScopeSnapshotId
        flagValueId
        propertyName
        targetScopeSnapshotId
        scopeFlagNodeId
        valuedFlagAsJsonExtract
        parentFlagNodeScopeSnapshotId
      }
    }
    ancestorScopeDifferences {
      ancestorScope {
        id
        comparableScopeDefiners {
          isScopeOptionIdExplicitlySelected
          scopeVariable {
            id
            ordinal
            name
          }
          scopeOption {
            id
            ordinal
            value
          }
        }
      }
      ancestorScopeSnapshots {
        id
        scopeId
        scopeVersion
        createdAt
      }
      savedInheritance {
        ordinal
        ordinalWithinDirectInheritances
        isSelf
        inheritedScopeSnapshotId
        isDirectInheritance
      }
      validatedInheritances {
        ordinal
        ordinalWithinDirectInheritances
        isSelf
        inheritedScopeSnapshotId
        isDirectInheritance
        directChildrenIdsLimitedToInheritancesOfTarget
      }
    }
    descendantScopeDifferences {
      descendantScope {
        id
        comparableScopeDefiners {
          isScopeOptionIdExplicitlySelected
          scopeVariable {
            id
            ordinal
            name
          }
          scopeOption {
            id
            ordinal
            value
          }
        }
      }
      descendantScopeSnapshots {
        id
        scopeId
        scopeVersion
        createdAt
        savedInheritance {
          ordinal
          ordinalWithinDirectInheritances
          isSelf
          inheritedScopeSnapshotId
          inheritedScopeSnapshot {
            id
            scopeId
            scopeVersion
            createdAt
          }
          isDirectInheritance
        }
        validatedInheritances {
          ordinal
          ordinalWithinDirectInheritances
          isSelf
          inheritedScopeSnapshotId
          inheritedScopeSnapshot {
            id
            scopeId
            scopeVersion
            createdAt
          }
          isDirectInheritance
        }
        validatedDirectParentIds
      }
    }
  }
  aggregateModifications {
    deleteSsDirectInheritancesWhere {
      scopeSnapshotId {
        _eq
      }
      directlyInheritedScopeId {
        _eq
      }
    }
    updateSsDirectInheritances {
      where {
        scopeSnapshotId {
          _eq
        }
        directlyInheritedScopeId {
          _eq
        }
      }
      _set {
        directlyInheritedScopeSnapshotId
        ordinal
      }
    }
    insertSsDirectInheritances {
      scopeSnapshotId
      directlyInheritedScopeId
      directlyInheritedScopeSnapshotId
      ordinal
    }
    deleteConflictingSsDirectInheritancesWhere {
      scopeSnapshotId {
        _eq
      }
      directlyInheritedScopeSnapshotId {
        _eq
      }
    }
  }
}
    `;
export const DeploymentsPageDocument = gql`
    query deploymentsPage {
  deployments(orderBy: {key: ASC}) {
    id
    key
    scopeSnapshot {
      ...scopeSnapshotFieldsForScopeSnapshotSelector
    }
  }
  scopeVariables(orderBy: {ordinal: ASC}) {
    ...scopeVariableFieldsForScopeSnapshotSelector
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}
${ScopeVariableFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeploymentsPageGQL extends Apollo.Query<DeploymentsPageQuery, DeploymentsPageQueryVariables> {
    document = DeploymentsPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDeploymentDocument = gql`
    mutation deleteDeployment($deploymentId: Int!) {
  deleteDeploymentsByPk(id: $deploymentId) {
    id
    key
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDeploymentGQL extends Apollo.Mutation<DeleteDeploymentMutation, DeleteDeploymentMutationVariables> {
    document = DeleteDeploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeploymentDocument = gql`
    mutation updateDeployment($id: Int!, $setFields: DeploymentsSetInput) {
  updateDeploymentsByPk(pkColumns: {id: $id}, _set: $setFields) {
    id
    key
    scopeSnapshot {
      ...scopeSnapshotFieldsForScopeSnapshotSelector
    }
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeploymentGQL extends Apollo.Mutation<UpdateDeploymentMutation, UpdateDeploymentMutationVariables> {
    document = UpdateDeploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertDeploymentDocument = gql`
    mutation insertDeployment($key: String!, $scopeId: Int!, $scopeVersion: String!) {
  insertDeploymentsOne(
    object: {key: $key, scopeId: $scopeId, scopeVersion: $scopeVersion}
  ) {
    id
    key
    scopeSnapshot {
      ...scopeSnapshotFieldsForScopeSnapshotSelector
    }
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertDeploymentGQL extends Apollo.Mutation<InsertDeploymentMutation, InsertDeploymentMutationVariables> {
    document = InsertDeploymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertFlagValueDocument = gql`
    mutation insertFlagValue($scopeFlagNodeId: Int!, $flagNodeScopeSnapshotId: Int!, $appliedInScopeSnapshotId: Int!, $value: jsonb) {
  insertFlagValuesOne(
    object: {scopeFlagNodeId: $scopeFlagNodeId, flagNodeScopeSnapshotId: $flagNodeScopeSnapshotId, appliedInScopeSnapshotId: $appliedInScopeSnapshotId, value: $value}
    onConflict: {constraint: flag_values_scope_flag_node_id_applied_in_scope_snapshot_id_key, updateColumns: value}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertFlagValueGQL extends Apollo.Mutation<InsertFlagValueMutation, InsertFlagValueMutationVariables> {
    document = InsertFlagValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFlagValueDocument = gql`
    mutation deleteFlagValue($scopeFlagNodeId: Int!, $flagNodeScopeSnapshotId: Int!, $appliedInScopeSnapshotId: Int!) {
  deleteFlagValues(
    where: {scopeFlagNodeId: {_eq: $scopeFlagNodeId}, appliedInScopeSnapshotId: {_eq: $appliedInScopeSnapshotId}, flagNodeScopeSnapshotId: {_eq: $flagNodeScopeSnapshotId}}
  ) {
    returning {
      id
    }
    affectedRows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFlagValueGQL extends Apollo.Mutation<DeleteFlagValueMutation, DeleteFlagValueMutationVariables> {
    document = DeleteFlagValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveFlagDocument = gql`
    mutation saveFlag($deleteFlagNodeIds: [Int!]! = [], $updateFlagNodes: [FlagNodesUpdates!]! = [], $insertFlagNodes: [FlagNodesInsertInput!]! = [], $compactArrayOrdinalsWithinScopeSnapshotId: Int!, $compactArrayOrdinalsForParentScopeFlagNodeIds: _int4!) {
  deleteFlagNodes(where: {id: {_in: $deleteFlagNodeIds}}) {
    returning {
      id
      propertyName
      arrayOrdinal
    }
  }
  updateFlagNodesMany(updates: $updateFlagNodes) {
    returning {
      id
      propertyName
      arrayOrdinal
    }
  }
  insertFlagNodes(objects: $insertFlagNodes) {
    returning {
      propertyName
      type
      arrayOrdinal
    }
  }
  compactFlagNodeArrayOrdinals(
    args: {defined_in_scope_snapshot_id: $compactArrayOrdinalsWithinScopeSnapshotId, parent_scope_flag_node_ids: $compactArrayOrdinalsForParentScopeFlagNodeIds}
  ) {
    id
    arrayOrdinal
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveFlagGQL extends Apollo.Mutation<SaveFlagMutation, SaveFlagMutationVariables> {
    document = SaveFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportOptionsDocument = gql`
    query importOptions {
  flagNodeImportOptions(orderBy: {ordinal: ASC}) {
    name
    description
  }
  flagValueImportOptions(orderBy: {ordinal: ASC}) {
    name
    description
  }
  arrayImportOptions(orderBy: {ordinal: ASC}) {
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportOptionsGQL extends Apollo.Query<ImportOptionsQuery, ImportOptionsQueryVariables> {
    document = ImportOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportConfigDocument = gql`
    mutation importConfig($scopeSnapshotId: Int!, $importConfig: jsonb!, $flagNodeImportOption: String!, $flagValueImportOption: String!, $arrayImportOption: String!) {
  importConfig(
    args: {scope_snapshot_id: $scopeSnapshotId, import_config: $importConfig, flag_node_import_option: $flagNodeImportOption, flag_value_import_option: $flagValueImportOption, array_import_option: $arrayImportOption}
  ) {
    flagNodeOperation
    flagValueOperation
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportConfigGQL extends Apollo.Mutation<ImportConfigMutation, ImportConfigMutationVariables> {
    document = ImportConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveParentConnectionsDocument = gql`
    mutation saveParentConnections($targetScopeSnapshotId: Int!, $deleteByParentScopeIds: [Int!]!, $updateParentConnections: [SsDirectInheritancesUpdates!]!, $insertParentConnections: [SsDirectInheritancesInsertInput!]!) {
  deleteSsDirectInheritances(
    where: {scopeSnapshotId: {_eq: $targetScopeSnapshotId}, directlyInheritedScopeId: {_in: $deleteByParentScopeIds}}
  ) {
    returning {
      id
    }
  }
  updateSsDirectInheritancesMany(updates: $updateParentConnections) {
    returning {
      id
    }
  }
  insertSsDirectInheritances(objects: $insertParentConnections) {
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveParentConnectionsGQL extends Apollo.Mutation<SaveParentConnectionsMutation, SaveParentConnectionsMutationVariables> {
    document = SaveParentConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeSnapshotDataForScopeSnapshotPageDocument = gql`
    query scopeSnapshotDataForScopeSnapshotPage($scopeSnapshotId: Int!) {
  scopeSnapshotsByPk(id: $scopeSnapshotId) {
    ...scopeSnapshotFieldsForScopeSnapshotSelector
    inheritances(orderBy: {ordinal: ASC}) {
      ordinal
      isDirectInheritance
      isSelf
      inheritedScopeSnapshotId
      ordinalWithinDirectInheritances
      inheritedScopeSnapshot {
        ...scopeSnapshotFieldsForStaticScopeSnapshotSelector
      }
    }
    descendantInheritances(
      where: {isSelf: {_eq: false}}
      orderBy: {isDirectInheritance: DESC, ordinal: ASC}
    ) {
      ordinal
      scopeSnapshotId
      isDirectInheritance
      scopeSnapshot {
        ...scopeSnapshotFieldsForStaticScopeSnapshotSelector
      }
    }
  }
  scopeVariables(orderBy: {ordinal: ASC}) {
    ...scopeVariableFieldsForScopeSnapshotSelector
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}
${ScopeSnapshotFieldsForStaticScopeSnapshotSelectorFragmentDoc}
${ScopeVariableFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeSnapshotDataForScopeSnapshotPageGQL extends Apollo.Query<ScopeSnapshotDataForScopeSnapshotPageQuery, ScopeSnapshotDataForScopeSnapshotPageQueryVariables> {
    document = ScopeSnapshotDataForScopeSnapshotPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlagsValuesDataDocument = gql`
    query flagsValuesData($scopeSnapshotId: Int!) {
  inheritedValuedFlagNodes(
    where: {targetScopeSnapshotId: {_eq: $scopeSnapshotId}}
    orderBy: {ordinalWithinIfns: ASC}
  ) {
    ivfnId: id
    flagNode {
      id
      propertyName
      arrayOrdinal
      scopeFlagNodeId
      definedInScopeSnapshotId
      parentScopeFlagNodeId
      type
      canonicalValuedFlagNode {
        id
        propertyNameOrArrayIndex
        arrayIndex
      }
      parent {
        id
      }
      scopeFlagNode {
        id
        flagNodes(orderBy: {scopeSnapshot: {scopeVersion: ASC}}) {
          id
          propertyName
          scopeSnapshot {
            id
            scopeVersion
          }
          canonicalValuedFlagNode {
            id
            propertyNameOrArrayIndex
          }
        }
        flagValues {
          ...flagValueFields
        }
      }
      childrenAggregate {
        aggregate {
          count
        }
      }
      flagValues {
        ...flagValueFields
      }
      flagValuesAggregate {
        aggregate {
          count
        }
      }
    }
    flagValue {
      ...flagValueFields
    }
  }
}
    ${FlagValueFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FlagsValuesDataGQL extends Apollo.Query<FlagsValuesDataQuery, FlagsValuesDataQueryVariables> {
    document = FlagsValuesDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfigurationForScopeSnapshotPageDocument = gql`
    query configurationForScopeSnapshotPage($scopeSnapshotId: Int!) {
  configuration(args: {scope_snapshot_id: $scopeSnapshotId}) {
    scopeSnapshotId
    jsonConfiguration
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfigurationForScopeSnapshotPageGQL extends Apollo.Query<ConfigurationForScopeSnapshotPageQuery, ConfigurationForScopeSnapshotPageQueryVariables> {
    document = ConfigurationForScopeSnapshotPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeSnapshotDataForCherryPickReplicationDocument = gql`
    query scopeSnapshotDataForCherryPickReplication($replicateToScopeSnapshotId: Int!) {
  inheritedValuedFlagNodes(
    where: {targetScopeSnapshotId: {_eq: $replicateToScopeSnapshotId}}
    orderBy: {ordinalWithinIfns: ASC}
  ) {
    id
    flagJsonpathText
    propertyNameOrArrayIndex
    flagNode {
      id
      propertyName
      scopeFlagNodeId
      parentScopeFlagNodeId
      type
    }
    flagValue {
      id
      value
      flagNodeScopeSnapshotId
      appliedInScopeSnapshotId
      scopeFlagNodeId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeSnapshotDataForCherryPickReplicationGQL extends Apollo.Query<ScopeSnapshotDataForCherryPickReplicationQuery, ScopeSnapshotDataForCherryPickReplicationQueryVariables> {
    document = ScopeSnapshotDataForCherryPickReplicationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitialDataForScopeSnapshotSelectorDocument = gql`
    query initialDataForScopeSnapshotSelector {
  scopeVariables(orderBy: {ordinal: ASC}) {
    ...scopeVariableFieldsForScopeSnapshotSelector
  }
  scopeSnapshotsAggregate {
    aggregate {
      count
    }
  }
}
    ${ScopeVariableFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InitialDataForScopeSnapshotSelectorGQL extends Apollo.Query<InitialDataForScopeSnapshotSelectorQuery, InitialDataForScopeSnapshotSelectorQueryVariables> {
    document = InitialDataForScopeSnapshotSelectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScopeSnapshotDocument = gql`
    mutation deleteScopeSnapshot($id: Int!) {
  deleteFlagValues(where: {appliedInScopeSnapshotId: {_eq: $id}}) {
    returning {
      id
    }
  }
  deleteFlagNodes(where: {definedInScopeSnapshotId: {_eq: $id}}) {
    returning {
      id
    }
  }
  deleteScopeSnapshotsByPk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScopeSnapshotGQL extends Apollo.Mutation<DeleteScopeSnapshotMutation, DeleteScopeSnapshotMutationVariables> {
    document = DeleteScopeSnapshotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScopeAndSnapshotDocument = gql`
    mutation createScopeAndSnapshot($scopeDefiners: [ScopeDefinersInsertInput!]!, $scopeVersion: String!) {
  insertScopeSnapshotsOne(
    object: {scopeVersion: $scopeVersion, scope: {data: {scopeDefiners: {data: $scopeDefiners}}}}
  ) {
    id
    scopeId
    scopeVersion
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScopeAndSnapshotGQL extends Apollo.Mutation<CreateScopeAndSnapshotMutation, CreateScopeAndSnapshotMutationVariables> {
    document = CreateScopeAndSnapshotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScopeSnapshotDocument = gql`
    mutation createScopeSnapshot($scopeId: Int!, $scopeVersion: String!) {
  insertScopeSnapshotsOne(
    object: {scopeId: $scopeId, scopeVersion: $scopeVersion}
  ) {
    id
    scopeId
    scopeVersion
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScopeSnapshotGQL extends Apollo.Mutation<CreateScopeSnapshotMutation, CreateScopeSnapshotMutationVariables> {
    document = CreateScopeSnapshotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameScopeVersionDocument = gql`
    mutation renameScopeVersion($scopeSnapshotId: Int!, $newScopeVersion: String!) {
  updateScopeSnapshotsByPk(
    pkColumns: {id: $scopeSnapshotId}
    _set: {scopeVersion: $newScopeVersion}
  ) {
    id
    scopeId
    scopeVersion
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameScopeVersionGQL extends Apollo.Mutation<RenameScopeVersionMutation, RenameScopeVersionMutationVariables> {
    document = RenameScopeVersionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeByOptionIdsDocument = gql`
    query scopeByOptionIds($scopeOptionIds: jsonb!) {
  allComparableScopeDefinitions(
    where: {scopeIdentifyingDefinitionJsonb: {_containedIn: $scopeOptionIds, _contains: $scopeOptionIds}}
  ) {
    scopeId
    scope {
      ...scopeFieldsForScopeSnapshotSelector
    }
  }
}
    ${ScopeFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeByOptionIdsGQL extends Apollo.Query<ScopeByOptionIdsQuery, ScopeByOptionIdsQueryVariables> {
    document = ScopeByOptionIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeByOptionIdsAndScopeUpdateValidatablesDocument = gql`
    query scopeByOptionIdsAndScopeUpdateValidatables($scopeOptionIds: jsonb!) {
  allComparableScopeDefinitions(
    where: {scopeIdentifyingDefinitionJsonb: {_containedIn: $scopeOptionIds, _contains: $scopeOptionIds}}
  ) {
    scopeId
    scope {
      ...scopeFieldsForScopeSnapshotSelector
    }
  }
  allValidatableScopeContainments {
    scopeId
    containableScopeDefinition
    scopeSnapshotId
    directlyInheritedScopeId
    containableDirectlyInheritedScopeDefinition
    directlyInheritedScopeSnapshotId
    scopeIdentifyingDefinition
    directlyInheritedScopeIdentifyingDefinition
    scopeSnapshot {
      scopeVersion
      createdAt
    }
    directlyInheritedScopeSnapshot {
      scopeVersion
      createdAt
    }
  }
}
    ${ScopeFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeByOptionIdsAndScopeUpdateValidatablesGQL extends Apollo.Query<ScopeByOptionIdsAndScopeUpdateValidatablesQuery, ScopeByOptionIdsAndScopeUpdateValidatablesQueryVariables> {
    document = ScopeByOptionIdsAndScopeUpdateValidatablesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReplicateScopeSnapshotAsNewVersionDocument = gql`
    mutation replicateScopeSnapshotAsNewVersion($replicateScopeSnapshotId: Int!, $newDirectlyInheritedScopeSnapshotIds: [Int!]!, $newScopeVersion: String!) {
  replicateScopeSnapshot(
    replicateScopeSnapshotId: $replicateScopeSnapshotId
    newDirectlyInheritedScopeSnapshotIds: $newDirectlyInheritedScopeSnapshotIds
    newScopeVersion: $newScopeVersion
  ) {
    id
    scopeId
    scopeVersion
    createdAt
    scopeSnapshot {
      ...scopeSnapshotFieldsForScopeSnapshotSelector
    }
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReplicateScopeSnapshotAsNewVersionGQL extends Apollo.Mutation<ReplicateScopeSnapshotAsNewVersionMutation, ReplicateScopeSnapshotAsNewVersionMutationVariables> {
    document = ReplicateScopeSnapshotAsNewVersionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReplicateFlagsAndValuesDocument = gql`
    mutation replicateFlagsAndValues($replicateFromScopeSnapshotId: Int!, $replicateFlagsOfScopeFlagNodeIds: [Int!]!, $replicateValuesOfScopeFlagNodeIds: [Int!]!, $destinationScopeSnapshotId: Int!) {
  replicateFlagsAndValues(
    replicateFromScopeSnapshotId: $replicateFromScopeSnapshotId
    replicateFlagsOfScopeFlagNodeIds: $replicateFlagsOfScopeFlagNodeIds
    replicateValuesOfScopeFlagNodeIds: $replicateValuesOfScopeFlagNodeIds
    destinationScopeSnapshotId: $destinationScopeSnapshotId
  ) {
    replicatedFlagsCount
    replicatedValuesCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReplicateFlagsAndValuesGQL extends Apollo.Mutation<ReplicateFlagsAndValuesMutation, ReplicateFlagsAndValuesMutationVariables> {
    document = ReplicateFlagsAndValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSnapshotWithNewScopeDocument = gql`
    mutation createSnapshotWithNewScope($scopeDefiners: [ScopeDefinersInsertInput!]!, $scopeVersion: String!, $directInheritances: [SsDirectInheritancesInsertInput!]!) {
  insertScopeSnapshotsOne(
    object: {scopeVersion: $scopeVersion, scope: {data: {scopeDefiners: {data: $scopeDefiners}}}, directInheritances: {data: $directInheritances}}
  ) {
    ...scopeSnapshotFieldsForScopeSnapshotSelector
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSnapshotWithNewScopeGQL extends Apollo.Mutation<CreateSnapshotWithNewScopeMutation, CreateSnapshotWithNewScopeMutationVariables> {
    document = CreateSnapshotWithNewScopeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSnapshotInExistingScopeDocument = gql`
    mutation createSnapshotInExistingScope($scopeId: Int!, $scopeVersion: String!, $directInheritances: [SsDirectInheritancesInsertInput!]!) {
  insertScopeSnapshotsOne(
    object: {scopeId: $scopeId, scopeVersion: $scopeVersion, directInheritances: {data: $directInheritances}}
  ) {
    ...scopeSnapshotFieldsForScopeSnapshotSelector
  }
}
    ${ScopeSnapshotFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSnapshotInExistingScopeGQL extends Apollo.Mutation<CreateSnapshotInExistingScopeMutation, CreateSnapshotInExistingScopeMutationVariables> {
    document = CreateSnapshotInExistingScopeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScopeDefinitionDocument = gql`
    mutation updateScopeDefinition($scopeId: Int!, $replaceWithScopeDefiners: [ScopeDefinersInsertInput!]!) {
  deleteScopeDefiners(where: {scopeId: {_eq: $scopeId}}) {
    returning {
      id
      scope {
        ...scopeFieldsForScopeSnapshotSelector
      }
    }
  }
  insertScopeDefiners(objects: $replaceWithScopeDefiners) {
    returning {
      id
      scope {
        ...scopeFieldsForScopeSnapshotSelector
      }
    }
  }
}
    ${ScopeFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScopeDefinitionGQL extends Apollo.Mutation<UpdateScopeDefinitionMutation, UpdateScopeDefinitionMutationVariables> {
    document = UpdateScopeDefinitionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HistoryPageDocument = gql`
    query historyPage($offset: Int!, $limit: Int!) {
  logs(offset: $offset, limit: $limit, orderBy: {actionTstampTx: DESC}) {
    id
    actionTstampTx
    action
    changedFields
    clientAddr
    rowData
    tableName
    tenantId
    userId
    user {
      id
      name
      email
    }
    transactionId
  }
  logsAggregate {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HistoryPageGQL extends Apollo.Query<HistoryPageQuery, HistoryPageQueryVariables> {
    document = HistoryPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeVariablesCountDocument = gql`
    query scopeVariablesCount {
  scopeVariablesAggregate {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeVariablesCountGQL extends Apollo.Query<ScopeVariablesCountQuery, ScopeVariablesCountQueryVariables> {
    document = ScopeVariablesCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopeVariablesPageDataDocument = gql`
    query scopeVariablesPageData {
  scopeVariables(orderBy: {ordinal: ASC}) {
    ...scopeVariableFieldsForScopeVariablesPage
  }
  scopeVariablesAggregate {
    aggregate {
      count
      max {
        ordinal
      }
    }
  }
  sortableScopeOptionTreeNodeAttributeOrdinals {
    svOrdinal
    ordinalWithinParentIsNull
    ordinalWithinParent
    soValue
    soId
  }
}
    ${ScopeVariableFieldsForScopeVariablesPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopeVariablesPageDataGQL extends Apollo.Query<ScopeVariablesPageDataQuery, ScopeVariablesPageDataQueryVariables> {
    document = ScopeVariablesPageDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertChildScopeOptionDocument = gql`
    mutation insertChildScopeOption($value: String!, $scopeVariableId: Int!, $parentScopeOptionId: Int!) {
  insertScopeOptionTreeEdgesOne(
    object: {scopeOptionId: $parentScopeOptionId, childScopeOption: {data: {value: $value, scopeVariableId: $scopeVariableId}}}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertChildScopeOptionGQL extends Apollo.Mutation<InsertChildScopeOptionMutation, InsertChildScopeOptionMutationVariables> {
    document = InsertChildScopeOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertScopeVariableDocument = gql`
    mutation insertScopeVariable($name: String!, $ordinal: Int!) {
  insertScopeVariablesOne(object: {name: $name, ordinal: $ordinal}) {
    ...scopeVariableFieldsForScopeVariablesPage
  }
}
    ${ScopeVariableFieldsForScopeVariablesPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertScopeVariableGQL extends Apollo.Mutation<InsertScopeVariableMutation, InsertScopeVariableMutationVariables> {
    document = InsertScopeVariableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScopeVariableDocument = gql`
    mutation updateScopeVariable($id: Int!, $name: String!) {
  updateScopeVariablesByPk(pkColumns: {id: $id}, _set: {name: $name}) {
    ...scopeVariableFieldsForScopeVariablesPage
  }
}
    ${ScopeVariableFieldsForScopeVariablesPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScopeVariableGQL extends Apollo.Mutation<UpdateScopeVariableMutation, UpdateScopeVariableMutationVariables> {
    document = UpdateScopeVariableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScopeVariableDocument = gql`
    mutation deleteScopeVariable($id: Int!) {
  deleteScopeVariablesByPk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScopeVariableGQL extends Apollo.Mutation<DeleteScopeVariableMutation, DeleteScopeVariableMutationVariables> {
    document = DeleteScopeVariableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertScopeOptionDocument = gql`
    mutation insertScopeOption($value: String!, $scopeVariableId: Int!) {
  insertScopeOptionsOne(
    object: {value: $value, scopeVariableId: $scopeVariableId}
  ) {
    ...scopeOptionFieldsForScopeVariablesPage
  }
}
    ${ScopeOptionFieldsForScopeVariablesPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertScopeOptionGQL extends Apollo.Mutation<InsertScopeOptionMutation, InsertScopeOptionMutationVariables> {
    document = InsertScopeOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScopeOptionDocument = gql`
    mutation updateScopeOption($id: Int!, $value: String!, $completeListOfChildTreeEdges: jsonb!, $originalChildrenOnlyForConcurrencyCheck: jsonb!, $preventScopeTargetReduction: Boolean!) {
  updateScopeOptionsByPk(pkColumns: {id: $id}, _set: {value: $value}) {
    ...scopeOptionFieldsForScopeVariablesPage
  }
  setScopeOptionChildren(
    args: {parent_scope_option_id: $id, complete_list_of_child_tree_edges: $completeListOfChildTreeEdges, original_children_only_for_concurrency_check: $originalChildrenOnlyForConcurrencyCheck, prevent_scope_target_reduction: $preventScopeTargetReduction}
  ) {
    parentScopeOptionId
    parentScopeOptionTreeEdgesBefore
    parentScopeOptionTreeEdgesAfter
    reconciledScopes
    scopeVariableId
  }
}
    ${ScopeOptionFieldsForScopeVariablesPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScopeOptionGQL extends Apollo.Mutation<UpdateScopeOptionMutation, UpdateScopeOptionMutationVariables> {
    document = UpdateScopeOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScopeOptionDocument = gql`
    mutation deleteScopeOption($id: Int!) {
  deleteScopeOptionTreeEdges(where: {childScopeOptionId: {_eq: $id}}) {
    affectedRows
  }
  deleteScopeOptionsByPk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScopeOptionGQL extends Apollo.Mutation<DeleteScopeOptionMutation, DeleteScopeOptionMutationVariables> {
    document = DeleteScopeOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScopeVariableAndOptionOrdinalsDocument = gql`
    mutation updateScopeVariableAndOptionOrdinals($scopeVariableOrdinals: [ScopeVariablesUpdates!]!, $scopeOptionOrdinals: [ScopeOptionsUpdates!]!, $scopeOptionTreeEdgeOrdinals: [ScopeOptionTreeEdgesUpdates!]!) {
  updateScopeVariablesMany(updates: $scopeVariableOrdinals) {
    returning {
      id
      ordinal
      name
    }
  }
  updateScopeOptionsMany(updates: $scopeOptionOrdinals) {
    returning {
      id
      scopeVariableId
      value
      ordinal
    }
  }
  updateScopeOptionTreeEdgesMany(updates: $scopeOptionTreeEdgeOrdinals) {
    returning {
      id
      scopeOptionId
      childScopeOptionId
      ordinal
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScopeVariableAndOptionOrdinalsGQL extends Apollo.Mutation<UpdateScopeVariableAndOptionOrdinalsMutation, UpdateScopeVariableAndOptionOrdinalsMutationVariables> {
    document = UpdateScopeVariableAndOptionOrdinalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScopesPageDocument = gql`
    query scopesPage {
  scopes(orderBy: {comparableScopeDefinition: {sortableScopeDefinition: DESC}}) {
    ...scopeFieldsForScopeSnapshotSelector
    deployments(orderBy: {key: ASC, scopeVersion: ASC}) {
      id
      key
      scopeVersion
    }
  }
  scopeVariables(orderBy: {ordinal: ASC}) {
    ...scopeVariableFieldsForScopeSnapshotSelector
  }
}
    ${ScopeFieldsForScopeSnapshotSelectorFragmentDoc}
${ScopeVariableFieldsForScopeSnapshotSelectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScopesPageGQL extends Apollo.Query<ScopesPageQuery, ScopesPageQueryVariables> {
    document = ScopesPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateOrSaveInheritanceModificationsDocument = gql`
    query validateOrSaveInheritanceModifications($modifications: [OneSsInheritanceModifications!]!, $validateOnly: Boolean!) {
  validateOrSaveSsInheritanceModifications(
    modifications: $modifications
    validateOnly: $validateOnly
  ) {
    ...validatedSsInheritanceModifications
  }
}
    ${ValidatedSsInheritanceModificationsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateOrSaveInheritanceModificationsGQL extends Apollo.Query<ValidateOrSaveInheritanceModificationsQuery, ValidateOrSaveInheritanceModificationsQueryVariables> {
    document = ValidateOrSaveInheritanceModificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScopeDocument = gql`
    mutation deleteScope($id: Int!) {
  deleteScopesByPk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScopeGQL extends Apollo.Mutation<DeleteScopeMutation, DeleteScopeMutationVariables> {
    document = DeleteScopeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesPageDataDocument = gql`
    query rolesPageData {
  roles(orderBy: {name: ASC}) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesPageDataGQL extends Apollo.Query<RolesPageDataQuery, RolesPageDataQueryVariables> {
    document = RolesPageDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertRoleDocument = gql`
    mutation insertRole($name: String!) {
  insertRolesOne(object: {name: $name}) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertRoleGQL extends Apollo.Mutation<InsertRoleMutation, InsertRoleMutationVariables> {
    document = InsertRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoleNameAndPermissionsDocument = gql`
    mutation updateRoleNameAndPermissions($roleId: Int!, $name: String!, $flagEditPermission: Boolean!, $valueEditPermission: Boolean!) {
  updateRolesByPk(
    pkColumns: {id: $roleId}
    _set: {name: $name, flagEditPermission: $flagEditPermission, valueEditPermission: $valueEditPermission}
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoleNameAndPermissionsGQL extends Apollo.Mutation<UpdateRoleNameAndPermissionsMutation, UpdateRoleNameAndPermissionsMutationVariables> {
    document = UpdateRoleNameAndPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleId: Int!) {
  deleteRolesByPk(id: $roleId) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRoleGQL extends Apollo.Mutation<DeleteRoleMutation, DeleteRoleMutationVariables> {
    document = DeleteRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserWithRolesDocument = gql`
    query userWithRoles($userId: String!) {
  usersByPk(id: $userId) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserWithRolesGQL extends Apollo.Query<UserWithRolesQuery, UserWithRolesQueryVariables> {
    document = UserWithRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersAndRolesDocument = gql`
    query usersAndRoles {
  users {
    ...userFields
  }
  roles(orderBy: {name: ASC}) {
    ...roleFields
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersAndRolesGQL extends Apollo.Query<UsersAndRolesQuery, UsersAndRolesQueryVariables> {
    document = UsersAndRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertAndDeleteUserRolesDocument = gql`
    mutation insertAndDeleteUserRoles($insertUserRoles: [UserRolesInsertInput!] = [], $deleteUserRoleIds: [Int!] = []) {
  insertUserRoles(objects: $insertUserRoles) {
    returning {
      ...userRoleFields
    }
  }
  deleteUserRoles(where: {id: {_in: $deleteUserRoleIds}}) {
    returning {
      ...userRoleFields
    }
  }
}
    ${UserRoleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertAndDeleteUserRolesGQL extends Apollo.Mutation<InsertAndDeleteUserRolesMutation, InsertAndDeleteUserRolesMutationVariables> {
    document = InsertAndDeleteUserRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }